export default {
  about_page: {
    aim: "בוויזה נט, אנו שואפים:",
    aim_1: "לפשט ולהנגיש הוצאת ויזות אלקטרוניות",
    aim_2: "לדאוג לאמינות ואבטחה ברמה הגבוהה ביותר",
    aim_3: "להקל כמה שיותר ולהבטיח שביעות רצון מלאה שלכם",
    choose: "למה כדאי להיעזר בנו?",
    company_name: "חברת eVisanet בע\"מ",
    connect: "דברו איתנו",
    contact_us: "יש לכם שאלות או שאתם זקוקים לעזרה? צרו איתנו קשר בדרכים הבאות:",
    customer_support_1: "סיוע 24/7 זמין בצ'אט, במייל ובטלפון.",
    customer_support_2: "תמיכה רב-לשונית לקהל לקוחותינו הגלובלי.",
    customer_support_title: "שירות לקוחות ללא תחרות",
    experience: "הניסיון שלנו עם עולם התיירות והמנהלה השגרירותית בעולם הביא אותנו למסקנה שאין דרך קלה, מוגנת ומשתלמת להוציא ויזה למדינה זרה, במיוחד לא עבור ישראלים.<br><strong>לכן הקמנו את אתר ויזה.נט {domain} - באתרנו נעזור לכם להנפיק ויזות אלקטרוניות למגוון מדינות, בלי לצאת מהבית או לבקר בשגירות, במחירים הזולים בארץ</strong>!",
    fast_and_secure_1: "הגישו בקשה מהבית – ללא צורך בביקורים בשגרירות.",
    fast_and_secure_2: "ויזות שאושרו על ידי הממשלה נשלחות ישירות לתיבת המייל שלכם.",
    fast_and_secure_title: "שירות מהיר ומאובטח",
    follow_us: "עקבו אחרינו",
    founded: "הקמנו את אתר ויזה.נט במטרה לתת מענה מקצועי, מהיר, בטוח וזול לבעיה המוכרת של הנפקת ויזה למדינה זרה. ",
    global_presence: "הנוכחות הגלובלית שלנו:",
    img_checkmark_shield: "אייקון: סימן וי (✓) ירוק בתוך סמל מגן",
    img_doc_with_checkmark: "אייקון: מסמך עם סימן וי (✓) ירוק",
    img_fast_online_service: "אייקון: רקטה מהירה יוצאת מאייקון מחשב נייד",
    img_gem: "אייקון: אבן חן כחולה",
    img_globe: "אייקון: גלובוס",
    img_magnifying_glass: "אייקון: זכוכית מגדלת מעל אייקון מסמך",
    img_man_at_table: "אייקון: איש מתוסכל יושב ליד שולחן",
    img_rocking_chair_with_cat_and_laptop: "אייקון: כיסא נדנדה עם חתול ואיור תלת-ממדי של מחשב נייד על שולחן",
    img_support_headphones: "אייקון: אוזניות תמיכה עם סמל כתר ירוק",
    legal: "מידע משפטי",
    licensed: "Visanet הינה חברה בעלת רישיון מלא ומוסמכת ל:",
    location: "מיקום",
    meta_desc: "הקמנו את אתר ויזה.נט במטרה לתת מענה מהיר, בטוח וזול להנפקת אשרות כניסה לחו\"ל - אנו נעזור לכם לקבל ויזות אלקטרוניות למגוון מדינות, בלי לבקר בשגרירות ובמחיר זול",
    operate_body: "לא רק בישראל - ויזה נט מסייעת למטיילים ברחבי העולם. אנחנו מוציאים ויזות ו-ETA לארצות הברית, וייטנאם, קנדה, הודו ועוד.",
    operate_title: "עוד סניפים שלנו",
    our_mission: "המשימה שלנו",
    our_story_1: "ויזה נט התחילה מחלום פשוט: להפוך את הוצאת הוויזה לחוויה קלה ונעימה. מאז, צמחנו והפכנו לחברה מובילה, שמסייעת למטיילים מכל העולם לקבל ויזות אלקטרוניות במהירות, בבטחה ובמחיר הוגן.",
    our_story_2: "אנחנו עובדים ישירות מול רשויות ההגירה כדי לוודא שאנחנו עומדים בכל הנהלים, וכדי לספק לכם מסמכי נסיעה רשמיים ומאושרים על ידי הממשלה. השקיפות והדאגה שלנו ללקוחות הפכו אותנו לשם מוכר ואמין בעולם התיירות הישראלי.",
    our_story_title: "הסיפור שלנו",
    registered: "רשומה בבריטניה ופועלת באישור ממשלתי לפעילות גלובלית.",
    successfully_processed: "מאז הקמתנו, הוצאנו בהצלחה <span class='text-primary'>מאות אלפי ויזות</span>, ועשינו חיים קלים להמוני מטיילים.",
    title: "אודות חברת ויזהנט ישראל: חברה להנפקת ויזות • Visanet – ויזה.נט",
    trust_1: "ניסיון מצטבר של {yearsActive} שנים בהוצאת ויזות.",
    trust_2: "מאות אלפי בקשות שאושרו בהצלחה ברחבי העולם.",
    trust_title: "ניסיון ומוניטין שאפשר לסמוך עליהם"
  },
  about_us: "עלינו",
  academic: "אקדמית",
  accompanying_children: {
    add: "הוסף ילד מתלווה",
    country_of_birth: "ארץ לידתו של הילד",
    dob: "תאריך הלידה של הילד",
    index: "ילד # {n}",
    label: "מידע ליווי ילדים",
    name: "שמו המלא של הילד"
  },
  according_to_passport: "על פי הדרכון",
  aerial_only: "הויזה תקפה לכניסה <strong> אווירית (טיסה) בלבד</strong>.",
  agree_terms: "אנו מסכימים ל<a href=\"/terms\" target=\"_blank\">תנאי השימוש</a> באתר.",
  airport: "שדה תעופה",
  all_vaccinated: "כל האנשים באפליקציה חוסנו נגד COVID",
  and_connector: "ו",
  applicant: "נוסע",
  applicant_info: {
    family: "משפחה",
    occupation: "עיסוק",
    passport: "דרכון",
    pastTravels: "ביקורים קודמים",
    personal: "מידע אישי"
  },
  applicant_photos: {
    address_proof: "הוכחת כתובת",
    address_proof_desc: "מסמך שמוכיח את כתובתך (כמו חשבון שירות, הצהרת בנק, רישיון נהיגה וכו ')",
    address_proof_upload_hint: "העלה מסמך שמוכיח את כתובתך (חשבון שירות, הצהרת בנק, רישיון נהיגה וכו ')",
    bank: "הצהרת בנק",
    bank_desc: "הצהרת בנק אישית עם סכום מינימלי של 2000$ (או שווה ערך) משלושת החודשים האחרונים (כולל שם, תאריך ויתרת חשבון)",
    bank_upload_hint: "העלה הצהרת בנק אישית עם סכום מינימלי של $2000 (או שווה ערך) משלושת החודשים האחרונים",
    booking: "הזמנת מלון",
    booking_desc: "עותק של הזמנת המלון שלך, או עותק של תדפיס קורא תעודות הזהות של המארח שלך",
    booking_upload_hint: "העלה עותק של הזמנת המלון שלך או עותק של תדפיס קורא תעודות הזהות של המארח שלך",
    card: "כרטיס ביקור",
    card_desc: "כרטיס ביקור עם שמך, עמדתך, שם העסק, הכתובת ופרטי הקשר שלך כתובים עליו.",
    card_upload_hint: "מסמך עם שמך, שם העסק, המיקום, הכתובת ואמצעי הקשר שלך",
    face: "תמונת פנים",
    face_desc: "תמונה ברורה ועדכנית של הפנים, עם רקע לבן או בהיר (בדומה לתמונת פספורט).",
    face_upload_hint: "תמונה ברורה של הפנים שלך עם רקע בהיר (כמו סלפי)",
    invitation: "מכתב הזמנה",
    invitation_desc: "מכתב הזמנה עם שמך, עמדתך, סיבת הביקור, הכתובת ופרטי הקשר שלך כתובים עליו.",
    invitation_upload_hint: "מכתב הזמנה עם שמך, עמדתך, סיבת הביקור, הכתובת ופרטי הקשר שלך.",
    occupation: "הוכחת עיסוק",
    occupation_desc: "מסמך המוכיח את עיסוקך, כמו רישיון עסק, חוזה עבודה, הצהרת פנסיה, כרטיס סטודנט, תעודת פרישה וכו '.",
    occupation_upload_hint: "העלה מסמך עיסוק (רישיון עסק, חוזה עבודה, הצהרת פנסיה, כרטיס סטודנט, תעודת פרישה וכו ')",
    passport: "תמונת דרכון",
    passport_desc: "תצלום ברור וקריא של דף הפרטים של הדרכון שלך.",
    passport_upload_hint: "תמונה ברורה של דף הנתונים של הדרכון שלך",
    return_ticket: "כרטיס חזרה",
    return_ticket_desc: "עותק של הזמנת הטיסה חזרה לכרטיס",
    return_ticket_upload_hint: "העלה עותק של הזמנת הטיסה שלך לכרטיס חזרה",
    travel_ticket: "הזמנת נסיעות",
    travel_ticket_desc: "עותק של הזמנת הנסיעה שלך",
    travel_ticket_upload_hint: "העלה את הזמנת הנסיעות שלך"
  },
  application_id: "קוד הזמנה",
  application_received: "קיבלנו את בקשת הוויזה האלקטרונית שלך",
  apply_coupon: "הפעל קופון",
  assumed_passport_expiry: "הערכנו אוטומטית את תאריך התפוגה של הדרכון שלך",
  authority: "סמכות - ממונה דרכונים",
  autocompleted: "השלמה אוטומטית",
  back_to_form_bahrain: "טופס ויזה",
  back_to_form_cambodia: "טופס ויזה",
  back_to_form_canada: "טופס eTA",
  back_to_form_india: "טופס ויזה",
  back_to_form_indonesia: "טופס ויזה",
  back_to_form_israel: "טופס ETA-IL",
  back_to_form_korea: "טופס K-ETA",
  back_to_form_morocco: "טופס ויזה",
  back_to_form_new_zealand: "טופס NZeta",
  back_to_form_saudi_arabia: "טופס ויזה",
  back_to_form_schengen: "טופס ויזה",
  back_to_form_sri_lanka: "טופס ויזה",
  back_to_form_thailand: "טופס ויזה",
  back_to_form_togo: "טופס ויזה",
  back_to_form_uk: "טופס eTA",
  back_to_form_usa: "טופס ESTA",
  back_to_form_vietnam: "טופס ויזה",
  bahrain: "בחריין",
  bahrain_evisa: "ויזה אלקטרונית בחריין",
  bahrain_page: {
    meta_desc: "הגש בקשה לויזה אלקטרונית לבחריין באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לבחריין - יישום מקוון קל Visanet {currentYear} {'|'}"
  },
  bill_payment: "תשלום על ידי חשבון",
  birth_city: "עיר לידה",
  birth_country: "ארץ לידה",
  birth_date: "תאריך לידה",
  blog: {
    author: "כותב",
    blog: "בלוג",
    categories: "קטגוריות",
    description: "חדשות, מדריכים, עדכונים ומידע חשוב אודות ויזות אלקטרוניות ואשרות כניסה עבור מטיילים ישראלים בחו\"ל.",
    find_articles: "חפש מאמרים",
    header: "בלוג ויזה.נט — למטייל הישראלי בחו\"ל",
    hero_img: "אדם קורא עיתון ויושב על כיסא חוף",
    meta_desc: "חדשות, מדריכים ועדכונים בנושאי ויזות ואשרות כניסה עבור ישראלים ותיירים הטסים לחו”ל - מידע עדכני {currentYear} אודות הנפקת ויזות להודו, ארה”ב, אנגליה, מרוקו, ויאטנם וקנדה",
    overview_img: "איור עיתון",
    overview_title: "חדשות אחרונות",
    published_on: "פורסם ב:",
    read_more: "המשך קריאה",
    recent: "מאמרים אחרונים",
    search: "חיפוש",
    subheader: "מידע עדכני בנושאי תיירות, ויזות אלקטרוניות ואשרות כניסה למטייל הישראלי למגוון יעדים: הודו, ארה”ב, אנגליה, מרוקו, ויאטנם, קנדה ועוד.",
    table_of_contents: "תוכן העניינים",
    title: "בלוג ויזה.נט: מידע ועדכונים אודות ויזות אלקטרוניות למטייל הישראלי בחו”ל",
    updated_on: "עודכן בתאריך:",
    written_by: "נכתב על ידי"
  },
  brand: {
    name: "ויזה נט"
  },
  business_address: "כתובת עסק",
  business_details: "פרטי עסק",
  business_name: "שם העסק",
  business_name_hint: "שם העסק",
  cambodia: "קמבודיה",
  cambodia_evisa: "ויזה אלקטרונית לקמבודיה",
  cambodia_page: {
    meta_desc: "הוצאת ויזה אלקטרונית לקמבודיה ב-{price} בלבד — טופס אונליין קצר בעברית, קבלת אשרה רשמית תוך 3-5 ימים ישירות לדוא”ל, במחיר הזול בישראל! ויזה לקמבודיה מעודכן {currentYear}.",
    title: "ויזה אלקטרונית לקמבודיה - יישום מקוון מהיר Visanet {currentYear} {'|'}"
  },
  canada: "קנדה",
  canada_evisa: "קנדה eTA",
  canada_page: {
    meta_desc: "קבלת אישור כניסה eTA לקנדה, בקרו באתרנו היום והתחילו בתהליך הוצאת ויזה לקנדה און ליין. ויזהנט עוזרים לכם להנפיק ויזות דיגיטליות לקנדה וארה״ב במחירים הזולים ביותר",
    title: "ויזה לקנדה: אישור כניסה אלקטרוני eTA לקנדה אונליין {currentYear} | ויזה.נט"
  },
  cc_validation_error: "פרטי הכרטיס אינם חוקיים",
  change_image: "שינוי תמונה",
  chat: "צ'אט",
  christianity: "נצרות",
  cities_or_locations: "שמות ערים או מיקומים",
  city: "עיר/ישוב",
  click_drag_image: "לחצו או גררו תמונה",
  click_here: "לחצו כאן",
  close: "סגור",
  collapse: "צמצם כרטיסיות",
  company_num: "מספר חברה",
  consulate_payment_note: "התשלום אפשרי דרך הקונסוליה בלבד לנמצאים בישראל.",
  contact: "צור קשר",
  contact_on_pay_issue: "זקוקים לעזרה? אם אתם נתקלים בבעיות כלשהן במהלך התשלום, אל תהססו <a href=\"/contact\" target=\"_blank\"> ליצור איתנו קשר</a>.",
  contact_page: {
    additional_support: "תמיכה נוספת",
    assist: "אנחנו כאן כדי לעזור בכל שאלה או בקשה. בוויזה נט, אנו מחויבים לתמיכה יוצאת דופן ולחוויה חלקה. אתם תמיד יכולים לפנות אלינו באמצעות:",
    availability: "זמינים בימים ראשון עד חמישי, בין השעות 09:00-17:00.",
    available_247: "(זמינות 24/7)",
    chat: "צ'אט לייב",
    desk: "מחשב נייד וציוד משרדי על שולחן",
    email: "דוא\"ל",
    email_address: "כתובת דוא\"ל",
    get_in_touch: "צרו איתנו קשר בכל עת דרך הערוצים הבאים:",
    header: "צרו קשר עם <span class='text-primary'> וויזה נט </span>",
    hours: "ראשון-חמישי, {hours}, בטלפון וב-WhatsApp",
    meta_desc: "לשירות הלקוחות של וויזה נט ניתן לפנות בדרכים הבאות: טלפון, WhatsApp, צ'אט חי באתר ודוא\"ל. מידע נוסף זמין בדף יצירת הקשר.",
    msg: "ההודעה שלכם",
    msg_send: "שלחו לנו הודעה",
    msg_send_body: "יש לכם שאלה או בקשה? שלחו לנו הודעה ונחזור אליכם בהקדם האפשרי.",
    msg_send_error: "שגיאה בשליחת ההודעה",
    msg_send_success: "ההודעה נשלחה בהצלחה",
    personalized_assistance: "לקבלת סיוע מותאם אישית יותר, פנו אלינו באמצעות:",
    send_msg: "שלחו הודעה",
    support_247: "אפשרויות תמיכה 24/7",
    title: "צרו קשר עם וויזה נט {'|'} {year}"
  },
  contact_us: "צור קשר",
  continue_img_upload_later: "אפשר להמשיך.<br>עם הגשת הטופס, תקבלו דוא\"ל עם הוראות לשליחת התמונות.",
  copy_link: "העתק קישור",
  countries_short: {
    GBR: "בריטניה"
  },
  country: "מדינה",
  coupon_applied: "קופון הופעל!",
  coupon_code: "קוד קופון",
  credit_card_charge_on_click: "בלחיצה על כפתור \"תשלום\", אמצעי התשלום שבחרתם יחויב בסכום הסופי של:",
  credit_card_details: "🔐 הזינו פרטי כרטיס האשראי:",
  crossing: {
    air: "אוויר",
    border: "שם גבול",
    flight: "מספר טיסה",
    land: "קרקע",
    radio_label: "איך אתם מתכננים לחצות את הגבול?",
    sea: "ים",
    ship: "שם הספינה"
  },
  customer_details: "פרטי לקוח",
  day: "יום",
  days: "{n} יום | {n} ימים",
  days_1: "יום אחד",
  days_10: "10 ימים",
  days_2: "2 ימים",
  days_21: "21 ימים",
  days_3: "3 ימים",
  days_30: "30 יום",
  days_4: "4 ימים",
  days_5: "5 ימים",
  days_7: "7 ימים",
  describe_incident: "תיאור קצר של המקרה",
  describe_rejection: "סיבה לדחייה",
  details: "פרטי דרכון",
  did_army: "האם שירתת בצבא?",
  did_visit_saarc: "האם ביקרתם באחת ממדינות SAARC ב-3 השנים האחרונות?",
  discount: "הנחה",
  education: "השכלה",
  eligible_countries_title_bahrain: "מדינות הזכאיות ל-eVisa לבחריין",
  eligible_countries_title_cambodia: "מדינות זכאיות לויזה אלקטרונית (eVisa) לקמבודיה",
  eligible_countries_title_canada: "מדינות הזכאיות להוציא eTA קנדי",
  eligible_countries_title_india: "מדינות זכאיות ל-eVisa להודו",
  eligible_countries_title_indonesia: "מדינות הזכאיות לקבלת eVisa באינדונזיה",
  eligible_countries_title_israel: "מדינות זכאיות ל-ETA-IL הישראלי",
  eligible_countries_title_korea: "מדינות הזכאיות ל-K-ETA לקוריאה",
  eligible_countries_title_morocco: "מדינות זכאיות לויזה אלקטרונית (eVisa) למרוקו",
  eligible_countries_title_new_zealand: "מדינות הזכאיות ל-eTA של ניו זילנד",
  eligible_countries_title_saudi_arabia: "מדינות רשאיות לויזה אלקטרונית (eVisa) לערב הסעודית",
  eligible_countries_title_schengen: "מדינות זכאיות לויזה אלקטרונית לאזור שנגן",
  eligible_countries_title_sri_lanka: "מדינות הזכאיות ל-eVisa לסרי לנקה",
  eligible_countries_title_thailand: "מדינות זכאיות לויזה אלקטרונית (eVisa) לתאילנד",
  eligible_countries_title_togo: "מדינות הזכאיות לויזה אלקטרונית לטוגו",
  eligible_countries_title_uk: "מדינות זכאיות ל-ETA לבריטניה",
  eligible_countries_title_usa: "מדינות הזכאיות ל-ESTA בארה\"ב",
  eligible_countries_title_vietnam: "מדינות זכאיות לויזה אלקטרונית (eVisa) לווייטנאם",
  email: "דוא\"ל",
  email_images_continue: "אנא שלחו את התמונות שלכם לכתובת הדוא\"ל שלנו: <a href=\"mailto:{email}\" target=\"_blank\"> {email}</a>. <br>לאחר שליחת התמונות, תוכלו להמשיך.",
  emails: {
    approved: {
      approval_confirmation_bahrain: "הוויזה האלקטרונית שלכם לבחריין אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_cambodia: "הוויזה האלקטרונית שלכם לקמבודיה אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_canada: "ה-eTA שלכם לקנדה אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_india: "הויזה האלקטרונית שלכם להודו אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_indonesia: "הוויזה האלקטרונית שלכם לאינדונזיה אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_israel: "ה- ETA-IL שלכם לישראל אושר בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_korea: "ה- K-ETA שלכם לקוריאה אושר בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_morocco: "הוויזה האלקטרונית שלכם למרוקו אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_new_zealand: "ה- NZeTA שלכם לניו זילנד אושר בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_saudi_arabia: "הוויזה האלקטרונית שלכם לערב הסעודית אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_schengen: "הויזה שלכם לאזור שנגן אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_sri_lanka: "הוויזה האלקטרונית שלכם לסרי לנקה אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_thailand: "הוויזה האלקטרונית שלכם לתאילנד אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_togo: "הוויזה האלקטרונית שלכם לטוגו אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_uk: "ה- ETA שלכם לבריטניה אושר בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_usa: "ה-ESTA שלכם לארה\"ב אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      approval_confirmation_vietnam: "הוויזה האלקטרונית שלכם לווייטנאם אושרה בהצלחה. כעת אתם מורשים לנסוע.",
      available_via: "אם יש אי התאמה כלשהי, צרו איתנו קשר מיד בתגובה לדוא\"ל זה או באמצעות <a href=\"tel:{phone}\">הטלפון</a> או <a href=\"{whatsapp}\">WhatsApp</a>.",
      calendar_stay_limit_bahrain: "השהייה בבחריין מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_cambodia: "השהייה בקמבודיה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_canada: "השהייה בקנדה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_india: "השהייה בהודו מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_indonesia: "השהייה באינדונזיה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_israel: "השהייה בישראל מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_korea: "השהייה בקוריאה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_morocco: "השהייה במרוקו מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_new_zealand: "השהייה בניו זילנד מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_saudi_arabia: "השהייה בערב הסעודית מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_schengen: "השהייה באזור שנגן מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_sri_lanka: "השהייה בסרי לנקה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_thailand: "השהייה בתאילנד מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_togo: "השהייה בטוגו מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_uk: "השהייה בבריטניה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_usa: "השהייה בארה\"ב מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_vietnam: "השהייה בווייטנאם מוגבלת לי {days} מים בשנה קלנדרית.",
      canada_usa_link: "מתכננים לבקר בארה\"ב? כעת אתם יכולים להגיש בקשה לו <a href='https://visanet.co.il/usa'> יזת ESTA לארצות הברית </a> 🇺🇸",
      days_to_use_bahrain: "הוויזה האלקטרונית שלכם מצריכה כניסה לבחריין בימים {days} הקרובים!",
      days_to_use_cambodia: "הוויזה האלקטרונית שלכם מצריכה כניסה לקמבודיה בימים {days} הקרובים!",
      days_to_use_canada: "ה- eTA שלכם מחייב כניסה לקנדה בימים {days} הקרובים!",
      days_to_use_india: "הוויזה האלקטרונית שלכם מצריכה כניסה להודו בימים {days} הקרובים!",
      days_to_use_indonesia: "הוויזה האלקטרונית שלכם מצריכה כניסה לאינדונזיה בימים {days} הקרובים!",
      days_to_use_israel: "ה- ETA-IL שלכם מחייב כניסה לישראל בימים הקרובים! {days}",
      days_to_use_korea: "ה- K-ETA שלכם מחייב כניסה לקוריאה בימים {days} הקרובים!",
      days_to_use_morocco: "הוויזה האלקטרונית שלכם מצריכה כניסה למרוקו בימים {days} הקרובים!",
      days_to_use_new_zealand: "ה- NZeTA שלכם מחייב כניסה לניו זילנד בי {days} מים הקרובים!",
      days_to_use_saudi_arabia: "הויזה האלקטרונית שלכם מצריכה כניסה לסעודיה בי {days} מים הקרובים!",
      days_to_use_schengen: "הויזה שלכם מצריכה כניסה לאזור שנגן בימים {days} הקרובים!",
      days_to_use_sri_lanka: "הוויזה האלקטרונית שלכם מצריכה כניסה לסרי לנקה בי {days} מים הקרובים!",
      days_to_use_thailand: "הוויזה האלקטרונית שלכם מצריכה כניסה לתאילנד בימים {days} הקרובים!",
      days_to_use_togo: "הוויזה האלקטרונית שלכם מצריכה כניסה לטוגו בימים הקרובים! {days}",
      days_to_use_uk: "ה- ETA שלכם בבריטניה מחייב כניסה לבריטניה בימים הקרובים! {days}",
      days_to_use_usa: "ה- ESTA שלכם מחייב כניסה לארה\"ב בימים {days} הקרובים!",
      days_to_use_vietnam: "הוויזה האלקטרונית שלכם מצריכה כניסה לווייטנאם בי {days} מים הקרובים!",
      doc_ready_bahrain: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם לבחריין אושרה!",
      doc_ready_cambodia: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם לקמבודיה אושרה!",
      doc_ready_canada: "אנחנו שמחים להודיע שה-eTA שלכם לקנדה אושר!",
      doc_ready_india: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם להודו אושרה!",
      doc_ready_indonesia: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם לאינדונזיה אושרה!",
      doc_ready_israel: "אנחנו שמחים להודיע שה- ETA-IL שלכם לישראל אושר!",
      doc_ready_korea: "אנחנו שמחים להודיע שה- K-ETA שלכם לקוריאה אושר!",
      doc_ready_morocco: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם למרוקו אושרה!",
      doc_ready_new_zealand: "אנחנו שמחים להודיע שה- NZeTA שלכם לניו זילנד אושרה!",
      doc_ready_saudi_arabia: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם לסעודיה אושרה!",
      doc_ready_schengen: "אנחנו שמחים להודיע שהוויזה שלכם לאזור שנגן אושרה!",
      doc_ready_sri_lanka: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם לסרי לנקה אושרה!",
      doc_ready_thailand: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם לתאילנד אושרה!",
      doc_ready_togo: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם לטוגו אושרה!",
      doc_ready_uk: "אנחנו שמחים להודיע שה- ETA שלכם בבריטניה עבור בריטניה אושר!",
      doc_ready_usa: "אנחנו שמחים להודיע שה-ESTA שלכם לארה\"ב אושרה!",
      doc_ready_vietnam: "אנחנו שמחים להודיע שהוויזה האלקטרונית שלכם לווייטנאם אושרה!",
      ensure_details_accurate: "אנא בדקו את כל הפרטים האישיים שלכם בקפידה.",
      entries_double_bahrain: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לבחריין כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_cambodia: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לקמבודיה כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_canada: "eTA זה מאפשר כניסה כפולה (2 כניסות) לקנדה (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_india: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) להודו כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_indonesia: "eVisa זו מאפשרת כניסה כפולה (2 כניסות) לאינדונזיה כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_israel: "ETA-IL זה מאפשר כניסה כפולה (2 כניסות) לישראל (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_korea: "K-ETA זה מאפשר כניסה כפולה (2 כניסות) לקוריאה (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_morocco: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) למרוקו כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_new_zealand: "NZeTA זה מאפשר כניסה כפולה (2 כניסות) לניו זילנד כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_saudi_arabia: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לסעודיה כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_schengen: "ויזה זו מאפשרת כניסה כפולה (2 כניסות) לאזור שנגן כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_sri_lanka: "eVisa זו מאפשרת כניסה כפולה (2 כניסות) לסרי לנקה כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_thailand: "eVisa זו מאפשרת כניסה כפולה (2 כניסות) לתאילנד כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_togo: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לטוגו כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_uk: "ETA בבריטניה זה מאפשר כניסה כפולה (2 כניסות) לבריטניה (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_usa: "ESTA זה מאפשר כניסה כפולה (2 כניסות) לארה\"ב (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_vietnam: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לוייטנאם כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_multiple_bahrain: "אתם יכולים להיכנס לבחריין כמה פעמים שתרצו כל עוד הוויזה האלקטרונית שלכם תישאר בתוקף.",
      entries_multiple_cambodia: "אתם יכולים להיכנס לקמבודיה כמה פעמים שתרצו כל עוד הוויזה האלקטרונית שלכם תישאר בתוקף.",
      entries_multiple_canada: "אתם יכולים להיכנס לקנדה כמה פעמים שתרצו כל עוד ה-eTA שלכם נשאר בתוקף.",
      entries_multiple_india: "אתם יכולים להיכנס להודו כמה פעמים שתרצו כל עוד האישור האלקטרוני שלכם נשאר בתוקף.",
      entries_multiple_indonesia: "אתם יכולים להיכנס לאינדונזיה כמה פעמים שתרצו כל עוד הוויזה האלקטרונית שלכם נשארת תקפה.",
      entries_multiple_israel: "אתם רשאים להיכנס לישראל כמה פעמים שתרצו כל עוד ה-ETA-IL שלכם נשאר בתוקף.",
      entries_multiple_korea: "אתם יכולים להיכנס לקוריאה כמה פעמים שתרצו כל עוד ה- K-ETA שלכם נשאר בתוקף.",
      entries_multiple_morocco: "אתם יכולים להיכנס למרוקו כמה פעמים שתרצו כל עוד הוויזה האלקטרונית שלכם תישאר בתוקף.",
      entries_multiple_new_zealand: "אתם יכולים להיכנס לניו זילנד כמה פעמים שתרצו כל עוד - NZeTA שלכם נשאר בתוקף.",
      entries_multiple_saudi_arabia: "אתם יכולים להיכנס לסעודיה כמה פעמים שתרצו כל עוד הוויזה האלקטרונית שלכם תישאר בתוקף.",
      entries_multiple_schengen: "אתם יכולים להיכנס לאזור שנגן כמה פעמים שתרצו כל עוד הוויזה שלכם נשארת בתוקף.",
      entries_multiple_sri_lanka: "אתם יכולים להיכנס לסרי לנקה כמה פעמים שתרצו כל עוד הוויזה האלקטרונית שלכם נשארת תקפה.",
      entries_multiple_thailand: "אתם יכולים להיכנס לתאילנד כמה פעמים שתרצו כל עוד הוויזה האלקטרונית שלכם תישאר בתוקף.",
      entries_multiple_togo: "אתם יכולים להיכנס לטוגו כמה פעמים שתרצו כל עוד הוויזה האלקטרונית שלכם נשארת תקפה.",
      entries_multiple_uk: "אתם יכולים להיכנס לבריטניה כמה פעמים שתרצו כל עוד ה-ETA שלכם בבריטניה נשאר בתוקף.",
      entries_multiple_usa: "אתם יכולים להיכנס לארה\"ב כמה פעמים שתרצו כל עוד ה-ESTA שלכם תישאר בתוקף.",
      entries_multiple_vietnam: "אתם יכולים להיכנס לווייטנאם כמה פעמים שתרצו כל עוד הוויזה האלקטרונית שלכם תישאר בתוקף.",
      entries_single_bahrain: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לבחריין.",
      entries_single_cambodia: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לקמבודיה.",
      entries_single_canada: "eTA זה מאפשר כניסה יחידה לקנדה.",
      entries_single_india: "ויזה אלקטרונית זו מאפשרת כניסה יחידה להודו.",
      entries_single_indonesia: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לאינדונזיה.",
      entries_single_israel: "ETA-IL זה מאפשר כניסה יחידה לישראל.",
      entries_single_korea: "K-ETA זה מאפשר כניסה יחידה לקוריאה.",
      entries_single_morocco: "ויזה אלקטרונית זו מאפשרת כניסה יחידה למרוקו.",
      entries_single_new_zealand: "NZeTA זה מאפשר כניסה יחידה לניו זילנד.",
      entries_single_saudi_arabia: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לסעודיה.",
      entries_single_schengen: "ויזה זו מאפשרת כניסה יחידה לאזור שנגן.",
      entries_single_sri_lanka: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לסרי לנקה.",
      entries_single_thailand: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לתאילנד.",
      entries_single_togo: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לטוגו.",
      entries_single_uk: "ETA בבריטניה זה מאפשר כניסה יחידה לבריטניה.",
      entries_single_usa: "ESTA זה מאפשר כניסה יחידה לארה\"ב.",
      entries_single_vietnam: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לווייטנאם.",
      eta_disclaimer_bahrain: "בעוד שהוויזה האלקטרונית מאשרת נסיעה, הכניסה לבחריין היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_cambodia: "בעוד שהוויזה האלקטרונית שלכם מאשרת נסיעה, הכניסה לקמבודיה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_canada: "בעוד שה-eTA שלכם מאשרת נסיעה, הכניסה לקנדה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_india: "בעוד שויזה אלקטרונית שלכם מאשרת נסיעה, הכניסה להודו היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_indonesia: "בעוד שהוויזה האלקטרונית שלכם מאשרת נסיעה, הכניסה לאינדונזיה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_israel: "בעוד ETA-IL שלכם מאשר נסיעה, הכניסה לישראל היא בסופו של דבר על שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_korea: "בעוד ה- K-ETA שלכם מאשר נסיעה, הכניסה לקוריאה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_morocco: "בעוד שהוויזה האלקטרונית שלכם מאשרת נסיעה, הכניסה למרוקו היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_new_zealand: "בעוד ש- NZeTA שלכם מאשר נסיעה, הכניסה לניו זילנד היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_saudi_arabia: "בעוד שהוויזה האלקטרונית שלכם מאשרת נסיעה, הכניסה לסעודיה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_schengen: "בעוד שהוויזה שלכם מאשרת נסיעה, הכניסה לאזור שנגן היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_sri_lanka: "בעוד שה-eVisa שלכם מאשרת נסיעה, הכניסה לסרי לנקה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_thailand: "בעוד שהוויזה האלקטרונית שלכם מאשרת נסיעה, הכניסה לתאילנד היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_togo: "בעוד שהוויזה האלקטרונית שלכם מאשרת נסיעה, הכניסה לטוגו היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_uk: "בעוד ש-ETA שלכם בבריטניה מאשרת נסיעה, הכניסה לבריטניה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_usa: "בעוד שה-ESTA שלכם מאשרת נסיעה, הכניסה לארה\"ב היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_vietnam: "בעוד שהוויזה האלקטרונית שלכם מאשרת נסיעה, הכניסה לווייטנאם היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה בביקורת הגבולות. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלכם, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_please_note: "שימו לב:",
      greeting: "שלום {name},",
      instruction_2_passport_pages: "חובה לפחות 2 עמודים ריקים בדרכון. עם ההגעה, הרשויות יחתמו על דפים אלה.",
      instruction_dont_print_eta: "אין צורך להדפיס את ה-{visaDocName}.",
      instruction_dont_print_evisa: "אין צורך להדפיס ויזה אלקטרונית זו.",
      instruction_dont_print_verification_eta: "אין צורך להדפיס את ה- ETA שלך. ניתן להציג את ה-{visaDocName} במכשיר הנייד במידת הצורך.",
      instruction_dont_print_verification_evisa: "אין צורך להדפיס את הוויזה האלקטרונית. ניתן להציג אותה במכשיר הנייד במידת הצורך.",
      instruction_dont_print_verification_visa: "אין צורך להדפיס את הוויזה. ניתן גם להציג אותה במכשיר הנייד במידת הצורך.",
      instruction_dont_print_visa: "אין צורך להדפיס ויזה זו.",
      instruction_print_eta: "עליכם להדפיס את האי {visaDocName} שור המצורף לדוא\"ל זה.",
      instruction_print_evisa: "עליכם להדפיס את אישור הוויזה האלקטרונית המצורפת לדוא\"ל זה.",
      instruction_print_keep_handy_bahrain: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בבחריין.",
      instruction_print_keep_handy_cambodia: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בקמבודיה.",
      instruction_print_keep_handy_canada: "שמרו את ה- eTA שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בקנדה.",
      instruction_print_keep_handy_india: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בהודו.",
      instruction_print_keep_handy_indonesia: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול באינדונזיה.",
      instruction_print_keep_handy_israel: "שמרו את ה- ETA-IL שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בישראל.",
      instruction_print_keep_handy_korea: "שמרו את ה- K-ETA שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בקוריאה.",
      instruction_print_keep_handy_morocco: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול במרוקו.",
      instruction_print_keep_handy_new_zealand: "שמרו את ה- NZeTA שהדפסתם בהישג יד בעת עלייה ו/או חציית הגבול בניו זילנד.",
      instruction_print_keep_handy_saudi_arabia: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בערב הסעודית.",
      instruction_print_keep_handy_schengen: "שמרו את הוויזה שהדפסתםת בהישג יד בעת העלייה ו/או חציית הגבול באזור שנגן.",
      instruction_print_keep_handy_sri_lanka: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בסרי לנקה.",
      instruction_print_keep_handy_thailand: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בתאילנד.",
      instruction_print_keep_handy_togo: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בטוגו.",
      instruction_print_keep_handy_uk: "שמרו את ה- ETA שהדפסתם בבריטניה בהישג יד בעת העלייה ו/או חציית הגבול בבריטניה.",
      instruction_print_keep_handy_usa: "שמרו את ה- ESTA שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בארה\"ב.",
      instruction_print_keep_handy_vietnam: "שמרו את הוויזה האלקטרונית שהדפסתם בהישג יד בעת העלייה ו/או חציית הגבול בווייטנאם.",
      instruction_print_twice_eta: "עליכם להדפיס שני עותקים של ה-{visaDocName}.",
      instruction_print_twice_evisa: "עליכם להדפיס שני עותקים של הוויזה האלקטרונית.",
      instruction_print_twice_present: "הציגו עותק אחד במהלך הצ'ק-אין ואת השני בביקורת הדרכונים עם ההגעה. תדפיסים בשחור לבן תקינים.",
      instruction_print_twice_visa: "עליכם להדפיס שני עותקים של הויזה.",
      instruction_print_visa: "עליכם להדפיס את אישור הוויזה המצורף לדוא\"ל זה.",
      instruction_return_ticket_and_accommodation_bahrain: "עם הכניסה לבחריין, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_cambodia: "עם הכניסה לקמבודיה, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_canada: "עם הכניסה לקנדה, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_india: "עם הכניסה להודו, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_indonesia: "עם הכניסה לאינדונזיה, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_israel: "עם הכניסה לישראל יש להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_korea: "עם הכניסה לקוריאה, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_morocco: "עם הכניסה למרוקו, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_new_zealand: "עם הכניסה לניו זילנד, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_saudi_arabia: "עם הכניסה לסעודיה, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_schengen: "עם הכניסה לאזור שנגן, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_sri_lanka: "עם הכניסה לסרי לנקה, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_thailand: "עם הכניסה לתאילנד, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_togo: "עם הכניסה לטוגו, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_uk: "עם הכניסה לבריטניה, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_usa: "עם הכניסה לארה\"ב, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_vietnam: "עם הכניסה לווייטנאם, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_bahrain: "עם הכניסה לבחריין, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_cambodia: "עם הכניסה לקמבודיה, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_canada: "עם הכניסה לקנדה, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_india: "עם הכניסה להודו, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_indonesia: "עם הכניסה לאינדונזיה, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_israel: "עם הכניסה לישראל, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_korea: "עם הכניסה לקוריאה, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_morocco: "עם הכניסה למרוקו, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_new_zealand: "עם הכניסה לניו זילנד, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_saudi_arabia: "עם הכניסה לסעודיה, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_schengen: "עם הכניסה לאזור שנגן, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_sri_lanka: "עם הכניסה לסרי לנקה, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_thailand: "עם הכניסה לתאילנד, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_togo: "עם הכניסה לטוגו, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_uk: "עם הכניסה לבריטניה, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_usa: "עם הכניסה לארה\"ב, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_vietnam: "עם הכניסה לווייטנאם, עליכם להציג כרטיס טיסה חזרה או יציאה.",
      instruction_stay_reset_bahrain: "כל ביקור בבחריין מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_cambodia: "כל ביקור בקמבודיה מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_canada: "כל ביקור בקנדה מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_extend: "כדי להאריך שהייה באופן חוקי, עליכם לצאת ולהיכנס מחדש למדינה. עם הכניסה חוזרת, השהייה המותרת מתאפסת לימים נוספים {days}.",
      instruction_stay_reset_india: "כל ביקור בהודו מוגבל לימים {days} רצופים.",
      instruction_stay_reset_indonesia: "כל ביקור באינדונזיה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_israel: "כל ביקור בישראל מוגבל לימים {days} רצופים.",
      instruction_stay_reset_korea: "כל ביקור בקוריאה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_morocco: "כל ביקור במרוקו מוגבל לימים {days} רצופים.",
      instruction_stay_reset_new_zealand: "כל ביקור בניו זילנד מוגבל לימים {days} רצופים.",
      instruction_stay_reset_saudi_arabia: "כל ביקור בערב הסעודית מוגבל לימים {days} רצופים.",
      instruction_stay_reset_schengen: "כל ביקור באזור שנגן מוגבל לימים {days} רצופים.",
      instruction_stay_reset_sri_lanka: "כל ביקור בסרי לנקה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_thailand: "כל ביקור בתאילנד מוגבל לימים {days} רצופים.",
      instruction_stay_reset_togo: "כל ביקור בטוגו מוגבל לימים {days} רצופים.",
      instruction_stay_reset_uk: "כל ביקור בבריטניה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_usa: "כל ביקור בארה\"ב מוגבל לימים {days} רצופים.",
      instruction_stay_reset_vietnam: "כל ביקור בווייטנאם מוגבל לי {days} מים רצופים.",
      instruction_travel_documents: "ייתכן שתתבקשו להציג הוכחת לינה (הזמנת מלון או דירה), אמצעים כספיים לזמן השהות וביטוח בריאות תקף.",
      instructions_title: "הנחיות חשובות",
      instructions_title_bahrain: "הנחיות לוויזה אלקטרונית לבחריין",
      instructions_title_cambodia: "הנחיות לוויזה אלקטרונית לקמבודיה",
      instructions_title_canada: "הנחיות eTA לקנדה",
      instructions_title_india: "הנחיות לוויזה אלקטרונית להודו",
      instructions_title_indonesia: "הנחיות לוויזה אלקטרונית לאינדונזיה",
      instructions_title_israel: "הנחיות ETA-IL לישראל",
      instructions_title_korea: "הנחיות K-ETA לקוריאה",
      instructions_title_morocco: "הנחיות לוויזה אלקטרונית למרוקו",
      instructions_title_new_zealand: "הנחיות ל- NZeTA לניו זילנד",
      instructions_title_saudi_arabia: "הנחיות לוויזה אלקטרונית לערב הסעודית",
      instructions_title_schengen: "הנחיות לויזה לאזור שנגן",
      instructions_title_sri_lanka: "הנחיות לוויזה אלקטרונית לסרי לנקה",
      instructions_title_thailand: "הנחיות לוויזה אלקטרונית לתאילנד",
      instructions_title_togo: "הנחיות עבור ויזה אלקטרונית לטוגו",
      instructions_title_uk: "הנחיות עבור UK-ETA לבריטניה",
      instructions_title_usa: "הנחיות ESTA לארה\"ב",
      instructions_title_vietnam: "הנחיות לוויזה אלקטרונית לווייטנאם",
      intent_business_bahrain: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בבחריין.",
      intent_business_cambodia: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בקמבודיה.",
      intent_business_canada: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בקנדה.",
      intent_business_india: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בהודו.",
      intent_business_indonesia: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך באינדונזיה.",
      intent_business_israel: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילות עסקית במהלך שהותך בישראל.",
      intent_business_korea: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בקוריאה.",
      intent_business_morocco: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך במרוקו.",
      intent_business_new_zealand: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בניו זילנד.",
      intent_business_saudi_arabia: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בערב הסעודית.",
      intent_business_schengen: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך באזור שנגן.",
      intent_business_sri_lanka: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בסרי לנקה.",
      intent_business_thailand: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בתאילנד.",
      intent_business_togo: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בטוגו.",
      intent_business_uk: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בבריטניה.",
      intent_business_usa: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בארה\"ב.",
      intent_business_vietnam: "מטרת הביקור שלכם היא עסקית. אתם רשאים לנהל פעילויות עסקיות במהלך שהותך בווייטנאם.",
      intent_tourism_bahrain: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בבחריין.",
      intent_tourism_cambodia: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בקמבודיה.",
      intent_tourism_canada: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בקנדה.",
      intent_tourism_india: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בהודו.",
      intent_tourism_indonesia: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים באינדונזיה.",
      intent_tourism_israel: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בישראל.",
      intent_tourism_korea: "מטרת הביקור שלכם היא תיירות בלבד. אסור לך לעבוד או לנהל עסקים בקוריאה.",
      intent_tourism_morocco: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים במרוקו.",
      intent_tourism_new_zealand: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בניו זילנד.",
      intent_tourism_saudi_arabia: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בערב הסעודית.",
      intent_tourism_schengen: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים באזור שנגן.",
      intent_tourism_sri_lanka: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בסרי לנקה.",
      intent_tourism_thailand: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בתאילנד.",
      intent_tourism_togo: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בטוגו.",
      intent_tourism_uk: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בבריטניה.",
      intent_tourism_usa: "מטרת הביקור שלכם היא תיירות בלבד. אסור לך לעבוד או לנהל עסקים בארה\"ב.",
      intent_tourism_vietnam: "מטרת הביקור שלכם היא תיירות בלבד. אינכם רשאים לעבוד או לנהל עסקים בווייטנאם.",
      leave_review: "❤ יחמם לנו את הלב אם תכתבו עלינו מילה טובה:",
      liked_service: "אהבתם את השירות שלנו?",
      passport_requirement_eta: "עליכם להציג את הדרכון ששימש להגשת בקשת ה-{visaDocName}; דרכון אחר לא יתקבל.",
      passport_requirement_evisa: "עליכם להציג את הדרכון ששימש להגשת הבקשה לוויזה; דרכון אחר לא יתקבל.",
      passport_requirement_visa: "עליכם להציג את הדרכון ששימש להגשת הבקשה לוויזה; דרכון אחר לא יתקבל.",
      pleasant_flight: "אנו מאחלים לכם טיסה נעימה",
      regards: "בברכה,<br>צוות ויזה נט",
      safe_travels: "תודה שבחרתם ויזה נט. שתהיה לכם נסיעה בטוחה!",
      thank_you_choosing: "ותודה שבחרתם ויזה נט",
      valid_since_approval_eta: "{visaDocName} זה תקף {validity} מהיום, או עד שתוקף הדרכון שלכם יפוג - המוקדם מביניהם.",
      valid_since_approval_evisa: "הויזה האלקטרונית שלכם תקפה {validity} מהיום, או עד שתוקף הדרכון שלכם יפוג - המוקדם מביניהם.",
      valid_since_approval_visa: "הויזה שלכם תקפה {validity} מהיום, או עד שתוקף הדרכון שלכם יפוג - המוקדם מביניהם.",
      valid_since_entry_bahrain: "עם הכניסה לבחריין, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_cambodia: "עם הכניסה לקמבודיה, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_canada: "עם הכניסה לקנדה, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_india: "עם הכניסה להודו, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_indonesia: "עם הכניסה לאינדונזיה, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_israel: "עם הכניסה לישראל, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_korea: "עם הכניסה לקוריאה, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_morocco: "עם הכניסה למרוקו, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_new_zealand: "עם הכניסה לניו זילנד, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_saudi_arabia: "עם הכניסה לסעודיה, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_schengen: "עם הכניסה לאזור שנגן, השהייה המותרת שלכם היא עד  עד{validity}.",
      valid_since_entry_sri_lanka: "עם הכניסה לסרי לנקה, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_thailand: "עם הכניסה לתאילנד, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_togo: "עם הכניסה לטוגו, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_uk: "עם הכניסה לבריטניה, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_usa: "עם הכניסה לארה\"ב, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_entry_vietnam: "עם הכניסה לווייטנאם, השהייה המותרת שלכם היא עד {validity}.",
      valid_since_specified_eta: "אישור ה-{visaDocName} שלך תקף עד {validity}, עם תאריכים מדויקים המפורטים תחת \"Valid from/until\" בקובץ ה- {visaDocName} שלך.",
      valid_since_specified_evisa: "הוויזה האלקטרונית שלך תקפה עד {validity}, עם תאריכים מדויקים המפורטים תחת \"Valid from/until\" בקובץ הוויזה האלקטרונית שלך.",
      valid_since_specified_note_bahrain: "עליכם לעזוב את בחריין עד תאריך תפוגה זה.",
      valid_since_specified_note_cambodia: "עליכם לעזוב את קמבודיה עד תאריך תפוגה זה.",
      valid_since_specified_note_canada: "עליכם לעזוב את קנדה עד תאריך תפוגה זה.",
      valid_since_specified_note_india: "עליכם לעזוב את הודו עד תאריך תפוגה זה.",
      valid_since_specified_note_indonesia: "עליכם לעזוב את אינדונזיה עד תאריך תפוגה זה.",
      valid_since_specified_note_israel: "עליכם לעזוב את ישראל עד תאריך תפוגה זה.",
      valid_since_specified_note_korea: "עליכם לעזוב את קוריאה עד תאריך תפוגה זה.",
      valid_since_specified_note_morocco: "עליכם לעזוב את מרוקו עד תאריך תפוגה זה.",
      valid_since_specified_note_new_zealand: "עליכם לעזוב את ניו זילנד עד תאריך תפוגה זה.",
      valid_since_specified_note_saudi_arabia: "עליכם לעזוב את ערב הסעודית עד תאריך תפוגה זה.",
      valid_since_specified_note_schengen: "עליכם לעזוב את אזור שנגן עד תאריך תפוגה זה.",
      valid_since_specified_note_sri_lanka: "עליכם לעזוב את סרי לנקה עד תאריך תפוגה זה.",
      valid_since_specified_note_thailand: "עליכם לעזוב את תאילנד עד תאריך תפוגה זה.",
      valid_since_specified_note_togo: "עליכם לעזוב את טוגו עד תאריך תפוגה זה.",
      valid_since_specified_note_uk: "עליכם לעזוב את בריטניה עד תאריך תפוגה זה.",
      valid_since_specified_note_usa: "עליכם לעזוב את ארה\"ב עד תאריך תפוגה זה.",
      valid_since_specified_note_vietnam: "עליכם לעזוב את וייטנאם עד תאריך תפוגה זה.",
      valid_since_specified_visa: "הוויזה שלך תקפה עד {validity}, עם תאריכים מדויקים המפורטים תחת \"Valid from/until\" בקובץ הוויזה שלך.",
      view_file_instruction: "ניתן להוריד בצורה מאובטחת את האישור שלכם באמצעות הכפתור למטה:"
    },
    fix: {
      address_following_issues: "במידה ואתם בוחרים להגיש את הבקשה בכל זאת, ישנם בעיות נוספות בנושאים הבאים:",
      alt_example_face_photo: "דוגמה לתמונת פנים",
      alt_example_passport_2_pages_photo: "דוגמה לתצלום דרכון 2 עמודים",
      alt_example_passport_photo: "דוגמה לתצלום דרכון",
      authorities_note: "⚠️ שימו לב: אם הנושא לא ייפתר במהירות, הרשויות ב{country} עלולות לדחות את בקשת הויזה שלכם.",
      cannot_guarantee_approval: "נוכל לנסות להגיש את בקשתכם, אך במצב כזה <strong>לא נוכל להבטיח הצלחה או זיכוי כספי במקרה של סירוב</strong> ❌",
      document_renewal_note: "חסרים מסמכים? אנחנו יכולים להקפיא את הבקשה שלכם עד שתהיו מוכנים. הזכאות שלכם לויזה נשארת בתוקף ✅",
      example_face_photo: "דוגמה לתמונת פנים תקינה:",
      example_passport_photo: "דוגמה לתצלום דרכון תקין:",
      greeting: "היי {name},",
      intro_authorities_bahrain: "הרשויות בבחריין בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_cambodia: "הרשויות בקמבודיה בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_canada: "הרשויות בקנדה בדקו את בקשת הeTA שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_india: "הרשויות בהודו בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_indonesia: "הרשויות באינדונזיה בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_israel: "הרשויות בישראל בדקו את בקשת הETA-IL שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_korea: "הרשויות בקוריאה בדקו את בקשת הK-ETA שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_morocco: "הרשויות במרוקו בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_new_zealand: "הרשויות בניו זילנד בדקו את בקשת הNZeTA שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_saudi_arabia: "הרשויות בערב הסעודית בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_schengen: "הרשויות בשנגן בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_sri_lanka: "הרשויות בסרי לנקה בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_thailand: "הרשויות תאילנד בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_togo: "הרשויות בטוגו בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_uk: "הרשויות באנגליה בדקו את בקשת הUK ETA שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_usa: "הרשויות בארה״ב בדקו את בקשת הESTA שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_authorities_vietnam: "הרשויות בויאטנם בדקו את בקשת הויזה שלכם ועדכנו אותנו בבעיות שדורשות את ההתייחסות שלכם:",
      intro_form_bahrain: "עברנו על טופס הויזה לבחריין שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_cambodia: "עברנו על טופס הויזה לקמבודיה שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_canada: "עברנו על טופס הeTA לקנדה שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_india: "עברנו על טופס הויזה להודו שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_indonesia: "עברנו על טופס הויזה לאינדונזיה שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_israel: "עברנו על טופס הETA-IL לישראל שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_korea: "עברנו על טופס הK-ETA לקוריאה שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_morocco: "עברנו על טופס הויזה למרוקו שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_new_zealand: "עברנו על טופס הNZeTA לניו זילנד שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_saudi_arabia: "עברנו על טופס הויזה לערב הסעודית שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_schengen: "עברנו על טופס הויזה לשנגן שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_sri_lanka: "עברנו על טופס הויזה לסרי לנקה שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_thailand: "עברנו על טופס הויזה לתאילנד שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_togo: "עברנו על טופס הויזה לטוגו שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_uk: "עברנו על טופס הUK ETA לאנגליה שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_usa: "עברנו על טופס הESTA לארה״ב שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      intro_form_vietnam: "עברנו על טופס הויזה לויאטנם שהגשתם באתרינו, ונתקלנו במספר בעיות אשר דורשות את תשומת ליבכם:",
      issues: {
        additional_people: "תמונת הפנים עם אנשים נוספים בתמונה - חובה תמונת פנים שלכם לבד.",
        black_and_white_face: "תמונת הפנים בשחור/לבן - חובה תמונת פנים בצבע.",
        black_and_white_pass: "תצלום הדרכון בשחור/לבן - חובה דרכון בצבע.",
        blurred_passport: "תצלום הדרכון מטושטש - חובה תצלום קריא.",
        blurred_photo: "תמונת הפנים מטושטשת - חובה תמונה ברורה באיכות טובה.",
        born_in_iran: "סומן בטופס שארץ הלידה היא איראן.",
        born_in_iraq: "סומן בטופס שארץ הלידה היא עיראק.",
        card_not_in_english: "חסר כרטיס ביקור באנגלית. הרשויות בהודו דורשות כרטיס ביקור באנגלית.",
        code_hidden_at_bottom: "תצלום הדרכון עם קוד מוסתר למטה - חובה שיראו את כל העמוד במלואו, כולל הקוד בתחתית. ",
        criminal_record: "סומן בטופס שקיים עבר פלילי.",
        cut_on_sides: "תצלום הדרכון חתוך בצדדים - חובה שיראו את כל העמוד.",
        expired_passport: "הדרכון פג תוקף - חובה דרכון בתוקף על מנת לקבל ויזה.",
        eyes_not_at_camera_level: "תמונת הפנים עם עיניים לא בגובה המצלמה - חובה להסתכל ישירות למצלמה.",
        face_cut_on_sides_top: "תמונת הפנים חתוכה בצדדים או למעלה - חובה שהתמונה תראה את כל הפנים בצורה מלאה.",
        hair_hiding_the_face: "תמונת הפנים עם שיער שמסתיר את הפנים - חובה שהפנים ייראו בצורה ברורה ולא מוסתרת.",
        head_body_not_straight: "תמונת הפנים עם ראש או גוף לא ישרים - חובה שהתמונה תהיה ישרה.",
        letter_not_in_english: "חסר מכתב הזמנה באנגלית. הרשויות בהודו דורשות מכתב באנגלית.",
        missing_business_card: "חסר כרטיס ביקור. הרשויות בהודו דורשות את כרטיס הביקור שלך באנגלית על מנת לקבל ויזת עסקים.",
        missing_invitation_letter: "חסר מכתב הזמנה. הרשויות בהודו דורשות מכתב הזמנה מבית עסק בהודו על מנת לקבל ויזת עסקים.",
        need_2_passport_pages: "תצלום הדרכון לא תקין - נא לשלוח צילום ברור של העמוד הראשי בדרכון, כולל העמוד שמופיע בצמוד אליו כאשר הדרכון פתוח. שני העמודים המחוברים יחד צריכים להופיע בתצלום. ",
        not_straight: "תצלום הדרכון לא ישר - חובה תמונה ישרה של העמוד.",
        not_white_background: "תמונת הפנים עם רקע שאינו לבן - חובה להשתמש ברקע לבן בלבד.",
        passport_5_years_or_less: "הדרכון בתוקף ל־5 שנים או פחות - הרשויות בארה״ב דורשות דרכון בתוקף ל־10 שנים סה״כ לכל בגיר מעל גיל 18 כדי לקבל אישור ESTA.",
        passport_missing: "תצלום הדרכון חסר - חובה לצלם את העמוד הראשי עם פרטי הדרכון המלאים.",
        passport_not_biometric: "הדרכון לא ביומטרי - הרשויות בארה״ב דורשות דרכון ביומטרי (עם תוקף ל־10 שנים לאזרחים בגירים) כדי לקבל אישור ESTA.",
        past_rejection: "סומן בטופס שסורבת בעבר לויזה בארה״ב.",
        photo_from_passport: "תמונת הפנים מתוך הדרכון - חובה לצלם תמונה נפרדת.",
        photo_is_missing: "תמונת הפנים חסרה - חובה לצרף תמונת פנים ברורה.",
        shadow_light_on_face: "תמונת הפנים עם צל או אור לא אחיד על הפנים - חובה לוודא תאורה טובה ואחידה.",
        shoulder_line_missing: "תמונת הפנים ללא קו כתפיים ברור - חובה שהתמונה תכלול את הכתפיים במלואן.",
        suspected_wrong_details: "אנו חושדים שיש טעות בפרטים שהוזנו בטופס - נא לשלוח צילום ברור של העמוד הראשי בדרכון לאימות.",
        temporary_passport: "הדרכון הינו דרכון זמני.",
        unnatural_facial_expression: "תמונת הפנים עם הבעת פנים לא טבעית - יש לשמור על הבעה נייטרלית ורגועה.",
        valid_less_than_6_months: "הדרכון עם תוקף פחות מחצי שנה קדימה - הרשויות ב{country} דורשות דרכון עם תוקף מעל חצי שנה מרגע הכניסה למדינה על מנת לקבל ויזה.",
        visit_in_cuba: "סומן בטופס שהיה ביקור בקובה.",
        with_accessories: "תמונת הפנים עם אוזניות, כובע או אביזרים - חובה להצטלם ללא אביזרים.",
        with_glasses: "תמונת הפנים עם משקפיים - אסור משקפיים בתמונה.",
        with_shadow_light: "תצלום הדרכון עם צל/אור שפוגע בקריאות - חובה שהדרכון יהיה קריא במלואו.",
        with_tank_top: "תמונת הפנים עם גופיה - חובה ללבוש חולצה שמכסה את הכתפיים.",
        without_shirt: "תמונת הפנים ללא חולצה - חובה ללבוש חולצה בתמונה.",
        wrong_passport: "תצלום הדרכון אינו תואם את הבקשה - חובה לצלם את העמוד הראשי עם פרטי הדרכון המלאים.",
        wrong_photo: "תמונת הפנים שגויה - חובה להעלות תמונה עדכנית ואישית לבקשת הוויזה."
      },
      need_help: "במידה ויש לכם שאלות או אתם זקוקים לעזרה נוספת, אל תהססו לפנות אלינו - אנחנו כאן כדי לעזור.",
      regards: "בברכה,<br>צוות ויזה.נט",
      submission_risk_options: "אתם יכולים לבחור אם לבטל את הבקשה, או להמשיך בהגשה. הבקשה תשאר במתנה עד שנקבל מכם עדכון. ניתן להשיב למייל זה או ליצור איתנו קשר דרך ב<a href='{whatsapp}'>WhatsApp</a>.",
      take_photos: "ניתן להשתמש במצלמת הטלפון עבור התמונות החסרות, וניתן לשלוח אותן כאן במייל או ב<a href='{whatsapp}'>WhatsApp</a>.",
      to_proceed: "כדי להמשיך את תהליך ההזמנה, נצטרך לקבל את המסמכים/תמונות החסרות בהקדם האפשרי ⏱️"
    },
    form_abandonment: {
      action_text: "כדי להשלים בקלות את בקשתכם ולהבטיח את קבלת ה-{visaDocName} שלכם, <strong>לחצו על הכפתור</strong> 🔽",
      action_text_eta: "כדי לסיים את בקשתכם ולהבטיח את קבלת ה-{visaDocName} שלכם, <strong>לחצו על הכפתור</strong> 🔽",
      action_text_evisa: "כדי לסיים את בקשתכם ולהבטיח את קבלת ה-eVisa שלכם, <strong>לחצו על הכפתור</strong> 🔽",
      action_text_visa: "כדי לסיים את בקשתכם ולהבטיח את קבלת הוויזה שלכם, <strong>לחצו על הכפתור</strong> 🔽",
      almost_ready_bahrain: "המסע שלכם לבחריין כמעט מוכן!",
      almost_ready_cambodia: "המסע שלכם לקמבודיה כמעט מוכן!",
      almost_ready_canada: "המסע שלכם לקנדה כמעט מוכן!",
      almost_ready_india: "המסע שלכם להודו כמעט מוכן!",
      almost_ready_indonesia: "המסע שלכם לאינדונזיה כמעט מוכן!",
      almost_ready_israel: "המסע שלכם לישראל כמעט מוכן!",
      almost_ready_korea: "המסע שלכם לקוריאה כמעט מוכן!",
      almost_ready_morocco: "המסע שלכם למרוקו כמעט מוכן!",
      almost_ready_new_zealand: "המסע שלכם לניו זילנד כמעט מוכן!",
      almost_ready_saudi_arabia: "המסע שלכם לערב הסעודית כמעט מוכן!",
      almost_ready_schengen: "המסע שלכם לאזור שנגן כמעט מוכן!",
      almost_ready_sri_lanka: "המסע שלכם לסרי לנקה כמעט מוכן!",
      almost_ready_thailand: "המסע שלכם לתאילנד כמעט מוכן!",
      almost_ready_togo: "המסע שלכם לטוגו כמעט מוכן!",
      almost_ready_uk: "המסע שלכם לבריטניה כמעט מוכן!",
      almost_ready_usa: "המסע שלכם לארה\"ב כמעט מוכן!",
      almost_ready_vietnam: "המסע שלכם לווייטנאם כמעט מוכן!",
      button: "השלימו את בקשתכם",
      closing: "מאחלים לכם נסיעה בטוחה, <br> צוות ויזה נט 👋",
      greeting: "היי {name},",
      main_text_bahrain: "אתם צעד אחד לפני קבלת הוויזה שלכם לבחריין.",
      main_text_cambodia: "אתם צעד אחד לפני קבלת הוויזה שלכם לקמבודיה.",
      main_text_canada: "אתם צעד אחד לפני קבלת הוויזה שלכם לקנדה.",
      main_text_eta: "שמנו לב שהייתם צעד אחד לפני קבלת הוויזה שלכם-{visaDocName} שלכם בויזה נט.",
      main_text_evisa: "שמנו לב שהייתם צעד אחד לפני קבלת הוויזה שלכם-eVisa שלכם בויזה נט.",
      main_text_india: "אתם צעד אחד לפני קבלת הוויזה שלכם להודו.",
      main_text_indonesia: "אתם צעד אחד לפני קבלת הוויזה שלכם לאינדונזיה.",
      main_text_israel: "אתם צעד אחד לפני קבלת הוויזה שלכם לישראל.",
      main_text_korea: "אתם צעד אחד לפני קבלת הוויזה שלכם לקוריאה.",
      main_text_morocco: "אתם צעד אחד לפני קבלת הוויזה שלכם למרוקו.",
      main_text_new_zealand: "אתם צעד אחד לפני קבלת הוויזה שלכם לניו זילנד.",
      main_text_saudi_arabia: "אתם צעד אחד לפני קבלת הוויזה שלכם לערב הסעודית.",
      main_text_schengen: "אתם צעד אחד לפני קבלת הוויזה שלכם לאזור שנגן.",
      main_text_sri_lanka: "אתם צעד אחד לפני קבלת הוויזה שלכם לסרי לנקה.",
      main_text_thailand: "אתם צעד אחד לפני קבלת הוויזה שלכם לתאילנד.",
      main_text_togo: "אתם צעד אחד לפני קבלת הוויזה שלכם לטוגו.",
      main_text_uk: "אתם צעד אחד לפני קבלת הוויזה שלכם לבריטניה.",
      main_text_usa: "אתם צעד אחד לפני קבלת הוויזה שלכם לארה\"ב.",
      main_text_vietnam: "אתם צעד אחד לפני קבלת הוויזה שלכם לווייטנאם.",
      support: "אם יש לכם שאלות או שאתם זקוקים לסיוע, צוות התמיכה שלנו כאן כדי לעזור לכם: דרך דוא\"ל (פשוט השיבו למייל זה), <a href='{whatsapp}'>WhatsApp</a> או <a href='tel:{phone}'>טלפון</a>."
    },
    insurance: {
      text_bahrain: "ביטוח אינו נדרש כדי להיכנס לבחריין, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_cambodia: "ביטוח אינו נדרש כדי להיכנס לקמבודיה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_canada: "ביטוח אינו נדרש לכניסה לקנדה, אך הוא יגן עליך מהוצאות רפואיות בלתי צפויות במהלך הטיול. השג את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">השג את הפוליסה שלך</a>",
      text_india: "ביטוח אינו נדרש כדי להיכנס להודו, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_indonesia: "ביטוח אינו נדרש כדי להיכנס לאינדונזיה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_israel: "ביטוח אינו נדרש כדי להיכנס לישראל, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_korea: "ביטוח אינו נדרש כדי להיכנס לדרום קוריאה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_morocco: "ביטוח אינו נדרש כדי להיכנס למרוקו, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_new_zealand: "ביטוח אינו נדרש כדי להיכנס לניו זילנד, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_saudi_arabia: "ביטוח אינו נדרש כדי להיכנס לערב הסעודית, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_schengen: "ביטוח אינו נדרש כדי להיכנס לאזור שנגן, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_sri_lanka: "ביטוח אינו נדרש כדי להיכנס לסרי לנקה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_thailand: "ביטוח אינו נדרש כדי להיכנס לתאילנד, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_togo: "ביטוח אינו נדרש כדי להיכנס לטוגו, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_uk: "ביטוח אינו נדרש כדי להיכנס לבריטניה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_usa: "ביטוח אינו נדרש כדי להיכנס לארה\"ב, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      text_vietnam: "ביטוח אינו נדרש כדי להיכנס לווייטנאם, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\">קבל את הפוליסה שלך</a>",
      title_bahrain: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_cambodia: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_canada: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_india: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_indonesia: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_israel: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_korea: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_morocco: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_new_zealand: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_saudi_arabia: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_schengen: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_sri_lanka: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_thailand: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_togo: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_uk: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_usa: "🛡️ כדאי לעשות ביטוח נסיעות",
      title_vietnam: "🛡️ כדאי לעשות ביטוח נסיעות"
    },
    mobile_payment: {
      hello: "שלום {name},",
      need_assistance: "במידה ותצטרכו סיוע או שיש לכם שאלות – נשמח לעזור. צוות התמיכה שלנו זמין עבורכם:",
      received_submission_bahrain: "קיבלנו את בקשתכם לויזה לבחריין ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_cambodia: "קיבלנו את בקשתכם לויזה לקמבודיה ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_canada: "קיבלנו את בקשתכם לeTA לקנדה ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_eta: "קיבלנו את בקשת תשלום הנייד עבור ה{docName}.",
      received_submission_evisa: "קיבלנו את בקשת תשלום הנייד עבור הויזה.",
      received_submission_india: "קיבלנו את בקשתכם לויזה להודו ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_indonesia: "קיבלנו את בקשתכם לויזה לאינדונזיה ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_israel: "קיבלנו את בקשתכם לETA-IL לישראל ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_korea: "קיבלנו את בקשתכם לK-ETA לקוריאה ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_morocco: "קיבלנו את בקשתכם לויזה למרוקו ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_new_zealand: "קיבלנו את בקשתכם לNZeTA לניו-זילנד ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_saudi_arabia: "קיבלנו את בקשתכם לויזה לערב הסעודית ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_schengen: "קיבלנו את בקשתכם לויזה לשנגן ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_sri_lanka: "קיבלנו את בקשתכם לויזה לסרי לנקה ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_thailand: "קיבלנו את בקשתכם לויזה לתאילנד ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_togo: "קיבלנו את בקשתכם לויזה לטוגו ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_uk: "קיבלנו את בקשתכם לUK-ETA לבריטניה ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_usa: "קיבלנו את בקשתכם לESTA לארה״ב ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_vietnam: "קיבלנו את בקשתכם לויזה לויאטנם ואת תשלום הנייד שביצעתם דרך {processor}.",
      received_submission_visa: "קיבלנו את בקשת תשלום הנייד עבור הויזה.",
      regards: "בברכה,<br>צוות ויזה נט",
      support_email: "ניתן להשיב ישירות למייל זה",
      support_phone: "או <a href='tel:{phone}'>בטלפון</a>",
      support_whatsapp: "ליצור קשר דרך ה<a href='{whatsapp}'>WhatsApp</a>",
      thank_you: "תודה שבחרתם בויזהנט! 🌍",
      verifying: "כעת אנו מאמתים את פרטי התשלום.",
      when_payment_approved: "ברגע שהתשלום יאושר, תקבלו למייל את אישור ההזמנה הרשמי יחד עם חשבונית."
    },
    onetime_coupon: {
      closing: "תודה רבה על היותכם לקוחותינו המוערכים בויזה נט. אם יש לכם שאלות, הצוות שלנו עומד לרשותכם 24/7.",
      coupon_label: "קופון",
      feedback_text: "המשוב שלכם לא רק עוזר לנו להשתפר, אלא גם עוזר לאחרים להכיר אותנו. כאות תודה, קיבלתם קופון חד פעמי לרכישה הבאה שלכם:",
      greeting: "היי {name}, <br> ברכות על קבלת ה-{visaDocName} שלכם! אנחנו שמחים לסייע לכם בתכנון הנסיעה ונשמח לשמוע על החוויה שלכם.",
      greeting_eta: "👋 היי {name}, <br> אנחנו מקווים שחווית ה-{visaDocName} שלכם הייתה חלקה ונוחה! שמחנו לסייע לכם ונשמח לשמוע על החוויה שלכם.",
      greeting_evisa: "👋 היי {name}, <br> אנחנו מקווים שחווית הוויזה האלקטרונית שלכם הייתה חלקה ונוחה! שמחנו לסייע לכם ונשמח לשמוע על החוויה שלכם.",
      greeting_visa: "👋 היי {name}, <br> אנחנו מקווים שחווית הוויזה שלכם הייתה חלקה ונוחה! שמחנו לסייע לכם ונשמח לשמוע על החוויה שלכם.",
      review_label: "יחמם לנו את הלב אם תגידו עלינו מילה טובה:",
      support: "תודה רבה על היותכם לקוחותינו. אם יש לכם שאלות, הצוות שלנו עומד לרשותכם 24/7. השיבו ישירות לדוא\"ל זה או צרו קשר באמצעות טלפון/וואטסאפ במספר {phone}.",
      title: "תודה שבחרתם ויזה נט 💙"
    },
    order_received: {
      applicant_info: "פרטי נוסע",
      application_received_bahrain: "טופס בקשת הוויזה האלקטרונית שלכם לבחריין התקבל בהצלחה.",
      application_received_cambodia: "טופס הוויזה האלקטרונית לקמבודיה התקבל בהצלחה.",
      application_received_canada: "טופס בקשת eTA שלכם לקנדה התקבל בהצלחה.",
      application_received_india: "טופס בקשת הוויזה האלקטרונית שלכם להודו התקבל בהצלחה.",
      application_received_indonesia: "טופס בקשת הוויזה האלקטרונית שלכם לאינדונזיה התקבל בהצלחה.",
      application_received_israel: "טופס בקשת ה- ETA-IL שלכם התקבל בהצלחה.",
      application_received_korea: "טופס בקשת ה- K-ETA שלכם לקוריאה התקבל בהצלחה.",
      application_received_morocco: "טופס בקשת הוויזה האלקטרונית שלכם למרוקו התקבל בהצלחה.",
      application_received_new_zealand: "טופס בקשת ה- NZeTA שלכם לניו זילנד התקבל בהצלחה.",
      application_received_saudi_arabia: "טופס בקשת הוויזה האלקטרונית שלכם לערב הסעודית התקבל בהצלחה.",
      application_received_schengen: "טופס בקשת אשרת שנגן שלכם התקבל בהצלחה.",
      application_received_sri_lanka: "טופס בקשת הוויזה האלקטרונית שלכם לסרי לנקה התקבל בהצלחה.",
      application_received_thailand: "טופס בקשת הוויזה האלקטרונית שלכם לתאילנד התקבל בהצלחה.",
      application_received_togo: "טופס הבקשה שלכם ל- הוויזה האלקטרונית התקבל בהצלחה.",
      application_received_uk: "טופס בקשת ה- UK-ETA שלכם לבריטניה התקבל בהצלחה.",
      application_received_usa: "טופס הבקשה שלכם ל- ESTA לארה\"ב התקבל בהצלחה.",
      application_received_vietnam: "טופס הוויזה האלקטרונית שלכם לווייטנאם התקבל בהצלחה",
      attention: "שימו לב",
      available_via: "אנו זמינים בדוא\"ל (בתגובה להודעה זו), <a href='{whatsapp}'>WhatsApp</a> או <a href='tel:{phone}'>טלפון</a>.",
      closing: "בתודה, <br> צוות ויזה נט 🙏",
      delay_alert: "תאריך הכניסה המתוכנן שלכם הוא יותר מ-{daysToUse} יום מעכשיו. כדי להבטיח שהאישור יהיה תקף לנסיעה שלכם, נגיש את בקשתכם 3 שבועות לפני מועד הכניסה המתוכנן. הסיבה לכך היא שסוג הויזה שבחרתם מחייב כניסה תוך {daysToUse} ימים מרגע ההנפקה.",
      ensure_details_accurate: "אנא ודאו שכל הפרטים האישיים שלכם מדויקים ותואמים למידע בדרכון.",
      estimated_entry_date: "תאריך כניסה משוער:",
      expect_receive_bahrain: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם בכתובת דוא\"ל זו",
      expect_receive_cambodia: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם בכתובת דוא\"ל זו",
      expect_receive_canada: "אתם צפויים לקבל את ה- eTA שלכם לקנדה בכתובת דוא\"ל זו",
      expect_receive_india: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם בכתובת דוא\"ל זו",
      expect_receive_indonesia: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם בכתובת דוא\"ל זו",
      expect_receive_israel: "אתם צפויים לקבל את ה- ETA-IL שלכם לישראל בכתובת דוא\"ל זו",
      expect_receive_korea: "אתם צפויים לקבל את ה- K-ETA שלכם לקוריאה בכתובת דוא\"ל זו",
      expect_receive_morocco: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם בכתובת דוא\"ל זו",
      expect_receive_new_zealand: "אתם צפויים לקבל את ה- NZeTA שלכם לניו זילנד בכתובת דוא\"ל זו",
      expect_receive_saudi_arabia: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם הסעודית בכתובת דוא\"ל זו",
      expect_receive_schengen: "אתם צפויים לקבל את אשרת שנגן שלכם בכתובת דוא\"ל זו",
      expect_receive_sri_lanka: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם לנקה בכתובת דוא\"ל זו",
      expect_receive_thailand: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם בכתובת דוא\"ל זו",
      expect_receive_togo: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם בכתובת דוא\"ל זו",
      expect_receive_uk: "אתם צפויים לקבל את ה- UK-ETA שלכם בכתובת דוא\"ל זו",
      expect_receive_usa: "אתם צפויים לקבל את ה- ESTA שלכם לארה\"ב בכתובת דוא\"ל זו",
      expect_receive_vietnam: "אתם צפויים לקבל את הוויזה האלקטרונית שלכם בכתובת דוא\"ל זו",
      greeting: "שלום {name},",
      here_to_help: "אנחנו כאן כדי להפוך את הנסיעה שלכם לפשוטה וקלה יותר!",
      no_further_action: "אם כל המידע נכון, לא נדרשת פעולה נוספת מצידך. בקשת הוויזה שלך נמצאת כעת בידינו, ואנחנו נדאג לכל דבר מכאן.",
      order_details: "{id} פרטי הזמנה:",
      passport_expiration: "תפוגת דרכון",
      passport_issue: "תאריך הוצאת דרכון",
      payment_receipt: "הודעת דוא\"ל נפרדת נשלחה עם קבלה עבור התשלום.",
      photos_needed: "🚨 כדי שנמשיך לטפל בבקשתכם, <u> אנא שלחו לנו את התמונות הבאות עבור כל נוסע:</u>",
      processing_bahrain: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של בחריין.",
      processing_cambodia: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של קמבודיה.",
      processing_canada: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של קנדה.",
      processing_india: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של הודו.",
      processing_indonesia: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של אינדונזיה.",
      processing_israel: "הטופס שלך נמצא בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה בישראל.",
      processing_korea: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של קוריאה.",
      processing_morocco: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של מרוקו.",
      processing_new_zealand: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של ניו זילנד.",
      processing_saudi_arabia: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של ערב הסעודית.",
      processing_schengen: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של אזור שנגן.",
      processing_sri_lanka: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של סרי לנקה.",
      processing_thailand: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של תאילנד.",
      processing_time_label: "זמן עיבוד:",
      processing_time_text: "עד {days} ימי עסקים",
      processing_time_text_1: "עד יום העסקים הבא.",
      processing_time_text_1_2_days: "עד 1-2 ימי עסקים",
      processing_time_text_3_days: "עד 3 ימי עסקים",
      processing_time_text_5_15_days: "עד 5-15 ימי עסקים",
      processing_time_text_5_days: "עד 5 ימי עסקים",
      processing_time_text_few_hours: "עד כמה שעות",
      processing_time_text_next_day: "עד יום העסקים הבא",
      processing_togo: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של טוגו.",
      processing_uk: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של בריטניה.",
      processing_usa: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של ארה\"ב.",
      processing_vietnam: "הטופס שלכם בטיפול ויוגש מיד כבקשה רשמית למחלקת ההגירה של וייטנאם.",
      product: "סוג ויזה:",
      quantity: "כמות:",
      send_photos_via: "אתם יכולים לשלוח את התמונות על ידי מענה לדוא\"ל זה או באמצעות <a href='{whatsapp}'> WhatsApp</a>.",
      thank_you_choosing: "תודה שבחרתם ויזה נט",
      thank_you_order: "תודה על ההזמנה שלך!",
      total_price: "סה\"כ מחיר:",
      urgent_order: "הזמנה דחופה:",
      within_business_days: "בתוך {days} ימי עסקים.",
      within_business_days_1: "עד יום העסקים הבא.",
      within_business_days_1_2_days: "תוך 1-2 ימי עסקים.",
      within_business_days_3_days: "תוך 3 ימי עסקים.",
      within_business_days_5_15_days: "תוך 5-15 ימי עסקים.",
      within_business_days_5_days: "תוך 5 ימי עסקים.",
      within_business_days_few_hours: "בתוך כמה שעות.",
      within_business_days_next_day: "ביום העסקים הבא."
    },
    order_status: {
      closing: "בברכה,<br> צוות ויזה נט",
      current_status: "ℹ מצב נוכחי:",
      greeting: "שלום {name},<br> אנחנו כאן כדי לעדכן אתכם במצב ההזמנה שלכם! להלן, סטטוס ההזמנה הנוכחי.",
      help_section: "<strong>❓ זקוקים לעזרה? יש לכם שאלות? </strong><br>אל תהססו <a href='https://visanet.co.il/contact'>לפנות אלינו</a> בכל עת.",
      status: {
        active: {
          approval_time: "האישור אורך בדרך כלל {days} ימי עסקים.",
          approval_time_1_2_days: "האישור אורך בדרך כלל 1-2 ימי עסקים.",
          approval_time_3_days: "האישור אורך בדרך כלל 3 ימי עסקים.",
          approval_time_5_15_days: "האישור אורך בדרך כלל בין 5 ל-15 ימי עסקים.",
          approval_time_5_days: "האישור אורך בדרך כלל 5 ימי עסקים.",
          approval_time_few_hours: "האישור בדרך כלל לוקח כמה שעות.",
          approval_time_next_day: "האישור אורך בדרך כלל עד יום עסקים אחד.",
          description: "קיבלנו בהצלחה את בקשתכם. עוד קצת סבלנות - התהליך בעיצומו ובדרך כלל לוקח {days} ימים.",
          description_1_2_days: "קיבלנו בהצלחה את בקשתכם והיא נמצאת בבדיקה. האישור אורך בדרך כלל 1-2 ימי עסקים.",
          description_3_days: "קיבלנו בהצלחה את בקשתכם והיא נמצאת בבדיקה. האישור אורך בדרך כלל 3 ימי עסקים.",
          description_5_15_days: "קיבלנו בהצלחה את בקשתכם, והיא נמצאת כעת בבדיקה. אישור לוקח בדרך כלל 5-15 ימי עסקים.",
          description_5_days: "קיבלנו בהצלחה את בקשתכם והיא נמצאת בבדיקה. האישור אורך בדרך כלל 5 ימי עסקים.",
          description_few_hours: "קיבלנו בהצלחה את בקשתכם והיא נמצאת בבדיקה. האישור בדרך כלל לוקח כמה שעות.",
          description_next_day: "קיבלנו בהצלחה את בקשתכם והיא נמצאת בבדיקה. האישור אורך בדרך כלל עד יום עסקים אחד.",
          title: "פעיל"
        },
        canceled: {
          description: "ההזמנה שלכם בוטלה.",
          title: "בוטל"
        },
        completed: {
          description: "מזל טוב! בקשתכם אושרה, ושלחנו לכם בדוא\"ל את כל הפרטים הרלוונטיים.",
          title: "הושלם"
        },
        issue: {
          description: "נראה שיש בעיה עם הבקשה שלכם. אנא בדקו את תיבת המייל שלכם לפרטים.",
          title: "בעיה"
        }
      },
      thank_you: "תודה שבחרתם ויזה נט."
    },
    resume_url: {
      action_text: "<strong>לחצו על הכפתור כדי להמשיך את הטופס שלכם.</strong> 🔽",
      almost_ready_bahrain: "הטיול שלכם לבחריין כמעט מוכן!",
      almost_ready_cambodia: "הטיול שלכם לקמבודיה כמעט מוכן!",
      almost_ready_canada: "הטיול שלכם לקנדה כמעט מוכן!",
      almost_ready_india: "הטיול שלכם להודו כמעט מוכן!",
      almost_ready_indonesia: "הטיול שלכם לאינדונזיה כמעט מוכן!",
      almost_ready_israel: "הטיול הקרוב שלכם לישראל כמעט מוכן!",
      almost_ready_korea: "הטיול שלכם לקוריאה כמעט מוכן!",
      almost_ready_morocco: "הטיול שלכם למרוקו כמעט מוכן!",
      almost_ready_new_zealand: "הטיול שלכם לניו זילנד כמעט מוכן!",
      almost_ready_saudi_arabia: "הטיול שלכם בערב הסעודית כמעט מוכן!",
      almost_ready_schengen: "הטיול שלכם לאזור שנגן כמעט מוכן!",
      almost_ready_sri_lanka: "הטיול שלכם לסרי לנקה כמעט מוכן!",
      almost_ready_thailand: "הטיול שלכם לתאילנד כמעט מוכן!",
      almost_ready_togo: "הטיול שלכם לטוגו כמעט מוכן!",
      almost_ready_uk: "הטיול שלכם לבריטניה כמעט מוכן!",
      almost_ready_usa: "הטיול שלכם לארה\"ב כמעט מוכן!",
      almost_ready_vietnam: "הטיול שלכם לווייטנאם כמעט מוכן!",
      button: "המשך הטופס שלכם",
      closing: "מאחלים לכם נסיעות בטוחות ונעימות, <br> צוות ויזה נט 👋",
      greeting: "היי {name},",
      main_text_eta: "נראה שאתם נמצאים צעדים ספורים ממילוי טופס ה-{visaDocName} שלכם בויזה נט.",
      main_text_evisa: "נראה שאתם נמצאים במרחק צעדים ספורים ממילוי טופס הוויזה האלקטרונית שלכם בויזה נט.",
      main_text_visa: "נראה שאתם נמצאים במרחק צעדים ספורים ממילוי טופס הוויזה שלכם בויזה נט.",
      support: "אם יש לכם שאלות או שאתם זקוקים לסיוע, צוות התמיכה שלנו כאן כדי לעזור לכם: דרך דוא\"ל (פשוט השיבו למייל זה), <a href='{whatsapp}'>WhatsApp</a> או <a href='tel:{phone}'>טלפון</a>."
    },
    wrapper: {
      confidentiality_notice: "🔐 חיסיון מידע: הודעה זו מכילה מידע המיועד לנמען בלבד. אם התקבל בטעות, אנא הודע לנו מייד ומחק דוא\"ל זה.",
      legal_notice: "ℹ️ קיבלת דוא\"ל זה מכיוון שהגשת בקשה לויזה דרך {domain} האתר. <br>🔒 <strong> חיסיון מידע</strong>: דוא\"ל זה וכל קובץ מצורף מיועד אך ורק לנמען/ים המיועדים ועשויים להכיל מידע סודי. כל סקירה, שימוש, גילוי או הפצה בלתי מורשים של תקשורת זו אסורים בהחלט. אם אינך הנמען המיועד, אנא הודע לשולח באופן מיידי על ידי מענה לדוא\"ל זה, מחק הודעה זו והשמיד את כל העותקים שלה.",
      legal_notice_abandonment: "ℹ️ קיבלת דוא\"ל זה מכיוון שהתחלת למלא טופס בקשה לויזה בכתובת {domain}.",
      legal_notice_approved_eta: "ℹ️ קיבלת דוא\"ל זה מכיוון שהגשת בקשה ל- {docName} דרך {domain}.",
      legal_notice_approved_evisa: "ℹ️ קיבלת דוא\"ל זה מכיוון שהגשת בקשה ל- eVisa באמצעות {domain}.",
      legal_notice_approved_visa: "ℹ️ קיבלת דוא\"ל זה מכיוון שהגשת בקשה לויזה דרך {domain}.",
      legal_notice_coupon: "ℹ️ קיבלת דוא\"ל זה מכיוון שהשלמת לאחרונה בקשת ויזה בכתובת {domain}.",
      legal_notice_fix_eta: "ℹ️ קיבלת הודעת מייל זו מאחר ורכשת {docName} דרך {domain}.",
      legal_notice_fix_evisa: "ℹ️ קיבלת הודעת מייל זו מאחר ורכשת ויזה דרך {domain}.",
      legal_notice_fix_visa: "ℹ️ קיבלת הודעת מייל זו מאחר ורכשת ויזה דרך {domain}.",
      legal_notice_mobile_payment_eta: "קיבלתם הודעה זו מאחר וביצעתם תשלום נייד עבור {docName} באתר {domain}.",
      legal_notice_mobile_payment_evisa: "קיבלתם הודעה זו מאחר וביצעתם תשלום נייד עבור ויזה באתר {domain}.",
      legal_notice_mobile_payment_visa: "קיבלתם הודעה זו מאחר וביצעתם תשלום נייד עבור ויזה באתר {domain}.",
      legal_notice_received: "ℹ️ קיבלת דוא\"ל זה מכיוון שהגשת בקשה לויזה דרך {domain}.",
      legal_notice_resume: "ℹ️ קיבלת דוא\"ל זה מכיוון ששמרת את טופס הוויזה שלך בכתובת {domain}.",
      legal_notice_status: "ℹ️ קיבלת דוא\"ל זה מכיוון שביקשת עדכון סטטוס לגבי בקשת הוויזה שלך בכתובת {domain}.",
      privacy_policy: "מדיניות פרטיות"
    }
  },
  emergency_contact: "איש קשר חירום",
  emergency_contact_address: "כתובת איש קשר חירום",
  emergency_contact_full_name: "שמו המלא של איש הקשר חירום",
  emergency_contact_phone: "מספר הטלפון של איש הקשר חירום",
  emergency_contact_relation: "קירבה",
  employee: "שכיר",
  empty_if_unknown: "אם לא ידוע, השאירו ריק.",
  eng_as_in_passport: "⚠️ באנגלית, בדיוק לפי הדרכון.",
  ensure_correct_email_bahrain: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_cambodia: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_canada: "ה- eTA יישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_india: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_indonesia: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_israel: "ה- ETA-IL שלך יישלח לכאן. אנא בדוק שוב את הדיוק.",
  ensure_correct_email_korea: "ה- K-ETA יישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_morocco: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_new_zealand: "ה- NZeTA יישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_saudi_arabia: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_schengen: "אנא ודאו שכתובת המייל נכונה וללא טעויות",
  ensure_correct_email_sri_lanka: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_thailand: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_togo: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_uk: "ה- eTA יישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_usa: "ה- ESTA יישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  ensure_correct_email_vietnam: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - ודאו שאין טעויות.",
  error_page: {
    home: "חזרה לדף הבית",
    wrong: "אופס, משהו השתבש!"
  },
  estimate_date: "ניתן להעריך שנה ותאריך משוערים.",
  estimate_entry_date_5_years_valid: "אין צורך לדייק. הויזה תקפה למשך 5 שנים מרגע ההנפקה.",
  estimate_entry_date_year_valid: "אין צורך לדייק. הויזה תקפה למשך שנה מרגע ההנפקה.",
  estimate_entry_in_2_years: "אין צורך לדייק. הויזה תישאר בתוקף עד שנתיים ממועד ההנפקה.",
  estimate_entry_in_half_year: "אין צורך לדייק. ניתן להיכנס למדינה עד שישה חודשים מרגע ההנפקה",
  estimate_one_min: "ניתן להעריך. בחירת מקום אחד מספיקה.",
  estimate_port_entry: "ניתן להעריך. הכניסה מותרת דרך כל הנמלים הרשומים.",
  estimate_visa_5_years: "אין צורך לדייק. הויזה תקפה למשך 5 שנים מרגע ההנפקה.",
  eta: "ETA | תעודות",
  eta_long: "אישור נסיעה אלקטרוני | אישורי נסיעה אלקטרוניים",
  ever_convicted: "האם הורשעתם אי פעם על רקע פלילי?",
  ever_refused_entry: "האם אי פעם סורבתם כניסה למדינה כלשהי?",
  ever_visited_bahrain: "האם ביקרתם בבחריין בעבר?",
  ever_visited_cambodia: "האם ביקרתם בקמבודיה בעבר?",
  ever_visited_canada: "האם ביקרתם פעם בקנדה בעבר?",
  ever_visited_india: "האם ביקרתם בעבר בהודו?",
  ever_visited_indonesia: "האם ביקרתם באינדונזיה בעבר?",
  ever_visited_israel: "האם ביקרתם בישראל בעבר?",
  ever_visited_korea: "האם ביקרתם בעבר בדרום קוריאה?",
  ever_visited_morocco: "האם ביקרתם פעם במרוקו בעבר?",
  ever_visited_new_zealand: "האם ביקרתם פעם בניו זילנד בעבר?",
  ever_visited_saudi_arabia: "האם ביקרתם בעבר בערב הסעודית?",
  ever_visited_schengen: "האם ביקרתם באזור שנגן בעבר?",
  ever_visited_sri_lanka: "האם ביקרתם בסרי לנקה בעבר?",
  ever_visited_thailand: "האם ביקרתם בתאילנד בעבר?",
  ever_visited_togo: "האם ביקרתם בטוגו בעבר?",
  ever_visited_uk: "האם ביקרתם בבריטניה בעבר?",
  ever_visited_usa: "האם ביקרתם בארצות הברית בעבר?",
  ever_visited_vietnam: "האם ביקרתם בווייטנאם בעבר?",
  evisa: "ויזה אלקטרונית | ויזות אלקטרוניות",
  evisas: "אשרות אלקטרוניות",
  exactly_as_in_passport: "הפרטים <strong>חייבים להתאים בדיוק לדרכון</strong>.",
  expected_entry_date: "תאריך כניסה מתוכנן",
  expected_entry_port: "נמל כניסה מתוכנן",
  expected_exit_date: "תאריך יציאה מתוכנן",
  expected_exit_port: "נמל יציאה מתוכנן",
  expected_stay_address_bahrain: "כתובת שהייה מתוכננת בבחריין",
  expected_stay_address_cambodia: "כתובת שהייה מתוכננת בקמבודיה",
  expected_stay_address_canada: "כתובת שהייה מתוכננת בקנדה",
  expected_stay_address_india: "כתובת שהייה מתוכננת בהודו",
  expected_stay_address_indonesia: "כתובת שהייה מתוכננת באינדונזיה",
  expected_stay_address_israel: "כתובת שהייה מתוכננת בישראל",
  expected_stay_address_korea: "כתובת שהייה מתוכננת בקוריאה",
  expected_stay_address_morocco: "כתובת שהייה מתוכננת במרוקו",
  expected_stay_address_new_zealand: "כתובת שהייה מתוכננת בניו זילנד",
  expected_stay_address_saudi_arabia: "כתובת שהייה מתוכננת בערב הסעודית",
  expected_stay_address_schengen: "כתובת שהייה מתוכננת באזור שנגן",
  expected_stay_address_sri_lanka: "כתובת שהייה מתוכננת בסרי לנקה",
  expected_stay_address_thailand: "כתובת שהייה מתוכננת בתאילנד",
  expected_stay_address_togo: "כתובת שהייה מתוכננת בטוגו",
  expected_stay_address_uk: "כתובת שהייה מתוכננת בבריטניה",
  expected_stay_address_usa: "כתובת שהייה מתוכננת בארה\"ב",
  expected_stay_address_vietnam: "כתובת שהייה מתוכננת בווייטנאם",
  explore_visa_options: "ויזות שאנחנו מוציאים",
  extra_nationality: {
    birth: "מלידה",
    from: "מתי קיבלת את האזרחות?",
    has: "אזרחות נוספת",
    how: "כיצד התקבלה האזרחות?",
    naturalization: "התאזרחות",
    none: "אין לי אזרחות נוספת",
    parents: "דרך ההורים",
    past: "הייתה לי אזרחות אחרת בעבר",
    present: "יש לי אזרחות אחרת",
    until: "מתי פגה האזרחות?"
  },
  failure_page: {
    chat: "חלון הצ'אט אמור להיפתח באופן אוטומטי. אתם מוזמנים לזרוק לנו מילה שם ואנו ננסה לענות במהירות.",
    contact: "אנא <a href=\"/contact\">צרו קשר</a> והצוות שלנו יענה בהקדם האפשרי.",
    failed: "התשלום נכשל",
    oops: "אופס! לא הצלחנו לחייב אותך.",
    sad_emoji_img: "איור אמוג'י כחול עצוב",
    saved: "אבל <span class='text-primary'> אל דאגה </span> - הטופס נשמר במערכת שלנו."
  },
  faq: "שאלות נפוצות",
  faq_img: "איור סימן שאלה",
  father_country: "ארץ הלידה של האב",
  father_name: "שם האב",
  female: "נקבה",
  final_price_note: "כל המסים והעמלות כלולים. אין עלויות נסתרות.",
  first_name: "שם פרטי",
  five_stars: "5 כוכבים",
  follow_us: "עקבו אחרינו",
  footer: {
    contact: "זמינים עבורכם",
    explore: "ויזה.נט Visanet",
    visa_to_bahrain: "ויזה לבחריין",
    visa_to_cambodia: "ויזה אלקטרונית לקמבודיה",
    visa_to_canada: "אישור ויזה לקנדה eTA",
    visa_to_india: "ויזה אלקטרונית להודו",
    visa_to_indonesia: "ויזה לאינדונזיה",
    visa_to_israel: "ויזה לישראל ETA-IL",
    visa_to_korea: "אישור ויזה לדרום קוריאה",
    visa_to_morocco: "ויזה אלקטרונית למרוקו",
    visa_to_new_zealand: "ויזה לניו זילנד NZeTA",
    visa_to_saudi_arabia: "ויזה לסעודיה",
    visa_to_schengen: "ויזה לאזור שנגן",
    visa_to_sri_lanka: "ויזה אלקטרונית לסרי לנקה",
    visa_to_thailand: "ויזה לתאילנד DTV",
    visa_to_togo: "ויזה לטוגו",
    visa_to_uk: "ויזה לבריטניה UK ETA",
    visa_to_usa: "פטור מויזה לארצות הברית",
    visa_to_vietnam: "ויזה אלקטרונית לויאטנם",
    visas: "ויזות אלקטרוניות"
  },
  form_modified_by_other: "הטופס עבר שינויים על ידי לשונית/מכשיר אחרים.",
  form_review: {
    applicant_details: "פרטי נוסע",
    checkbox: "אנחנו מאשרים שכל הפרטים מדויקים ותואמים לדרכון.",
    date_of_expiry: "תאריך תפוגה",
    date_of_issue: "תאריך הנפקה",
    ensure_note: "אנא ודאו שכל הפרטים בדף זה נכונים.",
    mistake_back: "מצאתם טעות? אפשר לחזור ולתקן.",
    number: "מספר דרכון",
    order_details: "סיכום הזמנה",
    quantity: "כמות נוסעים:",
    total_price: "מחיר סופי:"
  },
  form_saved_in_system: "הטופס נשמר במערכת שלנו",
  form_steps: {
    details: "פרטים",
    payment: "תשלום",
    review: "אימות",
    upload: "תמונות",
    visa_select: "בחירת ויזה"
  },
  from_price: "מ-{price}",
  full_name: "שם מלא",
  global_field: "חל על כל הנוסעים",
  google_apple_pay: "אפל/גוגל פיי",
  guardian_passport: "מספר דרכון של מבוגר מלווה",
  hero_cta_bahrain: "טופס ויזה לחריין",
  hero_cta_cambodia: "ויזה אלקטרונית לקמבודיה",
  hero_cta_canada: "אישור ויזה אלקטרוני לקנדה ETA",
  hero_cta_home: "ויזה להרפתקה הבאה",
  hero_cta_india: "טופס ויזה אלקטרונית להודו",
  hero_cta_indonesia: "טופס ויזה לאינדונזיה",
  hero_cta_israel: "טופס ויזה לישראל ETA-IL",
  hero_cta_korea: "טופס ויזה לקוריאה K-ETA",
  hero_cta_morocco: "טופס ויזה אלקטרונית למרוקו",
  hero_cta_new_zealand: "טופס ויזה לניו זילנד",
  hero_cta_saudi_arabia: "הגישו טופס ויזה לערב הסעודית",
  hero_cta_schengen: "הגישו בקשה לויזת שנגן",
  hero_cta_sri_lanka: "טופס ויזה לסרי לנקה",
  hero_cta_thailand: "טופס ויזה לתאילנד",
  hero_cta_togo: "טופס ויזה לטוגו",
  hero_cta_uk: "טופס ויזה לבריטניה ואנגליה",
  hero_cta_usa: "טופס ויזה לארצות הברית ESTA",
  hero_cta_vietnam: "טופס ויזה לווייטנאם",
  hero_img: "כותרת ראשית",
  highschool: "תיכונית",
  hindu: "הינדואיזם",
  home_address: "כתובת מגורים",
  home_page: {
    meta_desc: "ויזה.נט הוצאת ויזות לחו”ל: ויזה להודו, ESTA לארה”ב, ETA לאנגליה וויזה לויאטנם, מרוקו וקנדה. מילוי טופס מאובטח אונליין, בלי לבקר בשגרירות. זמין לישראלים בעברית ←",
    overview_body1_bahrain: "הגישו בקשה ל-eVisa לבחריין בנוחות ובקלות אונליין. קבלו אישור מהיר תוך 3-5 ימים בלבד, ישירות לתיבת הדואר הנכנס שלכם, וצאו לדרך.",
    overview_body1_cambodia: "הוציאו eVisa לקמבודיה במהירות ובבטחה! קבלו את הוויזה האלקטרונית שלכם תוך 3-5 ימים ספורים, וצאו לטיול במדינה ההיסטורית והמרתקת הזו.",
    overview_body1_canada: "שכחו מניירת מיותרת! עם שירות ה-ETA שלנו לקנדה, אישור הכניסה הופך לקל מאי פעם. ה-ETA, שיהיה בתוקף עד חמש שנים, יישלח אליכם ישירות לדוא\"ל תוך 1-3 ימי עסקים בלבד.",
    overview_body1_india: "אנו מציעים תהליך הגשת ויזה אונליין להודו – מהיר, מאובטח ובעברית מלאה. בחרו את תקופת השהייה המתאימה לכם (מ-30 יום ועד 5 שנים) וקבלו את הוויזה למייל תוך 1-3 ימי עסקים, בלי לצאת מהבית. התחילו את המסע שלכם להודו ברגל ימין עם תהליך ויזה פשוט ונוח. הצוות שלנו זמין לכל שאלה.",
    overview_body1_indonesia: "הגשת בקשה לויזה לאינדונזיה פשוטה מתמיד אצלנו. קבלו את הוויזה המאושרת שלכם ישירות למייל תוך 3-5 ימים, וצעדו אל גן העדן.",
    overview_body1_israel: "הוציאו ETA לישראל בקלות ובמהירות. אישור הנסיעה שלכם יימסר למייל תוך 1-3 ימים, מוכן לנסיעתכם.",
    overview_body1_korea: "הגשת בקשה ל-K-ETA לדרום קוריאה היא הליך פשוט וזריז. קבלו את אישור הנסיעה שלכם ישירות לתיבת הדואר הנכנס תוך 1-3 ימים.",
    overview_body1_morocco: "השגת ויזה אלקטרונית (eVisa) למרוקו מעולם לא הייתה קלה ונגישה יותר! תהליך הבקשה פשוט, מהיר וללא מאמץ מיותר. הגישו את הבקשה בנוחות ובמהירות מהבית, וקבלו את הוויזה הרשמית ישירות לדוא\"ל שלכם תוך 1-5 ימי עסקים בלבד.",
    overview_body1_new_zealand: "הבטיחו את ה-NZeTA שלכם בקלות ובנוחות – הכל אונליין! אישור הנסיעה שלכם יישלח ישירות לכתובת הדוא\"ל תוך 1-3 ימים בלבד, ואתם מוכנים לצאת לדרך.",
    overview_body1_saudi_arabia: "הגישו בקשה ל-eVisa לערב הסעודית אונליין בקלילות וקבלו אישור תוך 1-3 ימים בלבד. המסע שלכם לארץ שובת הלב הזו כבר ממתין.",
    overview_body1_schengen: "הגישו בקשה לויזת שנגן שלכם אונליין בקלות. קבלו אישור תוך 15 ימים בלבד מיום הפגישה, והיו מוכנים למסע חלומי ב-29 מדינות שנגן.",
    overview_body1_sri_lanka: "הגישו בקשת ויזה לסרי לנקה בקלות ובנוחות אונליין! קבלו אישור תוך 1-3 ימים ספורים, והיו מוכנים למסע למדינה הקסומה הזו.",
    overview_body1_thailand: "הצטרפו למהפכה הדיגיטלית וקבלו ויזה קצרה (eVisa) או ארוכת טווח (DTV) לתאילנד תוך 3-21 ימים, עם ליווי צמוד ועזרה מטעמנו לאורך כל התהליך.",
    overview_body1_togo: "הוציאו eVisa לטוגו אונליין בקלות. קבלו אישור תוך 1-3 ימים בלבד, והיו מוכנים לצאת למסע מרתק בארץ מיוחדת זו.",
    overview_body1_uk: "אצלנו באתר, השגת אישור נסיעה לבריטניה היא קלי קלות. תשכחו מניירת וביקורים מיותרים בשגרירות: ה-ETA לבריטניה, בתוקף לשנתיים, יגיע ישירות לתיבת הדואר הנכנס שלכם תוך 1-3 ימים.",
    overview_body1_usa: "כאן באתר, הגשת הבקשה ל-ESTA לארה\"ב היא קלה, מהירה ובטוחה. תשכחו מהטפסים המייגעים – אישור ה-ESTA, תקף לשנתיים, יגיע ישירות לתיבת הדואר הנכנס שלכם בתוך 1-3 ימים.",
    overview_body1_vietnam: "קבלו ויזה לווייטנאם אונליין ללא עיכובים וללא סיכון. תיהנו מתהליך מהיר ותקבלו את הוויזה לדוא\"ל תוך 1-7 ימים.",
    overview_body2_bahrain: "בקרו במסגד הגדול והמרהיב אל-פתאח בבחריין.",
    overview_body2_cambodia: "התפעלו מהזריחה עוצרת הנשימה מעל מקדשי אנגקור וואט.",
    overview_body2_canada: "צפו באורורה בוריאליס המדהימה בשמי יוקון.",
    overview_body2_india: "רכבו על פיל בג'איפור והרגישו כמו בני מלוכה.",
    overview_body2_indonesia: "הירגעו בחופים הבתוליים של באלי ואמצו את אווירת האי הקסומה.",
    overview_body2_israel: "טבלו במי הריפוי הייחודיים של ים המלח.",
    overview_body2_korea: "התענגו על תרבות אוכל הרחוב התוססת בשוק מיונגדונג.",
    overview_body2_morocco: "טיילו בשווקים הססגוניים של מרקש והתמקחו כמו מקצוענים.",
    overview_body2_new_zealand: "צאו לטיול בשבילים עוצרי הנשימה של מילפורד סאונד.",
    overview_body2_saudi_arabia: "גלו את הקברים המרהיבים החצובים בסלע של אל-עולה.",
    overview_body2_schengen: "בקרו בארכיטקטורה המדהימה של הסגרדה פמיליה בברצלונה.",
    overview_body2_sri_lanka: "גלו את מטעי התה הירוקים האינסופיים ואת חופי החול הזהובים.",
    overview_body2_thailand: "בקרו בהריסות העתיקות של איוטאיה ושקעו בהיסטוריה התאילנדית המרתקת.",
    overview_body2_togo: "גלו את השווקים התוססים והחופים המדהימים של לומה.",
    overview_body2_uk: "בקרו במגדל לונדון ההיסטורי וחשפו מאות שנים של סודות מלכותיים.",
    overview_body2_usa: "טיילו על גשר שער הזהב האייקוני וספגו את הנופים עוצרי הנשימה של מפרץ סן פרנסיסקו.",
    overview_body2_vietnam: "צאו לשייט חלומי בסירה דרך מערות הגיר המרשימות של מפרץ האלונג.",
    overview_lead_bahrain: "תכשיט של המפרץ הערבי, בחריין מציעה שילוב ייחודי של מודרניות ומסורת, מאדריכלות עתידנית ועד מבצרים עתיקים. היא מזמינה אתכם לגלות את קסמיה.",
    overview_lead_cambodia: "קמבודיה – מדינה קסומה ומרתקת, עם היסטוריה עתיקה ותרבות שוקקת חיים. ממקדשי אנגקור וואט המרהיבים ששומרים סודות עתיקים, ועד לחופים השלווים והג'ונגלים הירוקים, קמבודיה מציעה חוויה אותנטית ובלתי נשכחת לכל מטייל.",
    overview_lead_canada: "קנדה – ארץ רחבת ידיים עם טבע עוצר נשימה, תרבות עשירה ואנשים מסבירי פנים. מהערים התוססות כמו טורונטו וונקובר, ועד להרים המושלגים של הרי הרוקי והאגמים הכחולים, קנדה מציעה אינסוף הרפתקאות ורגעים בלתי נשכחים לכל מי שמגיע אליה.",
    overview_lead_india: "חולמים על טיול בתת-היבשת המרתקת? הודו קוראת לכם עם צבעים, תרבות עשירה, טעמים ייחודיים ונופים עוצרי נשימה. הנפקת ויזה אלקטרונית להודו (e-Visa) מעולם לא הייתה פשוטה יותר!",
    overview_lead_indonesia: "ביתם של החופים השלווים והתרבות העשירה של באלי, אינדונזיה מציעה בריחה קסומה. גלו את שדות האורז המוריקים של אובוד או צללו לתוך שוניות האלמוגים התוססות – אינדונזיה מחכה לכם.",
    overview_lead_israel: "ארץ של היסטוריה נצחית וחדשנות מודרנית. גלו את האתרים הקדושים בירושלים ואת חיי הלילה התוססים של תל אביב – ישראל מזמינה אתכם לחוויה בלתי נשכחת.",
    overview_lead_korea: "דרום קוריאה – ארץ שבה מסורת עתיקה פוגשת טכנולוגיה עתידנית. חקרו את הרחובות ההומים של סיאול, בקרו במקדשים בודהיסטים שלווים ותיהנו מהנופים עוצרי הנשימה של האי ג'ג'ו.",
    overview_lead_morocco: "מרוקו – ארץ של צבעים, ניחוחות וסיפורים, עם היסטוריה עשירה ותרבות מרתקת. מהשווקים התוססים של מרקש ועד למדבר סהרה הקסום, מרוקו מציעה שפע של חוויות בלתי נשכחות שמחכות לכם בכל פינה.",
    overview_lead_new_zealand: "ניו זילנד – ארץ של נופים עוצרי נשימה וטבע פראי במיטבו. מהפיורדים המרשימים ועד לחופים הזהובים, ניו זילנד היא הגשמת חלום עבור כל חובב טבע והרפתקאות.",
    overview_lead_saudi_arabia: "חשפו את המסתורין של ערב הסעודית – ארץ של פלאים עתיקים ופלאים מודרניים כאחד. מהקברים הנבטיים המרשימים של אל-עולה לעיר העתידנית ריאד, סעודיה היא יעד שפשוט אסור לפספס.",
    overview_lead_schengen: "אזור שנגן – השער שלכם לאירופה, מציע שטיח עשיר של תרבויות, שפות ונופים עוצרי נשימה. מהרחובות ההיסטוריים של רומא לתעלות הרומנטיות של ונציה, כל פינה מספרת סיפור וכל עיר מזמינה אתכם לגלותה.",
    overview_lead_sri_lanka: "סרי לנקה – אי טרופי קסום עם תרבות עשירה ונופים מגוונים. ממטעי התה הירוקים האינסופיים ועד לחופים שטופי השמש, סרי לנקה היא פנינה אמיתית שמחכה שתגלו את יופיה.",
    overview_lead_thailand: "תאילנד – ארץ של מקדשים מוזהבים, שווקים תוססים וחופים מדהימים. מההריסות העתיקות של איוטאיה לרחובות ההומים של בנגקוק, יש כל כך הרבה מה לראות ולחוות בארץ החיוכים.",
    overview_lead_togo: "טוגו – פנינה נסתרת במערב אפריקה, מציעה שילוב ייחודי של שווקים תוססים, חופים יפים ומורשת תרבותית עשירה. בואו לגלות את הקסם האפריקאי האותנטי.",
    overview_lead_uk: "הממלכה המאוחדת – מדינה שופעת סיפורים מרתקים, תרבות עשירה ונופים עוצרי נשימה. מנקודות הציון המפורסמות של לונדון ועד ליופי הפראי של ההיילנדס הסקוטיים, הממלכה המאוחדת מציעה פסיפס של חוויות שמחכות שתגלו אותן.",
    overview_lead_usa: "ארצות הברית – ארץ האפשרויות הבלתי מוגבלות. ארה\"ב היא כור היתוך של תרבויות, נופים מגוונים וחוויות יוצאות דופן. מהרחובות ההומים של ניו יורק ועד ליופיו השליו של הגרנד קניון, כל פינה מציעה משהו ייחודי ובלתי נשכח.",
    overview_lead_vietnam: "וייטנאם – שילוב הרמוני של יופי טבעי עוצר נשימה ומורשת תרבותית עשירה. גלו את טרסות האורז השופעות, רחובות האנוי ההומים ומפרץ האלונג השליו – וייטנאם מזמינה אתכם לחוויה בלתי רגילה.",
    overview_menu_label_desktop: "בחרו את היעד שלכם",
    overview_menu_label_mobile: "בחר יעד",
    title: "ויזה.נט Visanet {'|'} ויזות למטייל הישראלי בחו”ל: ארה״ב, הודו, בריטניה ועוד",
    travel_map: "מפת נסיעות"
  },
  homepage: "דף הבית",
  hotel_name: "שם המלון",
  hotel_name_address: "כתובת או שם המלון",
  hourglass: "איור שעון חול",
  icons: {
    bell: "סמל פעמון",
    building: "אייקון בניין גבוה מודרני",
    clam: "פתח צדפה עם סמל פנינה",
    coffee: "סמל כוס קפה",
    elephant: "סמל פיל",
    honey: "בקבוק דבש עם סמל קנדה",
    lawn_mower: "סמל מכסחת דשא",
    meat: "סמל חתיכות בשר",
    raccoon: "אייקון דביבון",
    spider: "סמל עכביש",
    trees: "סמל עצים טרופיים",
    volcano: "סמל הר געש"
  },
  illustation: "המחשה",
  image_upload: "העלאת תמונות",
  image_upload_instructions: "הנחיות להעלאת תמונות",
  image_upload_prefer: "איך תעדיפו לשלוח לנו את התמונות?",
  images: {
    al_fateh_grand_mosque_hero: "מסגד הגדול אל-פתח דגם תלת מימד, eVisa בחריין",
    aling_aling: "מפל אלינג-אלינג, באלי, אינדונזיה",
    angkor: "אנגקור וואט, סיאם ריפ, קמבודיה eVisa",
    angkor_desc: "אנגקור וואט, סיאם ריפ, קמבודיה",
    angkor_hero: "אנגקור וואט דגם תלת מימד, קמבודיה eVisa",
    arugam: "מפרץ ארוגאם, ויזה סרי לנקה",
    arugam_desc: "מפרץ ארוגאם, סרי לנקה",
    bahrain_beach_cta: "דגם תלת מימד של חוף בחריין, eVisa בחריין",
    bahrain_fort: "מבצר בחריין, ויזה אלקטרונית בחריין",
    bahrain_fort_desc: "מבצר בחריין, בחריין",
    bahrain_trade_center: "מרכז הסחר בחריין, מנאמה",
    bahrain_world_trade_center_cta: "מודל תלת מימד של מרכז הסחר העולמי בחריין, eVisa בחריין",
    bali_temple: "מקדש באלי, אינדונזיה",
    balinese_dancer_cta: "דגם תלת מימד של רקדן באלינזי, ויזה אינדונזיה",
    banff: "הפארק הלאומי באנף, קנדה",
    big_ben: "ביג בן, לונדון",
    borobudur: "מקדש בורובודור, ויזה אינדונזיה",
    borobudur_desc: "מקדש בורובודור, אינדונזיה",
    borobudur_hero: "דגם תלת מימד של מקדש בורובודור, ויזה אינדונזיה",
    british_guard_cta: "דגם תלת מימד בריטי גאורד, ETA בבריטניה",
    buddha_statue_cta: "דגם תלת מימד של פסל בודהה, הודו eVisa",
    cambodia_beach_cta: "דגם תלת מימד חוף קמבודיה, קמבודיה eVisa",
    camel_saudi_arabia_cta: "דגם תלת מימד של גמל, ערב הסעודית eVisa",
    casablanca: "קזבלנקה, מרוקו",
    cathedral: "קתדרלה, ירושלים",
    central_park: "סנטרל פארק, ניו יורק",
    chefchaouen: "שפצ'ואן, מרוקו eVisa",
    chefchaouen_cta: "דגם תלת מימד של שפצ'ואן, מרוקו eVisa",
    chefchaouen_desc: "שפצ'ואן, מרוקו",
    clipboard_checkmark: "לוח עם סימן ביקורת",
    clipboard_with_checkmark: "לוח עם סמל תלת מימד של סימן ביקורת",
    "da-nang-bridge": "גשר דה נאנג, וייטנאם",
    dead_sea: "ים המלח, ישראל ETA-IL",
    dead_sea_desc: "ים המלח, ישראל",
    dome_of_the_rock_hero: "כיפת הסלע דגם תלת מימד, ישראל ETA-IL",
    edinburgh_castle: "טירת אדינבורו, בריטניה ETA",
    edinburgh_castle_desc: "טירת אדינבורו, בריטניה",
    eiffel_tower: "מגדל אייפל",
    elephant_sri_lanka_cta: "דגם תלת מימד של פיל, ויזה סרי לנקה",
    goa: "גואה, הודו",
    golden_bridge: "גשר הזהב, ויזת וייטנאם",
    golden_bridge_desc: "גשר הזהב, וייטנאם",
    grand_canyon: "גרנד קניון, ESTA ארה\"ב",
    grand_canyon_desc: "גרנד קניון, ארה\"ב",
    gwanghwamun: "שער גוואנגוואמון, דרום קוריאה",
    gyeongbokgung_hero: "ארמון גיונגבוקגונג, דרום קוריאה KETA",
    ha_long_bay_cta: "דגם תלת מימד של מפרץ הלונג, ויזת וייטנאם",
    handara_gate: "שער הנדרה, באלי, אינדונזיה",
    hanok: "כפר בוקצ'ון האנוק, דרום קוריאה",
    hassan_ii_mosque_hero: "מסגד חסן השני דגם תלת מימד, מרוקו eVisa",
    hisma: "Hisma, ערב הסעודית",
    ho_chi_minh: "הו צ'י מין, וייטנאם",
    hollywood: "הוליווד, לוס אנג'לס",
    itmad: "קבר אטימאד-אוד-דולה, הודו",
    jeju_island: "האי ג'ג'ו, דרום קוריאה KETA",
    jeju_island_desc: "האי ג'ג'ו, דרום קוריאה",
    kokatahi: "קוקטאהי, ניו זילנד NZeTA",
    kokatahi_desc: "קוקטאהי, ניו זילנד",
    korean_warrior_cta: "לוחם קוריאני בלבוש מסורתי דגם תלת מימד, דרום קוריאה KETA",
    "lake-louise": "אגם לואיז, קנדה",
    louvre: "מוזיאון הלובר",
    louvre_desc: "מוזיאון הלובר, פריז",
    madain_saleh: "מדין סאלח, ערב הסעודית eVisa",
    madain_saleh_desc: "מדיין סאלח, ערב הסעודית",
    manhattan_hero: "דגם תלת מימד של מנהטן, ESTA ארה\"ב",
    masjid_al_haram_hero: "מסג'יד אל חראם דגם תלת מימד, ערב הסעודית eVisa",
    masks: "טקס מסכה הינדי, צפון הודו",
    matamata: "מטמטה, ניו זילנד",
    monks: "נזירים קמבודיים, קמבודיה",
    moraine: "אגם מוריין, קנדה",
    new_zealand_landscape_hero: "מודל תלת מימד של נוף ניו זילנד, ניו זילנד NZeTA",
    niagara_falls: "מפלי הניאגרה, קנדה ETA",
    niagara_falls_cta: "דגם תלת מימד מפלי הניאגרה, קנדה ETA",
    niagara_falls_desc: "מפלי הניאגרה, קנדה",
    ninh_binh: "נין בין, וייטנאם",
    notre_dame: "קתדרלת נוטרדאם",
    nuwara: "נוארה אלייה, סרי לנקה",
    passport_icon: "סמל דרכון",
    phi_phi_islands: "איי פי פי, תאילנד",
    phi_phi_islands_desc: "איי פי פי, תאילנד",
    qalat_al_bahrain: "קלאת אל-בחריין, בחריין",
    red_bus_palace_westminster: "אוטובוס אדום, ארמון ווסטמינסטר, לונדון",
    rocking_chair_with_cat_and_laptop: "כסא נדנדה עם חתול ומחשב נייד",
    royal_guard_horse: "המשמר המלכותי, לונדון",
    sigiriya: "סיגיריה, סרי לנקה",
    statue_of_liberty_cta: "פסל החירות דגם תלת מימד, ESTA ארה\"ב",
    taghazout: "טאגאזוט, מרוקו",
    taj_mahal: "טאג' מהאל, הודו eVisa",
    taj_mahal_desc: "טאג' מהאל, הודו",
    taj_mahal_hero: "דגם תלת מימד של טאג' מאהל, הודו eVisa",
    tel_aviv_beach_cta: "חוף תל אביב דגם תלת מימד, ישראל ETA-IL",
    togo_village: "כפר טוגו, טוגו eVisa",
    togo_waterfall: "מפל טוגו, טוגו eVisa",
    togo_waterfall_desc: "מפל מים, טוגו",
    toronto_hero: "טורונטו מודל תלת מימד, קנדה ETA",
    uluwatu_temple: "מקדש אולוואטו דגם תלת מימד, אינדונזיה eVisa",
    unawatuna_beach_hero: "דגם תלת מימד חוף אונוואטונה, ויזה סרי לנקה",
    ushaiqer: "אושייקר, ערב הסעודית",
    vietnam_house_on_beach_hero: "בית וייטנאם על החוף דגם תלת מימד, ויזת וייטנאם",
    wat_chalong: "וואט צ'אלונג, תאילנד"
  },
  images_required_note_face: "תמונת פנים עדכנית.",
  images_required_note_face_pass: "תמונת פנים עדכנית וצילום דרכון.",
  images_required_note_pass: "צילום דרכון.",
  images_required_note_start_bahrain: "מחלקת ההגירה של בחריין דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_cambodia: "מחלקת ההגירה של קמבודיה דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_india: "מחלקת ההגירה של הודו דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_indonesia: "מחלקת ההגירה של אינדונזיה מחייבת כל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_israel: "מחלקת ההגירה בישראל דורשת מכל מי שמגיש בקשה ל-ETA-IL לספק",
  images_required_note_start_korea: "מחלקת ההגירה של דרום קוריאה מחייבת כל מי שמבקש K-ETA לספק",
  images_required_note_start_morocco: "מחלקת ההגירה של מרוקו דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_saudi_arabia: "מחלקת ההגירה של ערב הסעודית דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_schengen: "מחלקת ההגירה של אזור שנגן מחייבת כל מי שמבקש אשרת שנגן לספק",
  images_required_note_start_sri_lanka: "מחלקת ההגירה של סרי לנקה דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_thailand: "מחלקת ההגירה של תאילנד דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_togo: "מחלקת ההגירה של טוגו דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_uk: "מחלקת ההגירה של בריטניה דורשת מכל מי שמבקש ETA בבריטניה לספק",
  images_required_note_start_usa: "מחלקת ההגירה של ארה\"ב דורשת מכל מי שמגיש בקשה ל- ESTA לספק",
  images_required_note_start_vietnam: "מחלקת ההגירה של וייטנאם מחייבת כל מי שמבקש ויזה אלקטרונית לספק",
  india: "הודו",
  india_evisa: "ויזה אלקטרונית להודו",
  india_page: {
    meta_desc: "ויזה להודו לישראלים בעברית, היכנסו לאתר ויזה.נט והתחילו למלא את טופס הויזה האלקטרוני להודו. קבלת וויזה להודו באינטרנט India e-Visa תוך 1-3 ימים, בלי לבקר בשגרירות",
    title: "ויזה להודו אונליין: הוצאת ויזה אלקטרונית להודו באינטרנט {currentYear} {'|'} ויזה.נט"
  },
  india_stay_limit_note: "עבור אזרחויות שאינם ארה\"ב, בריטניה, קנדה ויפן, מגבלת השהייה היא 90 יום.",
  indonesia: "אינדונזיה",
  indonesia_evisa: "ויזה אלקטרונית לאינדונזיה",
  indonesia_page: {
    meta_desc: "הגש בקשה לויזה אלקטרונית לאינדונזיה באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לאינדונזיה ובאלי ויזה נט מקוון {currentYear} {'|'}"
  },
  inside_country: "בתוך {country}",
  islam: "אסלאם",
  israel: "ישראל",
  israel_evisa: "ויזה לישראל ETA-IL",
  israel_page: {
    meta_desc: "אישור ויזה לישראל ETA-IL עבור אזרחי חו״ל בעברית ואנגלית זמין כעת. היכנסו לאתר ויזהנט והתחילו למלא את טופס הויזה האלקטרונית לישראל. קבלת וויזה באינטרנט תוך 1-3 ימים",
    title: "ויזה לישראל ETA-IL הוצאת אישור ויזה לישראל אונליין {currentYear} {'|'} ויזה.נט"
  },
  job_seniority: "שנות ותק",
  judaism: "יהדות",
  kid: "(ילד)",
  kid_visa_price: "מחיר ויזה לילדים:",
  korea: "דרום קוריאה",
  korea_accompanying_children_info: "ילדים בגילאי 0-17 אינם זקוקים ל- K-ETA כדי להיכנס לדרום קוריאה אם הם מלווים בהורה. אם ילדיכם מצטרפים לטיול שלכם, אנא הוסיפו אותם למטה.",
  korea_evisa: "ויזה לדרום קוריאה K-ETA",
  korea_page: {
    meta_desc: "ויזה לדרום קוריאה עבור ישראלים, טופס אישור נסיעה K-ETA בעברית. ויזה אלקטרונית רשמית לקוריאה הדרומית תוך 1-3 ימים בלבד, בלי לבקר בקונסוליה או לצאת מהבית - מעודכן",
    title: "ויזה לדרום קוריאה: ישראלים יכולים לקבל ויזה K-ETA אונליין {currentYear} {'|'} ויזה.נט"
  },
  landport: "גבול יבשתי",
  languages: {
    en: "אנגלית",
    he: "עברית",
    ru: "רוסית",
    sv: "שוודית"
  },
  last_name: "שם משפחה",
  last_travel: {
    country: "מהי המדינה האחרונה בה ביקרת?",
    from: "החל מ-",
    traveled: "האם אי פעם נסעת לחו\"ל?",
    until: "עד"
  },
  last_visa_issue_date: "תאריך הנפקת ויזה קודמת",
  link_copied: "קישור הועתק",
  link_send: "שלח את הקישור",
  link_sent: "הקישור נשלח בהצלחה",
  link_validity_time: "הקישור תקף למשך 30 יום בלבד. אנא חזרו ומלאו את הטופס במסגרת הזמן.",
  male: "זכר",
  marital: {
    divorced: "גרוש/ה",
    married: "נשוי/אה",
    single: "רווק/ה",
    widowed: "אלמן/ה"
  },
  marital_status: "מצב משפחתי",
  may_resume: "אתם יכולים להמשיך את הטופס מהנקודה בה עצרתם",
  may_use_phone_camera: "מותר להשתמש במצלמה של הטלפון.",
  medical_insurance_included: "הביטוח הרפואי הנדרש כבר כלול במחיר הויזה שלנו.",
  military_rank: "דרגה",
  military_ranks: {
    corporal: "רב\"ט",
    nco: "נגד",
    officer: "קצין",
    "private": "טוראי",
    sergeant: "סמל",
    staff_sergeant: "סמל ראשון"
  },
  military_roles: {
    fighter: "לחימה",
    office: "יתר (ג'ובניק)",
    support: "תמיכה"
  },
  military_service: "שירות צבאי",
  military_service_type: "סוג השירות",
  mobile_payment: {
    header: "הוראות תשלום נייד",
    instruction_1: "פתחו האפליקציה והעבירו את הסכום:",
    instruction_2: "שלחו את התשלום למספר {0}",
    phone_hint: "לאימות - מספר הטלפון ממנו בוצעה ההעברה",
    phone_label: "הטלפון של השולח",
    proceed: "אישור תשלום",
    transfer_id: "מספר העברה",
    transfer_id_hint: "מספר האישור המוצג באפליקציה לאחר השלמת התשלום"
  },
  month: "חודש",
  morocco: "מרוקו",
  morocco_evisa: "ויזה למרוקו",
  morocco_page: {
    meta_desc: "ויזה למרוקו לישראלים, היכנסו עכשיו ל-ויזה.נט והתחילו למלא את טופס הויזה האלקטרונית למרוקו בעברית. קבלת ויזה מרוקו דיגיטלית מהר ובצורה מאובטחת, בלי לבקר בשגרירות",
    title: "ויזה למרוקו אונליין: הוצאת ויזה אלקטרונית מרוקו באינטרנט {currentYear} ויזה.נט"
  },
  mother_country: "ארץ הלידה של האם",
  mother_name: "שם האם",
  msg_contact: "הודעה - צור קשר",
  nationality: "אזרחות",
  nav: {
    blog: "בלוג חדשות",
    cta_bahrain: "טופס ויזה אלקטרונית לבחריין",
    cta_cambodia: "טופס ויזה אלקטרונית לקמבודיה",
    cta_canada: "טופס eTA לקנדה",
    cta_home: "מילוי טופס ויזה",
    cta_india: "טופס ויזה אלקטרונית להודו",
    cta_indonesia: "טופס ויזה אלקטרונית לאינדונזיה",
    cta_israel: "טופס ETA-IL לישראל",
    cta_korea: "טופס K-ETA לדרום קוריאה",
    cta_morocco: "טופס ויזה אלקטרונית למרוקו",
    cta_new_zealand: "טופס NZeTA לניו זילנד",
    cta_saudi_arabia: "טופס ויזה אלקטרונית לערב הסעודית",
    cta_schengen: "טופס ויזת שנגן",
    cta_sri_lanka: "טופס ויזה אלקטרונית לסרי לנקה",
    cta_thailand: "טופס ויזה אלקטרונית לתאילנד",
    cta_togo: "טופס ויזה אלקטרונית לטוגו",
    cta_uk: "טופס UK-ETA לבריטניה",
    cta_usa: "טופס ESTA לארה\"ב",
    cta_vietnam: "טופס ויזה אלקטרונית לווייטנאם",
    visa_country_select: {
      label: "ויזות אלקטרוניות",
      option_bahrain: "ויזה אלקטרונית לבחריין",
      option_cambodia: "ויזה לקמבודיה",
      option_canada: "ויזה eTA לקנדה",
      option_india: "ויזה להודו",
      option_indonesia: "ויזה אלקטרונית לאינדונזיה",
      option_israel: "ויזה ETA-IL לישראל",
      option_korea: "ויזה K-ETA לדרום קוריאה",
      option_morocco: "ויזה למרוקו",
      option_new_zealand: "ויזה NZeTA לניו זילנד",
      option_saudi_arabia: "eVisa לערב הסעודית",
      option_schengen: "ויזת שנגן",
      option_sri_lanka: "ויזה לסרי לנקה",
      option_thailand: "ויזה לתאילנד",
      option_togo: "ויזה אלקטרונית לטוגו",
      option_uk: "ויזה לאנגליה ETA",
      option_usa: "ויזה לארה\"ב ESTA",
      option_vietnam: "ויזה לויאטנם"
    },
    visa_status: "ההזמנה שלי"
  },
  "new": "חדש",
  new_zealand: "ניו זילנד",
  new_zealand_evisa: "ויזה לניו זילנד NZeTA",
  new_zealand_page: {
    meta_desc: "הוצאת ויזה אלקטרונית לניו זילנד, היכנסו עכשיו והתחילו למלא את טופס ה-NZeTA און ליין, בהליך מאובטח בעברית. הנפקת אשרת כניסה לניו-זילנד ב-{currentYear} בלי לבקר בשגרירות",
    title: "ויזה אלקטרונית לניו זילנד אונליין: אשרת כניסה לניו זילנד NZeTA"
  },
  next: "הבא",
  next_day: "יום העסקים הבא",
  no: "לא",
  num_entries: "כמות כניסות:",
  occupation: "עיסוק",
  order_email_after_payment: "לאחר אישור התשלום, תקבלו אישור בדוא\"ל על ההזמנה וקבלה על התשלום.",
  order_summary: "סיכום הזמנה",
  other: "אחר",
  our_payment_methods: "טופס בקשת הויזה מוכן ונשמר במערכת. כדי לסיים את ההזמנה, אנא בצעו תשלום מאובטח:",
  page: {
    about: "אודות ויזה.נט",
    contact: "יצירת קשר",
    country_flag: "דגל המדינה",
    features: {
      "1_body_bahrain": "שכחו מביקורים בשגרירות ומערימות ניירת. הטופס המקוון שלנו פשוט ויעיל, והאישור האלקטרוני שלכם יישלח למייל תוך ימים ספורים בלבד.",
      "1_body_cambodia": "שכחו מביקורים בשגרירות ומערימות ניירת. הטופס המקוון שלנו פשוט ויעיל, והאישור האלקטרוני שלכם יישלח למייל תוך ימים ספורים בלבד.",
      "1_body_canada": "ללא תורים, ללא ביקורים בשגרירות – רק טופס מקוון פשוט. קבלו את ה-eTA המאושר ישירות לתיבת המייל שלכם תוך ימים ספורים.",
      "1_body_home": "הגישו בקשה בכל עת ובכל מקום. קבלו את הוויזה האלקטרונית המאושרת שלכם ישירות לתיבת המייל – נוח, מהיר ובמחיר משתלם.",
      "1_body_india": "דלגו על הביקור בשגרירות. הגישו בקשה אונליין תוך דקות בודדות, וקבלו את הוויזה האלקטרונית שלכם ישירות למייל תוך 1-3 ימים – מהיר, נוח וללא טרחה.",
      "1_body_indonesia": "שכחו מביקורים בשגרירות ומערימות ניירת. הטופס המקוון שלנו פשוט ויעיל, והאישור האלקטרוני שלכם יישלח למייל תוך ימים ספורים בלבד.",
      "1_body_israel": "ללא תורים, ללא ביקורים בשגרירות – רק טופס מקוון פשוט. קבלו את ה-ETA-IL המאושר ישירות לתיבת המייל שלכם תוך ימים ספורים.",
      "1_body_korea": "ללא תורים, ללא ביקורים בשגרירות – רק טופס מקוון פשוט. קבלו את ה-K-ETA המאושר ישירות לתיבת המייל שלכם תוך ימים ספורים.",
      "1_body_morocco": "שכחו מביקורים בשגרירות ומערימות ניירת. הטופס המקוון שלנו פשוט ויעיל, והאישור האלקטרוני שלכם יישלח למייל תוך ימים ספורים בלבד.",
      "1_body_new_zealand": "ללא תורים, ללא ביקורים בשגרירות – רק טופס מקוון פשוט. קבלו את ה-NZeTA המאושר ישירות לתיבת המייל שלכם תוך ימים ספורים.",
      "1_body_saudi_arabia": "דלגו על הביקור בשגרירות. הגישו בקשה אונליין תוך דקות בודדות, וקבלו את הוויזה האלקטרונית שלכם ישירות למייל תוך 1-3 ימים – מהיר, נוח וללא טרחה.",
      "1_body_schengen": "ללא תורים, ללא ביקורים בשגרירות – רק טופס מקוון פשוט. קבלו את אשרת שנגן המאושרת במהירות ובקלות.",
      "1_body_sri_lanka": "מלאו את טופס הבקשה לוויזה אלקטרונית ישירות באתר שלנו, אין צורך לשלוח מסמכים פיזיים או להגיע לשגרירות. תוך 1-2 ימים תקבלו את הוויזה האלקטרונית המאושרת שהזמנתם ישירות למייל שלכם, ובמחיר המשתלם ביותר.",
      "1_body_thailand": "ללא תורים, ללא ביקורים בשגרירות – רק טופס מקוון פשוט. קבלו את הוויזה האלקטרונית המאושרת שלכם ישירות לתיבת המייל תוך ימים ספורים.",
      "1_body_togo": "ללא תורים, ללא ביקורים בשגרירות – רק טופס מקוון פשוט. קבלו את הוויזה האלקטרונית המאושרת שלכם ישירות לתיבת המייל תוך ימים ספורים.",
      "1_body_uk": "ללא תורים, ללא ביקורים בשגרירות – רק טופס מקוון פשוט. קבלו את ETA בריטניה המאושר ישירות לתיבת המייל שלכם תוך ימים ספורים.",
      "1_body_usa": "ללא תורים, ללא ביקורים בשגרירות – רק טופס מקוון פשוט. קבלו את ה-ESTA המאושר ישירות לתיבת המייל שלכם תוך ימים ספורים.",
      "1_body_vietnam": "דלגו על הביקור בשגרירות. הגישו בקשה אונליין תוך דקות בודדות, וקבלו את הוויזה האלקטרונית שלכם ישירות למייל תוך 1-7 ימים – מהיר, נוח וללא טרחה.",
      "1_title_bahrain": "תהליך מהיר ויעיל",
      "1_title_cambodia": "תהליך מהיר ויעיל",
      "1_title_canada": "תהליך מהיר ויעיל",
      "1_title_home": "תהליך קל ומהיר",
      "1_title_india": "תהליך מהיר ופשוט",
      "1_title_indonesia": "תהליך מהיר ויעיל",
      "1_title_israel": "תהליך מהיר ויעיל",
      "1_title_korea": "תהליך מהיר ויעיל",
      "1_title_morocco": "תהליך מהיר ויעיל",
      "1_title_new_zealand": "תהליך מהיר ויעיל",
      "1_title_saudi_arabia": "תהליך מהיר ופשוט",
      "1_title_schengen": "תהליך מהיר ויעיל",
      "1_title_sri_lanka": "תהליך מהיר ופשוט",
      "1_title_thailand": "תהליך מהיר ויעיל",
      "1_title_togo": "תהליך מהיר ויעיל",
      "1_title_uk": "תהליך מהיר ויעיל",
      "1_title_usa": "תהליך מהיר ויעיל",
      "1_title_vietnam": "תהליך מהיר ופשוט",
      "2_body_bahrain": "תהנו משקט נפשי בידיעה שאנו עומדים מאחורי השירות שלנו. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_cambodia": "תהנו משקט נפשי בידיעה שאנו עומדים מאחורי השירות שלנו. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_canada": "אפשר לישון בשקט - אנחנו תמיד זמינים בשבילכם ונותנים שירות מעולה. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_home": "ההצלחה מדברת בעד עצמה: עשרות אלפי מטיילים קיבלו שירות מעל ומעבר, תמיד עם 100% הצלחה או החזר כספי מלא.",
      "2_body_india": "תהנו משקט נפשי בזכות הבטחת ההחזר הכספי שלנו. אם בקשתכם תידחה, נתקן אותה או נספק לכם החזר כספי מלא.",
      "2_body_indonesia": "תהנו משקט נפשי בידיעה שאנו עומדים מאחורי השירות שלנו. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_israel": "אפשר לישון בשקט - אנחנו תמיד זמינים בשבילכם ונותנים שירות מעולה. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_korea": "אפשר לישון בשקט - אנחנו תמיד זמינים בשבילכם ונותנים שירות מעולה. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_morocco": "תהנו משקט נפשי בידיעה שאנו עומדים מאחורי השירות שלנו. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_new_zealand": "אפשר לישון בשקט - אנחנו תמיד זמינים בשבילכם ונותנים שירות מעולה. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_saudi_arabia": "תהנו משקט נפשי בזכות הבטחת ההחזר הכספי שלנו. אם בקשתכם תידחה, נתקן אותה או נספק לכם החזר כספי מלא.",
      "2_body_schengen": "תהנו משקט נפשי בזכות הבטחת ההחזר הכספי שלנו. אם בקשתכם תידחה, נתקן אותה או נספק לכם החזר כספי מלא.",
      "2_body_sri_lanka": "תהנו משקט נפשי בזכות הבטחת ההחזר הכספי שלנו. אם בקשתכם תידחה, נתקן אותה או נספק לכם החזר כספי מלא.",
      "2_body_thailand": "אפשר לישון בשקט - אנחנו תמיד זמינים בשבילכם ונותנים שירות מעולה. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_togo": "אפשר לישון בשקט - אנחנו תמיד זמינים בשבילכם ונותנים שירות מעולה. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_uk": "אפשר לישון בשקט - אנחנו תמיד זמינים בשבילכם ונותנים שירות מעולה. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_usa": "אפשר לישון בשקט - אנחנו תמיד זמינים בשבילכם ונותנים שירות מעולה. אם בקשתכם תידחה, נתקן אותה או ניתן לכם החזר כספי מלא.",
      "2_body_vietnam": "תהנו משקט נפשי בזכות הבטחת ההחזר הכספי שלנו. אם בקשתכם תידחה, נתקן אותה או נספק לכם החזר כספי מלא.",
      "2_title_bahrain": "הצלחה או החזר מלא",
      "2_title_cambodia": "הצלחה או החזר מלא",
      "2_title_canada": "הצלחה או החזר מלא",
      "2_title_home": "שקט נפשי מובטח",
      "2_title_india": "הצלחה או החזר מלא",
      "2_title_indonesia": "הצלחה או החזר מלא",
      "2_title_israel": "הצלחה או החזר מלא",
      "2_title_korea": "הצלחה או החזר מלא",
      "2_title_morocco": "הצלחה או החזר מלא",
      "2_title_new_zealand": "הצלחה או החזר מלא",
      "2_title_saudi_arabia": "הצלחה או החזר מלא",
      "2_title_schengen": "הצלחה או החזר מלא",
      "2_title_sri_lanka": "הצלחה או החזר מלא",
      "2_title_thailand": "הצלחה או החזר מלא",
      "2_title_togo": "הצלחה או החזר מלא",
      "2_title_uk": "הצלחה או החזר מלא",
      "2_title_usa": "הצלחה או החזר מלא",
      "2_title_vietnam": "הצלחה או החזר מלא",
      "3_body_bahrain": "מאז 2019, סייענו לאינספור מטיילים ברחבי העולם. צרו איתנו קשר בכל עת – דרך <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_cambodia": "מאז 2019, סייענו לאינספור מטיילים ברחבי העולם. צרו איתנו קשר בכל עת – דרך <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_canada": "מאז 2019, עזרנו לאינספור מטיילים לקבל את ה-ETA שלהם בקלות ובמהירות. הצוות הרב-לשוני שלנו זמין לסייע לכם בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_home": "דרך צ'אט, דוא\"ל, אפליקציות טלפון והודעות – הצוות הידידותי שלנו עומד לשירותכם לפני, במהלך ואחרי הטיול שלכם.",
      "3_body_india": "מאז 2019, סייענו לעשרות אלפי מטיילים. הצוות שלנו זמין יום ולילה באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_indonesia": "מאז 2019, סייענו לאינספור מטיילים ברחבי העולם. צרו איתנו קשר בכל עת – דרך <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_israel": "מאז 2019, עזרנו לאינספור מטיילים לקבל את ה-ETA שלהם בקלות ובמהירות. הצוות הרב-לשוני שלנו זמין לסייע לכם בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_korea": "מאז 2019, עזרנו לאינספור מטיילים לקבל את ה-ETA שלהם בקלות ובמהירות. הצוות הרב-לשוני שלנו זמין לסייע לכם בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_morocco": "מאז 2019, סייענו לאינספור מטיילים ברחבי העולם. צרו איתנו קשר בכל עת – דרך <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_new_zealand": "מאז 2019, עזרנו לאינספור מטיילים לקבל את ה-NZeTA שלהם בקלות ובמהירות. הצוות הרב-לשוני שלנו זמין לסייע לכם בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_saudi_arabia": "מאז 2019, סייענו לעשרות אלפי מטיילים. הצוות שלנו זמין יום ולילה באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_schengen": "מאז 2019, סייענו לעשרות אלפי מטיילים. הצוות שלנו זמין יום ולילה באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_sri_lanka": "מאז 2019, סייענו לעשרות אלפי מטיילים. הצוות שלנו זמין יום ולילה באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_thailand": "מאז 2019, עזרנו לאינספור מטיילים לקבל את הוויזה האלקטרונית שלהם בקלות ובמהירות. הצוות הרב-לשוני שלנו זמין לסייע לכם בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_togo": "מאז 2019, עזרנו לאינספור מטיילים לקבל את הוויזה האלקטרונית שלהם בקלות ובמהירות. הצוות הרב-לשוני שלנו זמין לסייע לכם בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_uk": "מאז 2019, עזרנו לאינספור מטיילים לקבל את ה-ETA שלהם בקלות ובמהירות. הצוות הרב-לשוני שלנו זמין לסייע לכם בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_usa": "מאז 2019, עזרנו לאינספור מטיילים לקבל את ה-ESTA שלהם בקלות ובמהירות. הצוות הרב-לשוני שלנו זמין לסייע לכם בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_body_vietnam": "מאז 2019, סייענו לעשרות אלפי מטיילים. הצוות שלנו זמין יום ולילה באמצעות <a href=\"{whatsapp}\" target=\"_blank\">ווטסאפ</a>, <a {chat_opener}>צ'אט חי</a>, <a href=\"mailto:{email}\" target=\"_blank\">דוא\"ל</a> ו<a href=\"tel:{phone}\">טלפון</a>.",
      "3_title_bahrain": "שירות לקוחות מקצועי 24/7",
      "3_title_cambodia": "שירות לקוחות מקצועי 24/7",
      "3_title_canada": "תמיכה מקצועית 24/7",
      "3_title_home": "תמיכה ייעודית מסביב לשעון",
      "3_title_india": "תמיכה מקצועית 24/7",
      "3_title_indonesia": "שירות לקוחות מקצועי 24/7",
      "3_title_israel": "תמיכה מקצועית 24/7",
      "3_title_korea": "תמיכה מקצועית 24/7",
      "3_title_morocco": "שירות לקוחות מקצועי 24/7",
      "3_title_new_zealand": "תמיכה מקצועית 24/7",
      "3_title_saudi_arabia": "תמיכה מקצועית 24/7",
      "3_title_schengen": "תמיכה מקצועית 24/7",
      "3_title_sri_lanka": "תמיכה מקצועית 24/7",
      "3_title_thailand": "תמיכה מקצועית 24/7",
      "3_title_togo": "תמיכה מקצועית 24/7",
      "3_title_uk": "תמיכה מקצועית 24/7",
      "3_title_usa": "תמיכה מקצועית 24/7",
      "3_title_vietnam": "תמיכה מקצועית 24/7",
      open_passports_img: "דרכונים פתוחים",
      socials_body_bahrain: "זקוקים לעזרה, עדכונים או טיפים לטיול? <a href='/contact'>פנו אלינו</a> או עקבו אחרינו ברשתות החברתיות. אנו מחויבים להפוך את תהליך הוויזה שלכם לפשוט וקל, מתחילתו ועד סופו.",
      socials_body_cambodia: "זקוקים לעזרה, עדכונים או טיפים לטיול? <a href='/contact'>פנו אלינו</a> או עקבו אחרינו ברשתות החברתיות. אנו מחויבים להפוך את תהליך הוויזה שלכם לפשוט וקל, מתחילתו ועד סופו.",
      socials_body_canada: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צרו קשר</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים ולהפוך את תכנון הנסיעות שלכם לקל ונוח יותר.",
      socials_body_home: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צרו קשר</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים ולהפוך את תכנון הנסיעות שלכם לקל ונוח יותר.",
      socials_body_india: "יש לכם שאלה או שאתם זקוקים לעזרה? <a href='/contact'>פנו אלינו</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים.",
      socials_body_indonesia: "זקוקים לעזרה, עדכונים או טיפים לטיול? <a href='/contact'>פנו אלינו</a> או עקבו אחרינו ברשתות החברתיות. אנו מחויבים להפוך את תהליך הוויזה שלכם לפשוט וקל, מתחילתו ועד סופו.",
      socials_body_israel: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צרו קשר</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים ולהפוך את תכנון הנסיעות שלכם לקל ונוח יותר.",
      socials_body_korea: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צרו קשר</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים ולהפוך את תכנון הנסיעות שלכם לקל ונוח יותר.",
      socials_body_morocco: "זקוקים לעזרה, עדכונים או טיפים לטיול? <a href='/contact'>פנו אלינו</a> או עקבו אחרינו ברשתות החברתיות. אנו מחויבים להפוך את תהליך הוויזה שלכם לפשוט וקל, מתחילתו ועד סופו.",
      socials_body_new_zealand: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צרו קשר</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים ולהפוך את תכנון הנסיעות שלכם לקל ונוח יותר.",
      socials_body_saudi_arabia: "יש לכם שאלה או שאתם זקוקים לעזרה? <a href='/contact'>פנו אלינו</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים.",
      socials_body_schengen: "יש לכם שאלה או שאתם זקוקים לעזרה? <a href='/contact'>פנו אלינו</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים.",
      socials_body_sri_lanka: "יש לכם שאלה או שאתם זקוקים לעזרה? <a href='/contact'>פנו אלינו</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים.",
      socials_body_thailand: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צרו קשר</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים ולהפוך את תכנון הנסיעות שלכם לקל ונוח יותר.",
      socials_body_togo: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צרו קשר</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים ולהפוך את תכנון הנסיעות שלכם לקל ונוח יותר.",
      socials_body_uk: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צרו קשר</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים ולהפוך את תכנון הנסיעות שלכם לקל ונוח יותר.",
      socials_body_usa: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צרו קשר</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים ולהפוך את תכנון הנסיעות שלכם לקל ונוח יותר.",
      socials_body_vietnam: "יש לכם שאלה או שאתם זקוקים לעזרה? <a href='/contact'>פנו אלינו</a> או עקבו אחרינו ברשתות החברתיות כדי להישאר מעודכנים.",
      why_evisa_desc_bahrain: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לבחריין ולקבל את אישור הוויזה למייל שלכם תוך 3-5 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם לבחריין.",
      why_evisa_desc_cambodia: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לקמבודיה ולקבל את אישור הוויזה למייל שלכם תוך 3-5 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם לקמבודיה, בתוקף למשך 30 יום.",
      why_evisa_desc_canada: "באתר שלנו תוכלו להגיש בקשה ל-eTA לקנדה ולקבל את אישור הנסיעה למייל שלכם תוך 1-2 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים או לבקר בשגרירות, וקבלו את ה-eTA הרשמי שלכם לקנדה, בתוקף לחמש שנים.",
      why_evisa_desc_home: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית למדינות שונות ולקבל את אישור הוויזה למייל שלכם תוך מספר ימים. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את אשרת הכניסה הרשמית שלכם.",
      why_evisa_desc_india: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית להודו ולקבל את אישור הוויזה למייל שלכם תוך 1-3 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם להודו, בתוקף בין 30 יום לחמש שנים.",
      why_evisa_desc_indonesia: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לאינדונזיה ולקבל את אישור הוויזה למייל שלכם תוך 1-3 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם לאינדונזיה, בתוקף למשך 60 יום.",
      why_evisa_desc_israel: "באתר שלנו תוכלו להגיש בקשה ל-ETA-IL לישראל ולקבל את אישור הנסיעה למייל שלכם תוך 1-2 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים או לבקר בשגרירות, וקבלו אישור נסיעה אלקטרוני רשמי לישראל בתוקף לשנתיים.",
      why_evisa_desc_korea: "באתר שלנו תוכלו להגיש בקשה ל-K-ETA לדרום קוריאה ולקבל את אישור הנסיעה למייל שלכם תוך 1-3 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את ה-K-ETA הרשמי שלכם לדרום קוריאה, בתוקף לשנתיים.",
      why_evisa_desc_morocco: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית למרוקו ולקבל את אישור הוויזה למייל שלכם תוך 1-5 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם למרוקו, בתוקף למשך 180 יום.",
      why_evisa_desc_new_zealand: "באתר שלנו תוכלו להגיש בקשה ל-NZeTA לניו זילנד ולקבל את אישור הנסיעה למייל שלכם תוך 1-2 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את ה-NZeTA הרשמי שלכם לניו זילנד, בתוקף לשנתיים.",
      why_evisa_desc_saudi_arabia: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לסעודיה ולקבל את אישור הוויזה למייל שלכם תוך 1-2 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם לסעודיה, בתוקף למשך 180 יום.",
      why_evisa_desc_schengen: "באתר שלנו תוכלו להגיש בקשה לוויזת שנגן ולקבל את אישור הוויזה למייל שלכם תוך 1-3 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את ויזת השנגן הרשמית שלכם, בתוקף לתשעים יום.",
      why_evisa_desc_sri_lanka: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לסרי לנקה ולקבל את אישור הוויזה למייל שלכם תוך 1-2 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם לסרי לנקה, בתוקף למשך 30 יום.",
      why_evisa_desc_thailand: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לתאילנד ולקבל את אישור הוויזה למייל שלכם תוך 1-3 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם לתאילנד, בתוקף למשך 90 יום עד חמש שנים.",
      why_evisa_desc_togo: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לטוגו ולקבל את אישור הוויזה למייל שלכם תוך 1-3 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם לטוגו, בתוקף למשך 15 יום עד 90 יום.",
      why_evisa_desc_uk: "באתר שלנו תוכלו להגיש בקשה ל-ETA לבריטניה ולקבל את אישור הנסיעה למייל שלכם תוך 1-3 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את ה-ETA הרשמי שלכם לבריטניה, בתוקף לשישה חודשים.",
      why_evisa_desc_usa: "באתר שלנו תוכלו להגיש בקשה ל-ESTA לארה\"ב ולקבל את אישור הנסיעה למייל שלכם תוך 1-3 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים או לבקר בשגרירות, וקבלו את ה-ESTA הרשמי שלכם לארה\"ב, בתוקף לשנתיים.",
      why_evisa_desc_vietnam: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לווייטנאם ולקבל את אישור הוויזה למייל שלכם תוך 4-5 ימים בלבד. מלאו טופס בקשה מהיר וקל, בצורה מאובטחת אונליין, ללא צורך לשלוח מסמכים פיזיים כלשהם או לבקר בשגרירות, וקבלו את הוויזה האלקטרונית הרשמית שלכם לווייטנאם, בתוקף למשך 90 יום.",
      why_title_bahrain: "למה לקבל את הוויזה שלכם לבחריין אונליין",
      why_title_cambodia: "למה כדאי להזמין ויזה באתר ויזה.נט?",
      why_title_canada: "למה כדאי להזמין eTA באתר ויזה.נט?",
      why_title_home: "למה כדאי להזמין ויזה דרך ויזה נט?",
      why_title_india: "למה כדאי להזמין ויזה להודו באתר ויזה.נט?",
      why_title_indonesia: "למה לקבל את הוויזה האלקטרונית שלכם לאינדונזיה אונליין",
      why_title_israel: "למה כדאי להזמין ויזה באתר ויזה.נט?",
      why_title_korea: "למה כדאי להזמין KETA באתר ויזה.נט?",
      why_title_morocco: "למה כדאי להזמין באתר ויזה.נט?",
      why_title_new_zealand: "למה כדאי להזמין באתר ויזה.נט?",
      why_title_saudi_arabia: "למה לקבל את הוויזה שלכם לסעודיה אונליין עם ויזה נט?",
      why_title_schengen: "למה לקבל את ויזת השנגן שלכם אונליין",
      why_title_sri_lanka: "למה כדאי להזמין ויזה באתר ויזה.נט?",
      why_title_thailand: "למה כדאי להזמין ויזה לתאילנד באתר ויזה.נט?",
      why_title_togo: "למה לקבל את הוויזה שלכם לטוגו אונליין",
      why_title_uk: "למה כדאי להזמין ETA באתר ויזה.נט?",
      why_title_usa: "למה כדאי להזמין ESTA באתר ויזה.נט?",
      why_title_vietnam: "למה כדאי להזמין באתר ויזה.נט?"
    },
    form_title_bahrain: "טופס ויזה אלקטרונית לחריין",
    form_title_cambodia: "טופס ויזה אלקטרונית לקמבודיה",
    form_title_canada: "טופס אישור ויזה לקנדה ETA",
    form_title_india: "טופס ויזה להודו",
    form_title_indonesia: "טופס ויזה אלקטרונית לאינדונזיה",
    form_title_israel: "טופס ויזה לישראל ETA-IL",
    form_title_korea: "טופס ויזה לדרום קוריאה K-ETA",
    form_title_morocco: "טופס ויזה למרוקו",
    form_title_new_zealand: "טופס ויזה לניו זילנד",
    form_title_saudi_arabia: "טופס ויזה אלקטרוני של ערב הסעודית",
    form_title_schengen: "טופס ויזת שנגן",
    form_title_sri_lanka: "טופס ויזה לסרי לנקה",
    form_title_thailand: "טופס ויזה לתאילנד",
    form_title_togo: "טוגו טופס ויזה אלקטרונית",
    form_title_uk: "טופס ויזה לבריטניה ואנגליה",
    form_title_usa: "טופס ויזה לארצות הברית",
    form_title_vietnam: "טופס ויזה לויאטנם",
    get_visa_cta_bahrain: "קבלו את הויזה שלכם לבחריין",
    get_visa_cta_cambodia: "לחצו לקבלת ויזה לקמבודיה",
    get_visa_cta_canada: "לחצו לקבלת ויזה לקנדה",
    get_visa_cta_india: "לחצו לקבלת ויזה להודו",
    get_visa_cta_indonesia: "קבלו את האישור האלקטרוני שלכם לאינדונזיה",
    get_visa_cta_israel: "לחצו לקבלת ויזה לישראל",
    get_visa_cta_korea: "לחצו לקבלת ויזה לדרום קוריאה",
    get_visa_cta_morocco: "לחצו לקבלת ויזה למרוקו",
    get_visa_cta_new_zealand: "לחצו לקבלת ויזה לניו זילנד",
    get_visa_cta_saudi_arabia: "קבלו את הויזה שלכם לערב הסעודית",
    get_visa_cta_schengen: "קבלו את אשרת שנגן שלכם",
    get_visa_cta_sri_lanka: "לחצו לקבלת ויזה לסרי לנקה",
    get_visa_cta_thailand: "לחצו לקבלת ויזה לתאילנד",
    get_visa_cta_togo: "קבלו את הוויזה שלכם לטוגו",
    get_visa_cta_uk: "לחצו לקבלת ויזה לבריטניה",
    get_visa_cta_usa: "קבלו את ה-ESTA שלכם לארה\"ב",
    get_visa_cta_vietnam: "קבלו את הוויזה שלכם לווייטנאם",
    hero_body_bahrain: "הגישו בקשה מקוונת תוך דקות וקבלו את הוויזה הרשמית שלכם לבחריין ישירות למייל – בלי טרטורים או צורך לבקר בשגרירות. עם תמיכה 24/7 ואחריות הצלחה מלאה, אנחנו נפשט לכם את הדרך להתחיל את ההרפתקה בבחריין.",
    hero_body_cambodia: "הנפקת ויזה אלקטרונית לקמבודיה — טופס פשוט בעברית, קבלת אשרה רשמית תוך 3-5 ימים ישירות לאימייל, החל מ-{price}!",
    hero_body_canada: "הוצאת אישור ויזה לקנדה תוך 1-3 ימים, הגשת טופס אונליין קצר בעברית, בתהליך פשוט ונוח, הנפקת ויזה רשמית באינטרנט, בלי לבקר בשגרירות.",
    hero_body_home: "ברוכים הבאים לויזה.נט — האתר המוביל בישראל להנפקת ויזות אלקטרוניות: <a href=\"/india\">ויזה להודו</a>, <a href=\"/us\">ויזה לארה״ב</a>, <a href=\"/uk\">ויזה לאנגליה</a>, <a href=\"/vietnam\">ויזה לויאטנם</a>, <a href=\"/morocco\">ויזה למרוקו</a>, <a href=\"/canada\">ויזה לקנדה</a>, <a href=\"/israel\">ויזה לישראל</a> ועוד מגוון יעדים. הגשת טופס ויזה אונליין, בתהליך פשוט, קצר ומאובטח, במחיר הוגן וללא צורך לבקר בשגרירות.",
    hero_body_india: "הוצאת ויזה להודו תוך 1-3 ימים, החל מ-{price}<br>הגשת טופס אונליין קצר בעברית, בתהליך פשוט ונוח, הנפקת ויזה רשמית באינטרנט, בלי לבקר בשגרירות.",
    hero_body_indonesia: "הגישו בקשה מקוונת תוך דקות וקבלו את הוויזה שלכם לאינדונזיה – בלי צורך בביקורים בשגרירות. בין אם אתם מתכננים חופשה רגועה בבאלי או הרפתקה ברחבי אינדונזיה, תיהנו מתמיכה 24/7 ומהבטחת הצלחה מלאה לטיול נטול דאגות.",
    hero_body_israel: "הוצאת ויזה לישראל תוך 1-3 ימים, ב-{price}<br> הגשת טופס אונליין קצר בעברית, בתהליך פשוט ונוח, הנפקת ויזה רשמית באינטרנט, בלי לבקר בשגרירות.",
    hero_body_korea: "הוצאת אישור ויזה לקוריאה תוך 1-3 ימים, ב-{price}<br> מילוי טופס קצר בעברית, בתהליך אונליין פשוט ונוח, הנפקת ויזה רשמית באינטרנט, בלי לבקר בשגרירות",
    hero_body_morocco: "הוצאת ויזה למרוקו תוך 1-5 ימים, החל מ-{price}<br> הגשת טופס אונליין קצר בעברית, בתהליך פשוט ונוח, הנפקת ויזה רשמית באינטרנט, בלי לבקר בשגרירות.",
    hero_body_new_zealand: "הוצאת ויזה לניו זילנד תוך 1-3 ימים, ב-{price}<br> הגשת טופס אונליין קצר בעברית, בתהליך פשוט ונוח, הנפקת אישור NZeTA רשמי, בלי לבקר בשגרירות.",
    hero_body_saudi_arabia: "הגישו בקשה מקוונת תוך דקות וקבלו את האישור האלקטרוני הרשמי שלכם לערב הסעודית ישירות למייל – בלי צורך לבקר בשגרירות או לטפל בניירת. תיהנו מתמיכה 24/7 ומהבטחת הצלחה מלאה לטיול חלק ונטול דאגות.",
    hero_body_schengen: "הגישו בקשה מקוונת תוך דקות וקבלו את אשרת השנגן הרשמית שלכם. אנחנו נטפל עבורכם בניירת ובביקורים בשגרירות. עם תמיכה 24/7 ואחריות הצלחה מלאה, נבטיח שהמסע שלכם לאירופה יהיה חלק ונטול דאגות.",
    hero_body_sri_lanka: "הוצאת ויזה לסרי לנקה תוך 1-3 ימים, ב-{price}<br> הגשת טופס אונליין קצר בעברית, בתהליך פשוט ונוח, הנפקת ויזה רשמית, ללא הצורך לבקר בשגרירות.",
    hero_body_thailand: "הוצאת ויזה לתאילנד תוך 3-21 ימים, החל מ-{price}<br> מילוי טופס קצר בעברית, בתהליך אונליין פשוט ונוח, הנפקת ויזה רשמית באינטרנט, בלי לבקר בשגרירות.",
    hero_body_togo: "הגישו בקשה מקוונת תוך דקות וקבלו את הוויזה הרשמית שלכם לטוגו ישירות למייל – בלי טרטורים או צורך לבקר בשגרירות. עם תמיכה 24/7 ואחריות הצלחה מלאה, אנחנו נפשט לכם את הדרך להתחיל את ההרפתקה בטוגו.",
    hero_body_uk: "הוצאת אישור ויזה לאנגליה תוך 1-3 ימים, ב-{price}<br> מילוי טופס נוח בעברית, בתהליך קצר ופשוט אונליין, הנפקת ויזה רשמית באינטרנט, בלי לבקר בשגרירות.",
    hero_body_usa: "הוצאת אישור ויזה לארה״ב תוך 1-3 ימים, ב-{price}<br> מילוי טופס קצר בעברית, בתהליך אונליין פשוט ונוח, הנפקת ויזה רשמית באינטרנט, בלי לבקר בשגרירות.",
    hero_body_vietnam: "הוצאת ויזה לתאילנד תוך 3-21 ימים, החל מ-{price}<br> מילוי טופס קצר בעברית, בתהליך אונליין פשוט ונוח, הנפקת ויזה רשמית באינטרנט, בלי לבקר בשגרירות.",
    hero_header_bahrain: "ויזה אלקטרונית לחריין",
    hero_header_cambodia: "ויזה לקמבודיה",
    hero_header_canada: "ויזה לקנדה eTA",
    hero_header_home: "ויזות למטייל הישראלי בחו״ל",
    hero_header_india: "ויזה אלקטרונית להודו",
    hero_header_indonesia: "ויזה אלקטרונית לאינדונזיה",
    hero_header_israel: "ויזה לישראל ETA-IL",
    hero_header_korea: "ויזה לדרום קוריאה",
    hero_header_morocco: "ויזה אלקטרונית למרוקו",
    hero_header_new_zealand: "ויזה לניו זילנד NZeTA",
    hero_header_saudi_arabia: "ויזה לערב הסעודית",
    hero_header_schengen: "ויזת שנגן",
    hero_header_sri_lanka: "ויזה לסרי לנקה",
    hero_header_thailand: "ויזה לתאילנד DTV",
    hero_header_togo: "ויזה אלקטרונית לטוגו",
    hero_header_uk: "ויזה לאנגליה UK",
    hero_header_usa: "ויזה לארה״ב ESTA",
    hero_header_vietnam: "ויזה לווייטנאם",
    hero_price: "מחיר:",
    hero_processing: "זמן:",
    hero_video: "סרטון של חותמת ויזה Visanet בתוך דף הפתיחה של דרכון",
    how_it_works: "איך התהליך עובד",
    language: "שפה",
    more_reviews: {
      body: "לביקורות נוספות מלקוחותינו, בקרו אותנו ב:",
      title: "צפו בכל הביקורות עלינו"
    },
    pricing_card: {
      approved_within_bahrain: "ויזה אלקטרונית תוך 1-3 ימים",
      approved_within_cambodia: "ויזה אלקטרונית תוך 3-5 ימים",
      approved_within_canada: "ETA תוך 1-3 ימים",
      approved_within_india: "ויזה אלקטרונית תוך 1-3 ימים",
      approved_within_indonesia: "ויזה תוך 2-3 ימים",
      approved_within_israel: "ETA תוך 1-3 ימים",
      approved_within_korea: "KETA תוך 1-2 ימים",
      approved_within_morocco: "ויזה אלקטרונית תוך 1-5 ימים",
      approved_within_new_zealand: "NZeTA רשמית תוך 1-3 ימים",
      approved_within_saudi_arabia: "ויזה אלקטרונית תוך 1-2 ימים",
      approved_within_schengen: "ויזה תוך 15 יום",
      approved_within_sri_lanka: "ויזה אלקטרונית תוך 1-2 ימים",
      approved_within_thailand: "ויזה תוך 3-21 ימים",
      approved_within_togo: "ויזה אלקטרונית תוך 1-3 ימים",
      approved_within_uk: "אישור ETA בבריטניה תוך 1-3 ימים",
      approved_within_usa: "אישור ESTA תוך 1-3 ימים",
      approved_within_vietnam: "ויזה תוך 2-3 ימים",
      no_embassy: "אין צורך לבקר בשגרירות",
      online: "קבלת אשרה באינטרנט, ישירות מהבית",
      skip_voa: "דלג על קו VoA בשדה התעופה",
      support: "תמיכה מתמדת מתחילתו ועד סופו",
      urgent_option: "הזמנה מהירה למקרים דחופים",
      valid_15_days_30_days_90_days: "תקף למשך 15 יום, 30 יום או 90 יום",
      valid_1_year_90_days_per_visit: "תקף לשנה אחת, 90 יום לביקור",
      valid_2_years: "תקף לשנתיים",
      valid_2_years_90_days_per_visit: "תקף לשנתיים, 90 יום לביקור",
      valid_3_months_6_months_5_years: "תקף למשך 3 חודשים, 6 חודשים או 5 שנים",
      valid_5_years_6_months_per_visit: "תקף למשך 5 שנים, 6 חודשים לביקור",
      valid_for_180_days: "תקף למשך 180 יום",
      valid_for_2_weeks_3_months_or_more: "תקף לשבועיים, 3 חודשים או יותר",
      valid_for_30_days: "תקף למשך 30 יום",
      valid_for_30_days_90_days_1_year_stay: "תקף למשך 30 יום, 90 יום או שנה",
      valid_for_30_days_or_more: "תקף למשך 30 יום או יותר",
      valid_for_3_months: "תקף למשך 3 חודשים",
      valid_for_90_days: "תקף למשך 90 יום",
      valid_two_years_90_days_stay: "תקף לשנתיים, 90 ימי שהייה"
    },
    product_features: {
      cta: "מילוי טופס ויזה",
      img_bahrain: "קו הרקיע של בחריין, ויזה אלקטרונית בחריין",
      img_cambodia: "כפר בקמבודיה, קמבודיה eVisa",
      img_canada: "האגם וההר הקנדי, קנדה ETA",
      img_india: "מקדש גנגטוק, הודו eVisa",
      img_indonesia: "חתירה בבאלי, ויזה אינדונזיה",
      img_israel: "הגנים הבהאים בחיפה, ישראל ETA-IL",
      img_korea: "כפר האנוק, דרום קוריאה KETA",
      img_morocco: "אוארזאזאט, מרוקו eVisa",
      img_new_zealand: "ערוץ הוקיטיקה, ניו זילנד NZeTA",
      img_saudi_arabia: "נוף ערב הסעודית, ערב הסעודית eVisa",
      img_schengen: "מגדל אייפל, ויזת שנגן",
      img_sri_lanka: "קו החוף, ויזת סרי לנקה",
      img_thailand: "וואט צ'אלונג, ויזה תאילנד",
      img_togo: "פסל בודהה, ויזה טוגו",
      img_uk: "סטונהנג', ETA בבריטניה",
      img_usa: "ניו יורק, ארה\"ב ESTA",
      img_vietnam: "הוי אן, וייטנאם ויזה",
      processing: "אישור:",
      title_bahrain: "ויזה לבחריין",
      title_cambodia: "ויזה לקמבודיה",
      title_canada: "ויזה לקנדה",
      title_india: "ויזה להודו",
      title_indonesia: "ויזה לאינדונזיה",
      title_israel: "ויזה לישראל",
      title_korea: "ויזה לדרום קוריאה",
      title_morocco: "ויזה למרוקו",
      title_new_zealand: "ויזה לניו זילנד",
      title_saudi_arabia: "ויזה לסעודיה",
      title_schengen: "ויזה לאזור שנגן",
      title_sri_lanka: "ויזה לסרי לנקה",
      title_thailand: "ויזה לתאילנד",
      title_togo: "ויזה לטוגו",
      title_uk: "ויזה לבריטניה",
      title_usa: "ויזה לארצות הברית",
      title_vietnam: "ויזה לווייטנאם",
      validity: "תוקף:"
    },
    start_filling_form_bahrain: "התחילו את בקשתכם עוד היום וקבלו את הוויזה האלקטרונית הרשמית ישירות למייל תוך 3-5 ימים בלבד. הגיע הזמן לגלות את יופייה של בחריין ללא עיכובים או טרחה מיותרת.",
    start_filling_form_cambodia: "התחילו במילוי טופס האשרה עכשיו, ותקבלו את הויזה לקמבודיה תוך 3-5 ימים לדוא״ל!",
    start_filling_form_canada: "התחילו במילוי טופס הויזה עכשיו, ותקבלו את אישור הכניסה האלקטרוני לקנדה (eTA) תוך 1-3 ימים בלבד!",
    start_filling_form_india: "הצטרפו לעשרות אלפי הישראלים שקיבלו בהצלחה את הויזה האלקטרונית להודו, בלי לצאת מהבית או לבקר בשגרירות!<br>התחילו במילוי טופס האשרה עכשיו, ותקבלו את הויזה להודו תוך 1-3 ימים בלבד!",
    start_filling_form_indonesia: "התחילו את בקשתכם עוד היום וקבלו את הוויזה האלקטרונית הרשמית ישירות למייל תוך 5 ימים. זה הזמן לגלות את יופייה של אינדונזיה, ללא בירוקרטיה או כאבי ראש.",
    start_filling_form_israel: "התחילו במילוי טופס האשרה עכשיו, ותקבלו את הויזה לישראל ETA-IL ישירות למייל ו/או וואטסאפ תוך 1-3 ימים בלבד - עלות אישור הויזה לישראל {price}, זמין בעברית ואנגלית.",
    start_filling_form_korea: "התחילו במילוי טופס הויזה כעת, ותקבלו את אישור הנסיעה האלקטרוני לקוריאה הדרומית K-ETA ישירות לאימייל תוך 1-3 ימים בלבד!",
    start_filling_form_morocco: "התחילו במילוי טופס אשרת הכניסה למרקש עכשיו, ותקבלו את הויזה הרשמית של מרוקו ישירות לדוא״ל תוך 1-5 ימי עסקים בלבד!",
    start_filling_form_new_zealand: "התחילו עכשיו וקבלו את nZeTA המאושר שלכם ישירות למייל תוך 1-3 ימים. תכנון נסיעות מעולם לא היה קל ומאובטח יותר – התחילו את הבקשה שלכם עוד היום.",
    start_filling_form_saudi_arabia: "הגשת בקשה קלה: קבלו את הוויזה האלקטרונית הרשמית שלכם לדוא\"ל תוך 1-3 ימים בלבד. הפכו את נסיעותיכם לסעודיה לפשוטות, בטוחות ונטולות דאגות.",
    start_filling_form_schengen: "התחילו את תהליך הבקשה לוויזת שנגן עכשיו וקבלו את האישור בדוא\"ל תוך 15 יום בלבד ממועד הפגישה. הפכו את נסיעותיכם לאירופה לפשוטות, בטוחות ונטולות דאגות.",
    start_filling_form_sri_lanka: "הצטרפו לעשרות אלפי הישראלים שקיבלו בהצלחה את הויזה האלקטרונית לסרי לנקה, בלי לצאת מהבית או לבקר בשגרירות!<br>התחילו במילוי טופס האשרה עכשיו, ותקבלו את הויזה הרשמית של סרי לנקה תוך 1-3 ימים לדוא\"ל!",
    start_filling_form_thailand: "התחילו במילוי טופס הויזה האלקטרונית כעת, עם אפשרות לויזת טווח קצר (3-6 חודשים) או טווח ארוך (DTV ל-5 שנים), ותקבלו את אישור הוויזה לתאילנד תוך 3-21 ימים!",
    start_filling_form_togo: "התחילו את בקשתכם עוד היום וקבלו את הוויזה האלקטרונית הרשמית ישירות למייל תוך 1-3 ימים. הגיע הזמן לגלות את יופייה של טוגו ללא עיכובים או טרחה מיותרת.",
    start_filling_form_uk: "התחילו במילוי טופס ה-ETA כעת, ותקבלו את אישור הויזה לממלכה המאוחדת (אנגליה, סקוטלנד, וויילס וצפון אירלנד) תוך 1-3 ימים בלבד!",
    start_filling_form_usa: "התחילו במילוי טופס ה-ESTA כעת, ותקבלו את אישור הפטור מויזה לארצות הברית של אמריקה תוך 1-3 ימי עסקים בלבד!",
    start_filling_form_vietnam: "הצטרפו לאלפי הישראלים שקיבלו בהצלחה את הויזה האלקטרונית לויאטנם, בלי לצאת מהבית או לבקר בשגרירות!<br>התחילו במילוי טופס האשרה עכשיו, ותקבלו את הויזה לוייטנאם תוך 1-7 ימים למייל!",
    steps: {
      "1_body_bahrain": "מלאו את <a href='#form'>הטופס המאובטח</a> שלנו בכמה שלבים פשוטים. אין צורך בניירת, אין תורים ואין יציאה מהבית.",
      "1_body_cambodia": "מיד בסיום <a href=\"#form\">טופס הויזה הקצר באתרנו</a> בקשתכם עוברת <strong>בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי בקמבודיה</strong> להנפקת ויזה אלקטרונית עבורכם.",
      "1_body_canada": "מיד לאחר הגשת <a href=\"#form\">טופס הויזה באתרינו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת לרשויות ההגירה הממשלתיות בקנדה לצורך הנפקת אישור כניסה עבורכם.",
      "1_body_home": "הגשת טופס הויזה המקוון באתרנו היא תהליך פשוט ונוח, המתבצע כולו בעברית ובאופן מקוון, ולוקח בממוצע כ-5-10 דקות בלבד. תתבקשו להזין רק פרטי דרכון (ובמדינות מסוימות להוסיף תמונות) — ללא כל צורך בשליחת מסמכים בדואר רשום, יציאה מהבית או ביקור פיזי בשגרירות!",
      "1_body_india": "מיד לאחר הגשת <a href=\"#form\">טופס הויזה באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי בהודו לצורך הנפקת ויזה אלקטרונית עבורכם.",
      "1_body_indonesia": "מלאו את <a href='#form'>הטופס המאובטח</a> שלנו בכמה שלבים פשוטים. אין צורך בניירת, אין תורים ואין יציאה מהבית.",
      "1_body_israel": "מיד לאחר הגשת <a href=\"#form\">טופס הויזה באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי הישראלי לצורך הנפקת ויזה ETA-IL עבורכם.",
      "1_body_korea": "מיד לאחר הגשת <a href=\"#form\">טופס ה-K-ETA באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי בקוריאה לצורך הנפקת ויזה עבורכם.",
      "1_body_morocco": "מיד לאחר הגשת <a href=\"#form\">טופס הויזה באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי במרוקו לצורך הנפקת ויזה אלקטרונית עבורכם.",
      "1_body_new_zealand": "מיד לאחר הגשת <a href=\"#form\">טופס הויזה באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי בניו זילנד לצורך הנפקת ויזה עבורכם.",
      "1_body_saudi_arabia": "מלאו את <a href='#form'>הטופס המאובטח</a> שלנו תוך דקות ספורות בלבד - אין צורך לשלוח מסמכים בדואר או לצאת מהבית.",
      "1_body_schengen": "מלאו את <a href='#form'>הטופס המאובטח</a> שלנו תוך דקות ספורות בלבד - אין צורך לשלוח מסמכים בדואר או לצאת מהבית.",
      "1_body_sri_lanka": "מיד לאחר הגשת <a href=\"#form\">טופס הויזה באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי בסרי לנקה לצורך הנפקת ויזה עבורכם.",
      "1_body_status": "הצוות שלנו זמין עבורכם 24/7 לכל שאלה.",
      "1_body_thailand": "מיד לאחר הגשת <a href=\"#form\">טופס הויזה לתאילנד באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי בתאילנד לצורך הנפקת ויזה עבורכם.",
      "1_body_togo": "מלאו את <a href='#form'>הטופס המאובטח</a> שלנו בכמה שלבים פשוטים. אין צורך בניירת, אין תורים ואין יציאה מהבית.",
      "1_body_uk": "מיד לאחר הגשת <a href=\"#form\">טופס ה-ETA באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי בבריטניה לצורך הנפקת ויזה עבורכם.",
      "1_body_usa": "מיד לאחר הגשת <a href=\"#form\">טופס ה-ESTA באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי בארה״ב לצורך הנפקת ויזה עבורכם.",
      "1_body_vietnam": "מיד לאחר הגשת <a href=\"#form\">טופס הויזה באתרנו</a>, בקשתכם לאשרה עוברת בדיקה ע\"י צוות האתר ונשלחת למשרד ההגירה הממשלתי בוייטנאם לצורך הנפקת ויזה אלקטרונית עבורכם.",
      "1_title_bahrain": "ממלאים טופס אונליין",
      "1_title_cambodia": "ממלאים טופס אונליין",
      "1_title_canada": "ממלאים טופס אונליין",
      "1_title_home": "ממלאים טופס מאובטח אונליין",
      "1_title_india": "ממלאים טופס אונליין",
      "1_title_indonesia": "ממלאים טופס אונליין",
      "1_title_israel": "ממלאים טופס אונליין",
      "1_title_korea": "ממלאים טופס אונליין",
      "1_title_morocco": "ממלאים טופס אונליין",
      "1_title_new_zealand": "ממלאים טופס אונליין",
      "1_title_saudi_arabia": "ממלאים טופס אונליין",
      "1_title_schengen": "ממלאים טופס אונליין",
      "1_title_sri_lanka": "ממלאים טופס אונליין",
      "1_title_status": "תמיכה זמינה תמיד",
      "1_title_thailand": "ממלאים טופס ויזה אונליין",
      "1_title_togo": "ממלאים טופס אונליין",
      "1_title_uk": "ממלאים טופס UK ETA אונליין",
      "1_title_usa": "ממלאים טופס ESTA אונליין",
      "1_title_vietnam": "ממלאים טופס אונליין",
      "2_body_bahrain": "אנו מגישים את בקשתכם באופן מאובטח לרשויות בחריין. רוב הויזות האלקטרוניות מאושרות ונשלחות ישירות לתיבת הדואר הנכנס שלכם תוך 3-5 ימים.",
      "2_body_cambodia": "תוך <strong>3-5 ימים הויזה מאושרת</strong> ונשלחת ישירות למייל — מסמך זה מהווה <strong>אישור רשמי וחתום של ממשלת קמבודיה אודות ביקורכם</strong>, כל מה שעליכם לעשות זה להדפיסו.",
      "2_body_canada": "תוך 1-3 ימים הויזה מאושרת ונשלחת ישירות לדוא\"ל שלכם — ה-Electronic Travel Authorization, או בקצרה eTA, מהווה אישור כניסה אלקטרוני רשמי לקנדה ל-5 שנים.",
      "2_body_home": "לאחר הגשת טופס הויזה, אנו מעבדים מיד את בקשתכם ושולחים בקשה רשמית לרשות ההגירה הרלוונטית להנפקת ויזה בשמכם. הויזה האלקטרונית מתקבלת תוך 1-3 ימים ונשלחת ישירות למייל שלכם.",
      "2_body_india": "תוך 1-3 ימים הויזה מאושרת ונשלחת ישירות למייל שלכם — מסמך זה מהווה אישור רשמי וחתום של ממשלת הודו אודות ביקורכם, כל מה שעליכם לעשות זה להדפיסו.",
      "2_body_indonesia": "אנו שולחים את פרטיכם לרשויות אינדונזיה. רוב הויזות האלקטרוניות מאושרות ונשלחות ישירות לתיבת הדואר הנכנס שלכם תוך 5 ימים.",
      "2_body_israel": "תוך <strong>1-3 ימים הויזה מאושרת</strong> ונשלחת ישירות למייל ו/או וואטסאפ שלכם — מסמך זה מהווה <strong>אישור רשמי וחתום של ממשלת ישראל</strong> אודות ביקורכם בארץ.",
      "2_body_korea": "תוך <strong>1-3 ימים הויזה מאושרת</strong> ונשלחת למייל שלכם — מסמך זה מהווה <strong>אישור רשמי וחתום של ממשלת קוריאה</strong> אודות ביקורכם, כל מה שעליכם לעשות זה להדפיסו.",
      "2_body_morocco": "תוך <strong>1-5 ימים הויזה מאושרת</strong> ונשלחת ישירות למייל שלכם — מסמך זה מהווה <strong>אישור רשמי וחתום של ממשלת מרוקו</strong> אודות ביקורכם, כל מה שעליכם לעשות זה להדפיסו.",
      "2_body_new_zealand": "תוך <strong>1-3 ימים הויזה מאושרת</strong> ונשלחת ישירות למייל שלכם מסמך זה מהווה <strong>אישור רשמי וחתום של ממשלת ניו זילנד</strong> אודות ביקורכם, כל מה שנשאר לעשות זה להדפיסו.",
      "2_body_saudi_arabia": "אנו מגישים את בקשתכם לרשויות ההגירה של ערב הסעודית. רוב הויזות האלקטרוניות מאושרות תוך 1-3 ימים (עם אפשרות לטיפול מהיר יותר לבקשות דחופות).",
      "2_body_schengen": "אנו מגישים את בקשתכם לרשויות שנגן. רוב הוויזות מאושרות תוך 15 יום לאחר הפגישה בשגרירות/קונסוליה.",
      "2_body_sri_lanka": "תוך <strong>1-3 ימים הויזה מאושרת</strong> ונשלחת ישירות למייל שלכם — מסמך זה מהווה <strong>אישור רשמי של ממשלת סרי לנקה</strong> אודות ביקורכם, כל מה שעליכם לעשות זה להדפיסו.",
      "2_body_status": "אתם יכולים לבדוק בקלות את סטטוס הבקשה שלכם בכל עת, באמצעות כתובת המייל וקוד ההזמנה.",
      "2_body_thailand": "בהתאם לסוג הויזה, תוך <strong>3-21 ימים הויזה מאושרת</strong> ונשלחת ישירות לדוא״ל ו/או וואטסאפ שלכם—מסמך זה מהווה <strong>אישור רשמי של ממשלת תאילנד</strong> אודות ביקורכם במדינה.",
      "2_body_togo": "אנו שולחים את בקשתכם באופן מאובטח לרשויות טוגו. רוב הויזות האלקטרוניות מאושרות ונשלחות ישירות לתיבת הדואר הנכנס שלכם תוך 3 ימים.",
      "2_body_uk": "תוך <strong>1-3 ימים הויזה מאושרת</strong> ונשלחת ישירות למייל ו/או וואטסאפ שלכם — מסמך זה מהווה <strong>אישור רשמי וחתום של ממשלת בריטניה</strong> אודות ביקורכם באנגליה ובריטניה.",
      "2_body_usa": "תוך <strong>1-3 ימים הויזה מאושרת</strong> ונשלחת לאימייל שלכם — מסמך זה מהווה <strong>אישור רשמי וחתום של ממשלת ארה״ב</strong> אודות ביקורכם, כל מה שעליכם לעשות זה להדפיסו.",
      "2_body_vietnam": "תוך 1-7 ימים הויזה מאושרת ונשלחת לדוא\"ל שלכם — מסמך זה מהווה <strong>אישור דיגיטלי רשמי של ממשלת ויאטנם</strong> אודות ביקורכם, כל מה שעליכם לעשות זה להדפיסו.",
      "2_title_bahrain": "ממתינים לאישור הויזה",
      "2_title_cambodia": "ממתינים לאישור הויזה",
      "2_title_canada": "ממתינים לאישור ה-eTA",
      "2_title_home": "ממתינים לאישור הויזה",
      "2_title_india": "ממתינים לאישור הויזה",
      "2_title_indonesia": "ממתינים לאישור הויזה",
      "2_title_israel": "ממתינים לאישור הויזה",
      "2_title_korea": "ממתינים לאישור הויזה",
      "2_title_morocco": "ממתינים לאישור הויזה",
      "2_title_new_zealand": "ממתינים לאישור הויזה",
      "2_title_saudi_arabia": "ממתינים לאישור הויזה",
      "2_title_schengen": "ממתינים לאישור הויזה",
      "2_title_sri_lanka": "ממתינים לאישור הויזה",
      "2_title_status": "תהליך מהיר ונוח",
      "2_title_thailand": "ממתינים לאישור הויזה",
      "2_title_togo": "ממתינים לאישור הויזה",
      "2_title_uk": "ממתינים לאישור הויזה",
      "2_title_usa": "ממתינים לאישור הויזה",
      "2_title_vietnam": "ממתינים לאישור הויזה",
      "3_body_bahrain": "הדפיסו את הויזה האלקטרונית המאושרת שלכם והציגו אותה עם ההגעה. הכניסה שלכם תהיה חלקה, ואתם מוכנים ליהנות מהטיול לבחריין.",
      "3_body_cambodia": "לוקחים את הויזה המודפסת איתכם, מציגים אותה בעת ביקורת הגבולות בקמבודיה <strong>ובתמורה מקבלים חותמת בדרכון המאשרת את כניסתכם לקמבודיה ל-30 ימים</strong>. זה הכל — טיסה נעימה!",
      "3_body_canada": "מציגים את הויזה ואת הדרכון שלכם בעת ביקורות הגבולות בקנדה, ובתמורה מקבלים (ללא עלות) חותמת בדרכון המאשרת את כניסתכם לקנדה. זה הכל — טיסה נעימה!",
      "3_body_home": "ברכותינו! ויזה אלקטרונית רשמית תמתין לכם בדוא\"ל בסוף ההמתנה — כעת כל שנותר לכם הוא להדפיס את אשרת הנסיעה, לארוז את המזוודה... ולנו נותר לאחל לכם טיסה נעימה!",
      "3_body_india": "לוקחים את הויזה המודפסת איתכם, מציגים אותה בעת העלייה למטוס וביקורת הגבולות בהודו ובתמורה מקבלים (ללא עלות נוספת) חותמת בדרכון המאשרת את כניסתכם להודו. זה הכל — מאחלים לכם טיסה נעימה! 🙏",
      "3_body_indonesia": "הדפיסו את הויזה האלקטרונית המאושרת שלכם והציגו אותה עם ההגעה. הכניסה שלכם תהיה חלקה, ואתם מוכנים ליהנות מהטיול לאינדונזיה.",
      "3_body_israel": "מדפיסים או שומרים את הויזה בטלפון, מציגים אותה בעת העלייה למטוס וביקורת הגבולות בישראל <strong>ובתמורה מקבלים אישור כניסה ETA-IL לישראל (ללא עלות נוספת)</strong>. זה הכל — מאחלים לכם טיסה נעימה!",
      "3_body_korea": "לוקחים את הויזה המודפסת איתכם, מציגים אותה בעת העלייה למטוס ו/או ביקורת הגבולות <strong>ובתמורה מקבלים (ללא עלות נוספת) חותמת בדרכון המאשרת את כניסתכם לדרום קוריאה</strong>. מאחלים לכם טיסה נעימה!",
      "3_body_morocco": "לוקחים את הויזה המודפסת, מציגים אותה בעת העלייה למטוס וביקורת הגבולות במרוקו<strong> ובתמורה מקבלים (ללא עלות נוספת) חותמת בדרכון המאשרת את כניסתכם למרוקו</strong>. זה הכל — מאחלים לכם טיסה נעימה!",
      "3_body_new_zealand": "לוקחים את הויזה המודפסת, מציגים אותה בעת העלייה למטוס וביקורת הגבולות בניו זילנד<strong> ובתמורה מקבלים (ללא עלות נוספת) חותמת בדרכון המאשרת את כניסתכם לניו זילנד</strong>. זה הכל — מאחלים טיסה נעימה!",
      "3_body_saudi_arabia": "הדפיסו את הויזה האלקטרונית המאושרת שלכם והציגו אותה עם ההגעה. הכניסה שלכם תהיה חלקה, ואתם מוכנים ליהנות מהטיול.",
      "3_body_schengen": "הדפיסו את אשרת שנגן המאושרת שלכם והציגו אותה בגבול. הכניסה שלכם תהיה חלקה, ואתם מוכנים ליהנות מהטיול לאירופה.",
      "3_body_sri_lanka": "לוקחים את הויזה האלקטרונית המודפסת איתכם, מציגים אותה בעת העלייה למטוס וביקורת הגבולות בסרי לנקה <strong>ובתמורה מקבלים (ללא עלות נוספת) חותמת בדרכון המאשרת את כניסתכם לסרילנקה</strong>. זה הכל — מאחלים לכם טיסה נעימה!",
      "3_body_status": "קבלו את הויזה האלקטרונית שלכם בדוא\"ל. הדפיסו אותה, הביאו אותה עמכם ועברו את ביקורת הדרכונים בקלות.",
      "3_body_thailand": "מדפיסים את הויזה, מציגים אותה בעת העלייה למטוס וביקורת הגבולות בתאילנד <strong>ובתמורה מקבלים (ללא עלות נוספת) חותמת בדרכון המאשרת את כניסתכם לתאילנד</strong>. מאחלים לכם טיסה נעימה!",
      "3_body_togo": "הדפיסו את הויזה האלקטרונית המאושרת שלכם והציגו אותה עם ההגעה. הכניסה שלכם תהיה חלקה, ואתם מוכנים ליהנות מהטיול לטוגו.",
      "3_body_uk": "מדפיסים או שומרים את הויזה בטלפון, מציגים אותה בעת העלייה למטוס וביקורת הגבולות בבריטניה <strong>ובתמורה מקבלים (ללא עלות נוספת) חותמת בדרכון המאשרת את כניסתכם למדינות הממלכה המאוחדת: אנגליה, סקוטלנד, ויילס וצפון אירלנד</strong>. מאחלים לכם טיסה נעימה!",
      "3_body_usa": "לוקחים את הויזה המודפסת איתכם, מציגים אותה בעת העלייה למטוס ו/או ביקורת הגבולות בארה״ב <strong>ובתמורה מקבלים (ללא עלות נוספת) חותמת בדרכון המאשרת את כניסתכם לארצות הברית</strong>. מאחלים לכם טיסה נעימה!",
      "3_body_vietnam": "לוקחים את הויזה המודפסת, מציגים אותה בעת העלייה למטוס וביקורת הגבולות בוייטנאם<strong> ובתמורה מקבלים (ללא תוספת תשלום) חותמת בדרכון המאשרת את כניסתכם לוייטנאם</strong>. זה הכל — מאחלים לכם טיסה נעימה!",
      "3_title_bahrain": "מוכנים לטוס לבחריין!",
      "3_title_cambodia": "טסים לקמבודיה!",
      "3_title_canada": "טסים לקנדה!",
      "3_title_home": "✈️ מדפיסים וטסים!",
      "3_title_india": "טסים להודו!",
      "3_title_indonesia": "מוכנים לטוס לאינדונזיה!",
      "3_title_israel": "טסים לישראל!",
      "3_title_korea": "טסים לקוריאה הדרומית!",
      "3_title_morocco": "טסים למרוקו!",
      "3_title_new_zealand": "טסים לניו זילנד!",
      "3_title_saudi_arabia": "מוכנים לטוס לסעודיה!",
      "3_title_schengen": "מוכנים לטוס לאירופה!",
      "3_title_sri_lanka": "טסים לסרי לנקה!",
      "3_title_status": "שקיפות מלאה ואמינות",
      "3_title_thailand": "טסים לתאילנד!",
      "3_title_togo": "מוכנים לטוס לטוגו!",
      "3_title_uk": "טסים לבריטניה!",
      "3_title_usa": "טסים לארצות הברית!",
      "3_title_vietnam": "טסים לווייטנאם!",
      cta_country_page: "הגשת טופס ויזה",
      cta_home: "היעדים שלנו",
      img_alt: "מחשב נייד פתוח עם כוס קפה על השולחן"
    },
    testimonials: {
      megaphone_img: "איור מגפון",
      read_original: "לביקורת המלאה",
      title: "מה לקוחותינו אומרים"
    },
    trust: {
      "1_alt": "אייקון מנעול אבטחה",
      "1_body_bahrain": "אנו מאבטחים את המידע האישי שלכם באמצעות הצפנה מתקדמת ובתקנים בינלאומיים מחמירים. הנתונים שלכם מטופלים ברמת אבטחה זהה למערכות בנקאיות וממשלתיות גלובליות.",
      "1_body_cambodia": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך במילוי טפסים באנגלית או המתנה ארוכה בגבול הקמבודי — לאחר 3-5 ימים תקבלו את הויזה האלקטרונית ישירות למייל, במחיר הזול בארץ!",
      "1_body_canada": "הגשת הויזה מתבצעת ישירות באתרינו, ללא צורך בשליחת מסמכים בדואר או הגעה לשגרירות — לאחר 1-3 ימים תקבלו אישור כניסה רשמי לקנדה למייל, במחיר הזול בארץ!",
      "1_body_home": "הגשת הויזה מתבצעת בצורה מאובטחת באתרנו, ללא צורך בשליחת מסמכים בדואר או הגעה לשגרירות. לאחר 1-3 ימים תקבלו את ה-eVisa שהזמנתם ישירות למייל, במחיר הזול בארץ!",
      "1_body_india": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בשליחת מסמכים או הגעה פיזית לשגרירות — לאחר 1-3 ימים תקבלו את הויזה האלקטרונית של הודו ישירות למייל, במחיר הזול בארץ!",
      "1_body_indonesia": "הצוות שלנו מגן על הפרטים האישיים שלכם באמצעות הצפנה ברמה הגבוהה ביותר וסטנדרטים בינלאומיים. הנתונים שלכם מטופלים באופן מאובטח כמו במערכות בנקאיות או ממשלתיות גלובליות.",
      "1_body_israel": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בשליחת מסמכים או הגעה פיזית לשגרירות — לאחר 1-3 ימים תקבלו את הויזה האלקטרונית של ישראל ישירות למייל, במחיר הזול בארץ!",
      "1_body_korea": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בשליחת מסמכים או הגעה פיזית לשגרירות — לאחר 1-3 ימים תקבלו את אישור ה-K-ETA של דרום קוריאה ישירות למייל, במחיר הזול בארץ!",
      "1_body_morocco": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בשליחת מסמכים או הגעה פיזית לשגרירות — לאחר 1-5 ימים תקבלו את הויזה האלקטרונית של מרוקו ישירות למייל, במחיר הזול בארץ!",
      "1_body_new_zealand": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בשליחת מסמכים או הגעה פיזית לשגרירות — לאחר 1-3 ימים תקבלו את הויזה האלקטרונית של ניו זילנד ישירות למייל, במחיר הזול בארץ!",
      "1_body_saudi_arabia": "כל המידע שאתם מוסרים לנו מוגן באמצעות הצפנת SSL ותקני אבטחה בינלאומיים קפדניים – בדיוק כמו בנקים ואתרים ממשלתיים מובילים.",
      "1_body_schengen": "אנו מגנים על הפרטים האישיים שלכם באמצעות הצפנה ברמה הגבוהה ביותר וסטנדרטים בינלאומיים. הנתונים שלכם מטופלים בצורה מאובטחת במיוחד, בדומה למערכות בנקאיות או ממשלתיות גלובליות.",
      "1_body_sri_lanka": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בשליחת מסמכים או הגעה פיזית לשגרירות — לאחר 1-3 ימים תקבלו את הויזה האלקטרונית של סרי לנקה ישירות לדוא\"ל, במחיר הזול בארץ!",
      "1_body_thailand": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בהגעה פיזית לשגרירות—לאחר 3-21 ימים תקבלו את אישור הויזה הרשמי של תאילנד ישירות לדואר אלקטרוני, במחיר הזול בארץ!",
      "1_body_togo": "הפרטים האישיים שלכם מוגנים אצלנו באמצעות הצפנה ברמה הגבוהה ביותר ובתקנים בינלאומיים. הנתונים שלכם מטופלים ברמת אבטחה זהה לזו של מערכות בנקאיות או ממשלתיות גלובליות.",
      "1_body_uk": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בשליחת מסמכים או הגעה פיזית לשגרירות — לאחר 1-3 ימים תקבלו את אישור ה-ETA של אנגליה ישירות למייל, במחיר הזול בארץ!",
      "1_body_usa": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בשליחת מסמכים או הגעה פיזית לשגרירות — לאחר 1-3 ימים תקבלו את אישור ה-ESTA של ארה״ב למייל, במחיר הזול בארץ!",
      "1_body_vietnam": "הגשת הויזה מתבצעת ישירות באתרנו, ללא צורך בשליחת מסמכים בדואר או הגעה פיזית לשגרירות — לאחר 1-7 ימים תקבלו את הויזה של וייטנאם ישירות לאימייל, במחיר הזול בארץ!",
      "1_title": "תהליך קצר אונליין",
      "2_alt": "סמל מגן עם סימן כסף",
      "2_body": "הגישו בקשה בראש שקט, הודות למדיניות ההחזר הכספי המלאה שלנו. אנו נטפל בכל פרט, ואם בקשתכם תידחה, נגיש עבורכם בקשה חוזרת ללא עלות, או שנחזיר לכם את מלוא כספכם – ללא שאלות וללא תנאים.",
      "2_body_bahrain": "אם הויזה האלקטרונית שלכם תידחה, אנו נגיש בקשה חוזרת עבורכם ללא עלות, או שנבצע החזר כספי מלא – ללא שאלות.",
      "2_body_cambodia": "הוצאת ויזה רשמית לקמבודיה ב-{price} בלבד — במקרה האפסי של סירוב או טעות באישור הויזה, נדאג להנפקה של אשרה חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_canada": "הנפקת ויזה אלקטרונית לקנדה (אישור כניסה eTA) ב{price} בלבד — במקרה האפסי של סירוב או תקלה בויזה, נדאג להנפקה של אישור כניסה חדש בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_home": "תהליך הוצאת ויזה אלקטרונית מעולם לא היה פשוט ובטוח יותר — במקרה האפסי של סירוב או טעות באישור הויזה, נדאג להנפקה של אשרה חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_india": "הוצאת ויזה אלקטרונית להודו החל מ-{price} בלבד — במקרה האפסי של סירוב או תקלה באישור הויזה, נדאג להנפקה של אשרה חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_indonesia": "אם הויזה האלקטרונית שלכם לא תאושר, אנו נגיש בקשה חוזרת בחינם או שנחזיר לכם את מלוא התשלום – ללא שאלות מיותרות.",
      "2_body_israel": "הוצאת ויזה ETA-IL לישראל החל מ-{price} בלבד — במקרה האפסי של סירוב או תקלה באישור הויזה, נדאג להנפקה של אשרה חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_korea": "הוצאת אשרת נסיעה אלקטרונית לקוריאה KETA ב-{price} בלבד — במקרה האפסי של סירוב או תקלה באישור הויזה, נדאג להנפקה של חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_morocco": "הוצאת ויזה אלקטרונית למרוקו החל מ-{price} — במקרה האפסי של סירוב או תקלה באישור הויזה, נדאג להנפקה של אשרה חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_new_zealand": "הוצאת אשרה אלקטרונית לניו זילנד החל מ-{price} בלבד — במקרה האפסי של סירוב או תקלה בהליך האישור, נדאג להנפקה של אשרה חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_saudi_arabia": "במידה והויזה האלקטרונית שלכם תידחה, אנו נגיש בקשה מחודשת בחינם או שנבצע החזר כספי מלא – ללא שאלות.",
      "2_body_schengen": "אם אשרת השנגן שלכם תידחה, אנו נגיש בקשה חוזרת בחינם או שנבצע החזר כספי מלא – ללא שאלות.",
      "2_body_sri_lanka": "הוצאת ויזה אלקטרונית לסרי לנקה החל מ-{price} בלבד — במקרה האפסי של סירוב או תקלה באישור הויזה, נדאג להנפקה של אשרה חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_thailand": "הוצאת ויזה אלקטרונית לטווח קצר לתאילנד ב-{price} בלבד—במקרה האפסי של סירוב או תקלה באישור הויזה, נדאג להנפקה של ויזה חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_togo": "אם הויזה האלקטרונית שלכם תידחה, אנו נגיש בקשה חוזרת בחינם או שנחזיר לכם את מלוא התשלום – ללא שאלות.",
      "2_body_uk": "הוצאת אשרת נסיעה אלקטרונית לאנגליה ETA ב-{price} בלבד — במקרה האפסי של סירוב או תקלה באישור הויזה, נדאג להנפקה של ויזה חדש בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_usa": "הוצאת אשרת כניסה אלקטרונית לארה\"ב ESTA ב-{price} בלבד — במקרה האפסי של סירוב או תקלה באישור הויזה, נדאג להנפקה של ויזה חדש בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_body_vietnam": "הוצאת ויזה רשמית לוייטנאם החל מ-{price} בלבד — במקרה האפסי של סירוב או תקלה באישור הויזה, נדאג להנפקה של אשרה חדשה בחינם או נזכה את מלואו כספכם בחזרה.",
      "2_title": "100% הצלחה או החזר כספי מלא",
      "3_alt": "אייקון שירות לקוחות 24/7",
      "3_body": "מתחילת שנת 2019 הנפקנו בהצלחה עשרות אלפי אישורי כניסה ללקוחות ישראלים — אנו מטפלים בבקשות הויזה מסביב לשעון, ותמיד זמינים לתת מענה ב-<a href=\"{whatsapp}\" target=\"_blank\">וואטסאפ</a>, <a data-chat-opener>צ'אט</a>, <a href=\"mailto:{email}\" target=\"_blank\">אימייל</a> או <a href=\"tel:{phone}\">טלפון</a>. לעדכונים שוטפים, עקבו אחרינו ב<a href=\"{instagram}\" target=\"_blank\">אינסטגרם</a> וב<a href=\"{facebook}\" target=\"_blank\">פייסבוק</a>.",
      "3_title": "תמיכה מקצועית 24/7",
      "3_title_home": "תשלום מאובטח",
      lead_bahrain: "באתרנו תוכלו להזמין <strong>ויזה אלקטרונית לבחריין</strong> (Bahrain eVisa) ולקבל את האשרה למייל תוך <strong>3-5 ימי עסקים בלבד</strong> – מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, ללא צורך בשליחת מסמכים, יאפשר לכם לקבל <strong>ויזה רשמית לבחריין</strong> למטרת תיירות.",
      lead_cambodia: "באתרינו תוכלו להזמין <strong>ויזה אלקטרונית לקמבודיה</strong> (Cambodia e-Visa) ולקבל את האשרה חתומה למייל תוך <strong>3-5 ימי עסקים בלבד</strong> — מילוי טופס פשוט בעברית ותשלום מאובטח בסך ₪199 יקנה לכם <strong>ויזה לקמבודיה ל-30 ימים</strong>.",
      lead_canada: "באתרנו תוכלו להזמין <strong>אישור כניסה אלקטרוני לקנדה</strong> (Canada eTA) ולקבל את האשרה למייל תוך <strong>1-3 ימי עסקים בלבד</strong> — מילוי טופס פשוט בעברית, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>אישור ויזה רשמי לקנדה ל-5 שנים</strong>.",
      lead_india: "באתרנו תוכלו להזמין <strong>ויזה אלקטרונית להודו</strong> (India eVisa) ולקבל את האשרה למייל תוך <strong>1-3 ימי עסקים בלבד</strong> — מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>ויזה רשמית להודו החל מ-30 ימים ועד ל-5 שנים</strong>.",
      lead_indonesia: "באתרנו תוכלו להזמין <strong>ויזה אלקטרונית לאינדונזיה</strong> (Indonesia eVisa) ולקבל את האשרה למייל תוך <strong>3-5 ימי עסקים</strong> – תהליך מקוון ומאובטח, בשפה העברית, ללא צורך בהגעה לשגרירות, יקנה לכם <strong>ויזה אלקטרונית לאינדונזיה</strong>, התקפה לתקופות שונות.",
      lead_israel: "באתרנו תוכלו להזמין <strong>ויזה אלקטרונית לישראל</strong> (Israel ETAIL) ולקבל את האשרה למייל תוך <strong>1-3 ימי עסקים בלבד</strong> — מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>ויזה רשמית לישראל לשנתיים</strong>.",
      lead_korea: "באתרנו תוכלו להזמין <strong>אישור נסיעה אלקטרוני לקוריאה הדרומית</strong> (K-ETA) ולקבל את הויזה לדוא״ל תוך <strong>1-3 ימים בלבד</strong> — מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>ויזה רשמית לדרום קוריאה</strong> לשנתיים.",
      lead_morocco: "באתרנו תוכלו להזמין <strong>ויזה אלקטרונית למרוקו</strong> (Morocco eVisa) ולקבל את האשרה למייל תוך <strong>1-5 ימי עסקים בלבד</strong> — מילוי טופס קצר ונוח בעברית, בתהליך מאובטח אונליין, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>ויזה אלקטרונית רשמית למרוקו החל מ-30 ימים ועד לחצי שנה</strong>.",
      lead_new_zealand: "באתרנו תוכלו להזמין <strong>אשרת כניסה/מעבר אלקטרונית לניו זילנד</strong> (NZeTA) ולקבל את האישור לדוא\"ל תוך <strong>1-3 ימי עסקים בלבד</strong> — מילוי טופס קצר ונוח בעברית, בהליך מאובטח אונליין, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>ויזה אלקטרונית רשמית לניו זילנד עד לשנתיים</strong>.",
      lead_saudi_arabia: "באתרנו תוכלו להזמין <strong>ויזה אלקטרונית לסעודיה</strong> (Saudi Arabia eVisa) ולקבל את האשרה למייל תוך <strong>1-3 ימי עסקים בלבד</strong> – מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, יקנה לכם <strong>ויזה רשמית לסעודיה התקפה לשנה</strong>.",
      lead_schengen: "באתרנו תוכלו להזמין שירות מקיף לקבלת <strong>ויזת שנגן</strong> (Schengen Visa Type C). אנו מסייעים בתהליך הגשת הבקשה, תרגום מסמכים ותיאום פגישה, על מנת להקל עליכם את התהליך ולקבל <strong>ויזת שנגן</strong> במהירות וביעילות.",
      lead_sri_lanka: "באתרנו תוכלו להזמין <strong>ויזה אלקטרונית לסרי לנקה</strong> (Sri Lanka eVisa) ולקבל את האשרה למייל תוך <strong>1-2 ימי עסקים בלבד</strong> — מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>ויזה רשמית לסרי לנקה החל מ-30 ימים ועד לחצי שנה</strong>.",
      lead_thailand: "באתרנו תוכלו להזמין <strong>ויזה קצרה או ארוכת טווח לתאילנד</strong> (Thailand eVisa &amp; DTV) ולקבל את הויזה לדוא״ל תוך <strong>3-21 ימים</strong>—מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, ללא צורך בהגעה לשגרירות, יקנה לכם <strong>ויזה רשמית לתאילנד</strong> בתוקף עד 5 שנים.",
      lead_togo: "באתרנו תוכלו להזמין <strong>ויזה אלקטרונית לטוגו</strong> (Togo eVisa) ולקבל את האשרה ישירות למייל תוך <strong>1-3 ימי עסקים</strong>. הזמנת הויזה מתבצעת אונליין, בשפה העברית, בתהליך מאובטח ונוח. ניתן להזמין <strong>ויזה אלקטרונית לטוגו</strong> למספר סוגי כניסות.",
      lead_uk: "באתרנו תוכלו להזמין <strong>אישור כניסה אלקטרוני לאנגליה</strong> (UK ETA) ולקבל את הויזה לדוא״ל תוך <strong>1-3 ימים בלבד</strong> — מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>ויזה רשמית לאנגליה</strong> לשנתיים.",
      lead_usa: "באתרנו תוכלו להזמין <strong>אישור כניסה אלקטרוני לארה\"ב</strong> (U.S ESTA) ולקבל את הויזה לדוא״ל תוך <strong>1-3 ימים בלבד</strong> — מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>ויזה רשמית לארה״ב</strong> לשנתיים.",
      lead_vietnam: "באתרנו תוכלו להזמין <strong>ויזה אלקטרונית לווייטנאם</strong> (Vietnam eVisa) ולקבל את האשרה למייל תוך <strong>1-7 ימי עסקים בלבד</strong> — מילוי טופס פשוט בעברית, בתהליך מאובטח אונליין, ללא צורך בשליחת מסמכים או הגעה לשגרירות, יקנה לכם <strong>ויזה רשמית לווייטנאם</strong> ל-90 ימים.",
      title: "אפשר לסמוך עלינו"
    },
    visa_starting_price_bahrain: "ויזה אלקטרונית לבחריין החל מ-{price}",
    visa_starting_price_cambodia: "ויזה רשמית לקמבודיה ב-{price}",
    visa_starting_price_canada: "אישור כניסה לקנדה ETA ב-{price}",
    visa_starting_price_india: "ויזה אלקטרונית להודו החל מ-{price}",
    visa_starting_price_indonesia: "ויזה אלקטרונית לאינדונזיה בעלות של {price}",
    visa_starting_price_israel: "ויזה אלקטרונית לישראל ETA-IL",
    visa_starting_price_korea: "ויזה אלקטרונית לדרום קוריאה ב-{price}",
    visa_starting_price_morocco: "ויזה אלקטרונית למרוקו החל מ-{price}",
    visa_starting_price_new_zealand: "ויזה אלקטרונית לניו זילנד ב-{price}",
    visa_starting_price_saudi_arabia: "ויזה אלקטרונית לערב הסעודית במחיר של {price}",
    visa_starting_price_schengen: "אשרת שנגן החל מ-{price}",
    visa_starting_price_sri_lanka: "ויזה אלקטרונית לסרי לנקה החל מ-{price}",
    visa_starting_price_thailand: "ויזה לתאילנד החל מ-{price}",
    visa_starting_price_togo: "ויזה אלקטרונית לטוגו החל מ-{price}",
    visa_starting_price_uk: "ויזה אלקטרונית לבריטניה ב-{price}",
    visa_starting_price_usa: "ויזה אלקטרונית לארה״ב ESTA ב-{price}",
    visa_starting_price_vietnam: "ויזה לווייטנאם החל מ-{price}"
  },
  parental_info: "הורים",
  passport: "דרכון",
  passport_biometric_only: "הדרכון חייב להיות ביומטרי.",
  passport_details: "פרטי דרכון",
  passport_expiry: "תאריך תפוגה של דרכון",
  passport_half_year_valid: "הדרכון חייב להיות בתוקף לפחות 6 חודשים.",
  passport_issue_date: "תאריך הוצאת דרכון",
  passport_issue_place: "מקום ההנפקה של דרכון",
  passport_number: "מספר דרכון",
  passport_personal_details: "פרטי דרכון ומידע אישי",
  passport_valid_six_months_min: "חייב להיות בתוקף לפחות 6 חודשים",
  passport_year_valid_two_empty_pages: "הדרכון חייב להיות בתוקף לפחות 6 חודשים עם שני עמודים ריקים.",
  pay: "שלם",
  payment: "תשלום",
  payment_methods: "אמצעי תשלום",
  payment_processor_error_alert: "שגיאה בשיטת תשלום זו. בחרו אמצעי תשלום אחר או נסו שוב.",
  payment_processors: {
    bill: "Bill",
    bill_payment: "תשלום על ידי חשבון",
    bit: "ביט",
    credit_card: "כרטיס אשראי/חיוב",
    credit_card_ru: "כרטיס בנק רוסי",
    paybox: "פייבוקס",
    paypal: "פייפאל",
    stripe: "Stripe",
    tbank: "TBank"
  },
  paypal: "פייפאל",
  personal_id_number: "מספר תעודת זהות",
  phone_number: "טלפון",
  picture: "תמונה",
  pictures: "תמונות",
  popular: "פופולרי",
  previous: "חזרה",
  previous_visa_num: "מספר הויזה הקודם",
  priority: {
    checkbox_1_2_days: "סמנו ✓ כדי לקבל את הויזה שלכם תוך 1-2 ימי עסקים.",
    checkbox_1_2_days_appointment: "סמנו ✓ כדי לקבל תור בתוך 1-2 ימי עסקים.",
    checkbox_3_days: "סמנו ✓ כדי לקבל את הויזה שלכם תוך 3 ימי עסקים.",
    checkbox_3_days_appointment: "סמנו ✓ כדי לקבל תור בתוך 3 ימי עסקים.",
    checkbox_5_15_days: "סמנו ✓ כדי לקבל את הויזה שלכם תוך 5-15 ימי עסקים.",
    checkbox_5_15_days_appointment: "סמנו ✓ כדי לקבל תור בתוך 5-15 ימי עסקים.",
    checkbox_5_days: "סמנו ✓ כדי לקבל את הויזה שלכם תוך 5 ימי עסקים.",
    checkbox_5_days_appointment: "סמנו ✓ כדי לקבל תור בתוך 5 ימי עסקים.",
    checkbox_few_hours: "סמנו ✓ כדי לקבל את הויזה שלכם היום או מחר (בהתאם לשעה).",
    checkbox_few_hours_appointment: "סמנו ✓ כדי לקבל תור בתוך היום או מחר (בהתאם לשעה).",
    checkbox_next_day: "סמנו ✓ כדי לקבל את הויזה שלכם ביום העסקים הבא.",
    checkbox_next_day_appointment: "סמנו ✓ כדי לקבל תור בתוך ביום העסקים הבא.",
    fast_processing: "הזמנה דחופה",
    label_appointment: "זמן לפגישה בשגרירות",
    processing_time: "ויזה מוכנה תוך",
    select_1_2_days: "דחוף: 1-2 ימי עסקים {price}",
    select_3_days: "דחוף: 3 ימי עסקים {price}",
    select_5_15_days: "דחוף: 5-15 ימי עסקים {price}",
    select_5_days: "דחוף: 5 ימי עסקים {price}",
    select_few_hours: "דחוף: מספר שעות {price}",
    select_next_day: "דחוף: יום העסקים הבא {price}",
    select_none: "רגיל: {wait}",
    wait_1_2_days: "1-2 ימי עסקים",
    wait_3_days: "3 ימי עסקים",
    wait_5_15_days: "5-15 ימי עסקים",
    wait_5_days: "5 ימי עסקים",
    wait_few_hours: "היום/מחר",
    wait_next_day: "יום העסקים הבא"
  },
  privacy_autodelete: "אנחנו מתייחסים לפרטיות ואבטחה ברצינות רבה. כל המידע באתר מאובטח בהצפנת SSL ועומד בתקן PCI הבינלאומי לשנת {year}. עם קבלת הויזה האלקטרונית, התמונות שלכם יימחקו משרתי האתר.",
  privacy_page: {
    meta_desc: "עמוד מדיניות הפרטיות ואבטחת המידע של אתר ויזה.נט - הפרטיות של לקוחותינו מאוד חשובה לנו ואנו דואגים לשמור על כל המידע באתרינו בסביבה מאובטחת עם הצפנת SSL",
    title: "מדיניות פרטיות אתר ויזהנט ישראל • Visanet – ויזה.נט"
  },
  privacy_policy: "מדיניות פרטיות",
  privacy_security_importance: "אנחנו שמים דגש על אבטחת המידע והפרטיות שלכם, ומבטיחים שהנתונים שלכם יישארו מוגנים בכל עת.",
  product: {
    entries: {
      "double": "כפולה (2)",
      multiple: "רב פעמי",
      single: "בודדת (1)"
    },
    urgent: "דחוף",
    validity: {
      "15_days": "15 ימים",
      "2_months": "60 ימים",
      "2_weeks": "14 ימים",
      "2_years": "שנתיים",
      "3_months": "90 ימים",
      "3_years": "3 שנים",
      "5_years": "5 שנים",
      "6_months": "180 ימים",
      month: "30 ימים",
      year: "שנה אחת"
    }
  },
  product_variation: {
    alert_title: "שימו לב!",
    label: {
      fee_60_plus: "דמי ביטוח (גיל 60+)",
      fee_by_nationality: "תוספת אזרחות",
      stay_limit_by_nationality: "מגבלת שהייה",
      validity_2_years_by_nationality: "תוקף ויזה (אזרחות)",
      validity_6_months_by_nationality: "תוקף ויזה (אזרחות)"
    },
    note: {
      fee_60_plus: "לנוסעים מעל גיל 60 יש דמי ביטוח רפואי גבוהים יותר: {fee}",
      fee_by_nationality: "הנפקת ויזה לאזרחות שבחרת ({ nationality }) מחייבת תוספת תשלום: {fee}",
      stay_limit_by_nationality: "הזארחות שבחרת זכאית לשהייה של {limit} ימים לכל היותר.",
      validity_2_years_by_nationality: "האזרחות שבחרת זכאית לויזה לשנתיים בלבד.",
      validity_6_months_by_nationality: "הזארחות שבחרת זכאית לוויזה של 6 חודשים בלבד."
    }
  },
  products: {
    label: {
      bahrain_2_weeks: "ויזה אלקטרונית, 14 יום",
      bahrain_3_months: "ויזה אלקטרונית, 3 חודשים",
      bahrain_year: "ויזה אלקטרונית, שנה אחת",
      cambodia_month: "ויזה תיירות, 30 יום",
      canada_5_years: "eTA אישור נסיעה, 5 שנים",
      india_business_year: "ויזת עסקים לשנה",
      india_tourist_5_years: "ויזת תיירות ל-5 שנים",
      india_tourist_month: "ויזת תיירות לחודש",
      india_tourist_year: "ויזת תיירות לשנה",
      indonesia_2_months: "60 יום, כניסה יחידה",
      indonesia_2_years: "שנתיים, רב פעמית",
      indonesia_5_years: "5 שנים, רב פעמית",
      indonesia_year: "שנה אחת, רב פעמית",
      israel_2_years: "אישור נסיעה ETA-IL לשנתיים",
      korea_2_years: "אישור נסיעה K-ETA לשנתיים",
      korea_3_years: "אישור נסיעה K-ETA ל-3 שנים",
      korea_3_years_30_stay: "K-ETA, 3 שנים",
      morocco_tourist_6_months: "ויזת תיירות לחצי שנה",
      new_zealand_2_years: "אישור NZeTA לשנתיים",
      saudi_arabia_6_months: "ויזה אלקטרונית, 6 חודשים",
      saudi_arabia_year: "ויזה אלקטרונית, שנה אחת",
      schengen: "אשרת שנגן, 90 יום",
      sri_lanka_month: "ויזת תיירות לחצי שנה",
      thailand_3_months: "ויזת תיירות, 90 יום, חד פעמית",
      thailand_5_years: "ויזת DTV לחמש שנים, רב פעמית",
      thailand_6_months: "ויזת תיירות, 180 יום, רב פעמית",
      togo_15_days_multi: "15 ימים, רב פעמית",
      togo_15_days_single: "15 ימים, כניסה אחת",
      togo_3_months: "90 יום, רב פעמית",
      togo_month: "30 יום, רב פעמית",
      uk_2_years: "אישור נסיעה UK ETA לשנתיים",
      usa_2_years: "אישור נסיעה ESTA לשנתיים",
      vietnam_3_months_multi: "ויזת תיירות רב פעמית, 90 יום",
      vietnam_3_months_multi_business: "ויזת עסקים רב פעמית, 90 יום",
      vietnam_3_months_single: "ויזת תיירות חד פעמית, 90 יום",
      vietnam_3_months_single_business: "ויזת עסקים חד פעמית, 90 יום"
    },
    "long": {
      bahrain_2_weeks: "ויזה אלקטרונית לבחריין, 14 יום",
      bahrain_3_months: "ויזה אלקטרונית לבחריין, 3 חודשים",
      bahrain_year: "ויזה אלקטרונית לבחריין, שנה",
      cambodia_month: "ויזה אלקטרונית לקמבודיה, 30 יום",
      canada_5_years: "אישור נסיעה eTA לקנדה, 5 שנים",
      india_business_year: "ויזת עסקים להודו, לשנה",
      india_tourist_5_years: "ויזת תייר להודו, ל-5 שנים",
      india_tourist_month: "ויזת תייר להודו, ל-30 יום",
      india_tourist_year: "ויזת תייר להודו, לשנה",
      indonesia_2_months: "ויזת תייר לאינדונזיה, 60 יום, כניסה בודדת",
      indonesia_2_years: "ויזת תייר אלקטרונית לאינדונזיה, שנתיים, רב פעמית",
      indonesia_5_years: "ויזת תייר אלקטרונית לאינדונזיה, 5 שנים, רב פעמית",
      indonesia_year: "ויזת תייר אלקטרונית לאינדונזיה, שנה, רב פעמית",
      israel_2_years: "אישור נסיעה ETA-IL לישראל, שנתיים",
      korea_2_years: "אישור נסיעה K-ETA לדרום קוריאה, שנתיים",
      korea_3_years: "אישור נסיעה K-ETA לדרום קוריאה, 3 שנים",
      korea_3_years_30_stay: "אישור נסיעה K-ETA לדרום קוריאה, 3 שנים",
      morocco_tourist_6_months: "ויזת תייר למרוקו, 180 יום",
      new_zealand_2_years: "אישור נסיעה NZeTA לניו זילנד, שנתיים",
      saudi_arabia_6_months: "ויזה אלקטרונית לערב הסעודית, 6 חודשים",
      saudi_arabia_year: "ויזה אלקטרונית לערב הסעודית, שנה",
      schengen: "אשרת שנגן, 90 יום, רב פעמית",
      sri_lanka_month: "ויזת תייר לסרי לנקה, 30 יום",
      thailand_3_months: "ויזה אלקטרונית לתאילנד, 90 יום, כניסה בודדת",
      thailand_5_years: "ויזת DTV לתאילנד, 5 שנים, רב פעמית",
      thailand_6_months: "ויזה אלקטרונית לתאילנד, 180 יום, רב פעמית",
      togo_15_days_multi: "ויזה אלקטרונית לטוגו, 15 יום, רב פעמית",
      togo_15_days_single: "ויזה אלקטרונית לטוגו, 15 יום, כניסה בודדת",
      togo_3_months: "ויזה אלקטרונית לטוגו, 90 יום, רב פעמית",
      togo_month: "ויזה אלקטרונית לטוגו, 30 יום, רב פעמית",
      uk_2_years: "אישור נסיעה ETA לבריטניה, שנתיים",
      usa_2_years: "אישור נסיעה ESTA לארה\"ב, שנתיים",
      vietnam_3_months_multi: "ויזה אלקטרונית לווייטנאם, 90 יום, רב פעמית",
      vietnam_3_months_multi_business: "ויזת עסקים אלקטרונית לווייטנאם, 90 יום, רב פעמית",
      vietnam_3_months_single: "ויזה אלקטרונית לווייטנאם, 90 יום, כניסה בודדת",
      vietnam_3_months_single_business: "ויזת עסקים אלקטרונית לווייטנאם, 90 יום, כניסה בודדת"
    },
    notes: {
      form_and_appointment_only: "אנו מכינים ומגישים את טופס הבקשה שלכם, וקובעים עבורכם פגישה בקונסוליה."
    }
  },
  professional: "מקצועית",
  quantity: "כמות",
  quantity_select: {
    hint_all: "ויזה אחת לכל נוסע, כולל ילדים (גילאי 0-18).",
    hint_range: "אחד לאדם (גילאי {min} עד {max}).",
    label: "כמות ויזות"
  },
  redirect_payment_on_click: "לאחר שתלצחו על כפתור 'תשלום', תועברו לדף מאובטח להשלמת התשלום.",
  religion: {
    christianity: "נצרות",
    druze: "דרוזים",
    hindu: "הינדואיזם",
    islam: "אסלאם",
    judaism: "יהדות",
    label: "דת",
    other: "אחר/אין"
  },
  religion_other: "אחר/אין",
  remove: "הסר",
  resume_form_with_link: "ניתן להשתמש בקישור הבא מכל מחשב או טלפון, ולהמשיך את הטופס מהנקודה בה עצרתם.",
  resume_saved_form: "חזרה לטופס השמור",
  retired: "גמלאות",
  retry: "נסו שוב",
  review_links: "בואו לקרוא מה הלקוחות אומרים עלינו ב",
  rules: {
    email_invalid: "כתובת דוא\"ל לא תקנית",
    file_not_supported: "סוג קובץ לא נתמך",
    file_size: "הקובץ חייב להיות קטן מ-{max} מגה-בייט",
    latin: "אותיות לטיניות, מקפים וסוגריים בלבד",
    length: "בדיוק {length} תווים",
    numbers: "מספרים בלבד",
    one_min: "יש לבחור לפחות אפשרות אחת",
    required: "שדה חובה",
    six_months_min: "חייב להיות יותר מ-6 חודשים",
    too_early: "התאריך מוקדם מדי",
    too_late: "התאריך מאוחר מדי"
  },
  saarc_countries_are: "מדינות ה-SAARC הן",
  safety_box: {
    official_visa: "ויזה רשמית",
    refund: "החזר מלא במקרה של דחייה",
    secure_payment: "תשלום מאובטח",
    ssl: "הצפנת SSL",
    support: "תמיכה 24/7"
  },
  saudi_arabia: "ערב הסעודית",
  saudi_arabia_evisa: "ויזה אלקטרונית לערב הסעודית",
  saudi_arabia_page: {
    meta_desc: "ויזה אלקטרונית לערב הסעודית - Visanet. הגישו בקשה לויזה אלקטרונית בקלות ובמהירות. קבלו את הויזה שלכם תוך 1-3 ימי עסקים.",
    title: "ויזה אלקטרונית לערב הסעודית • Visanet – ויזה.נט"
  },
  save_form: "שמור טופס",
  schengen: "שנגן",
  schengen_page: {
    meta_desc: "ויזת שנגן - בקשה מקוונת. הגישו בקשה לויזת שנגן בקלות ובמהירות. קבלו את הויזה שלכם תוך 1-3 ימי עסקים.",
    title: "ויזת שנגן • Visanet – ויזה.נט"
  },
  seaport: "נמל ים",
  sector: "תחום",
  sector_hint: "תחום העסק, למשל הייטק או מוזיקה",
  select: "בחר",
  select_education: "בחרו רמת השכלה",
  select_from_my_addresses: "בחרו מהכתובות שלכם",
  select_nationality: "בחרו אזרחות",
  select_occupation: "בחרו עיסוק",
  select_payment_method: "בחרו אמצעי תשלום:",
  select_seniority_years: "בחרו שנות ותק",
  select_visa_type_bahrain: "בחרו סוג ויזה אלקטרונית לבחריין",
  select_visa_type_cambodia: "בחרו סוג ויזה אלקטרונית לקמבודיה",
  select_visa_type_canada: "בחרו סוג ויזה לקנדה",
  select_visa_type_india: "בחרו סוג ויזה אלקטרונית להודו",
  select_visa_type_indonesia: "בחרו סוג ויזה אלקטרונית לאינדונזיה",
  select_visa_type_israel: "בחרו סוג ויזה לישראל",
  select_visa_type_korea: "בחרו סוג ויזה לדרום קוריאה",
  select_visa_type_morocco: "בחרו סוג ויזה אלקטרונית למרוקו",
  select_visa_type_new_zealand: "בחרו סוג ויזה לניו זילנד",
  select_visa_type_saudi_arabia: "בחרו סוג ויזה אלקטרונית לערב הסעודית",
  select_visa_type_schengen: "בחרו סוג ויזה לאזור שנגן",
  select_visa_type_sri_lanka: "בחרו סוג ויזה אלקטרונית לסרי לנקה",
  select_visa_type_thailand: "בחרו סוג ויזה לתאילנד",
  select_visa_type_togo: "בחרו סוג ויזה אלקטרונית לטוגו",
  select_visa_type_uk: "בחרו סוג ויזה לבריטניה",
  select_visa_type_usa: "בחרו סוג ויזה לארה\"ב",
  select_visa_type_vietnam: "בחרו סוג ויזה אלקטרונית לווייטנאם",
  self_employed: "עצמאי",
  send: "שלח",
  send_images_later: "מאוחר יותר",
  send_link: "שלח קישור",
  send_link_to_email: "ניתן לשלוח את הקישור ישירות לדוא\"ל שלכם.",
  send_message: "שלח הודעה",
  sent: "נשלח בהצלחה!",
  sex: "מגדר",
  six_hours: "6 שעות",
  socials: {
    "2gis": "2גיס",
    easy: "איזי",
    facebook: "פייסבוק",
    google: "גוגל",
    instagram: "אינסטגרם",
    irecommend: "אני ממליץ",
    otzovik: "otzovik",
    telegram: "טלגרם",
    trustpilot: "טרוסטפיילוט",
    vk: "VK",
    x: "X",
    yandex: "יאנדקס"
  },
  spouse_country: "ארץ הלידה של בן/בת הזוג",
  spouse_name: "שם בן/בת הזוג",
  sri_lanka: "סרי לנקה",
  sri_lanka_evisa: "ויזה אלקטרונית לסרי לנקה",
  sri_lanka_page: {
    meta_desc: "הנפקת ויזה לסרי לנקה באינטרנט, בתהליך קצר אונליין, בקשת ויזה אלקטרונית לסרילנקה תוך 1-3 ימים - באתר ויזה.נט תוכלו להנפיק וויזה לסרי לנקה לישראלים בלי לבקר בשגרירות",
    title: "ויזה לסרי לנקה: הוצאת ויזה אלקטרונית רשמית לסרילנקה {currentYear} | ויזה.נט"
  },
  stamp: "חותמת",
  status_page: {
    check: "בדיקת סטטוס ויזה",
    clock_img: "שעון חול",
    contact_us: "לשאלות דחופות או קבלת עזרה, אל תהססו ליצור איתנו קשר:",
    email_address: "כתובת הדוא\"ל שלכם",
    find_application_id: "את קוד ההזמנה שלכם תוכלו למצוא במייל האישור ששלחנו לכם. הקפידו להזין את אותה כתובת דוא\"ל שבה השתמשתם במהלך תהליך הגשת הבקשה.",
    find_application_id_title: "ℹ️ איפה קוד ההזמנה שלי?",
    find_here_1: "זמן משוער לאישור",
    find_here_2: "התראות לגבי מסמכים או מידע נוסף שנדרש מכם",
    find_here_3: "מצב ההזמנה שלכם",
    find_here_body: "עמוד זה מספק עדכונים בזמן אמת על התקדמות בקשת הוויזה האלקטרונית שלכם, כולל:",
    find_here_title: "מה תמצאו כאן?",
    instructions_title: "בדקו את מצב הוויזה שלכם",
    intro: "ברוכים הבאים לעמוד סטטוס ויזה - כאן תוכלו לעקוב אחר התקדמות בקשת הוויזה האלקטרונית שלכם דרך ויזה נט.",
    man_lays_on_laptop_img: "גבר נשען על מקלדת מחשב",
    meta_desc: "דף סטטוס הוויזה באתר ויזה נט מאפשר לכם לבדוק את הסטטוס העדכני של בקשת הוויזה האלקטרונית שלכם. כל שעליכם לעשות הוא להזין את קוד ההזמנה שלכם.",
    need_help_body: "אם אינכם מצליחים לבדוק את סטטוס הוויזה שלכם, או אם יש לכם שאלות נוספות, אנא פנו לצוות התמיכה שלנו. אנחנו כאן כדי לעזור לכם בכל שלב של הדרך.",
    need_help_title: "זקוקים לעזרה?",
    "new": "חדש",
    not_found: "לא הצלחנו לאתר את בקשתכם באמצעות הפרטים שהוזנו. אנא הקפידו להזין את אותה כתובת דוא\"ל ששימשה בטופס הבקשה, יחד עם מזהה הבקשה מהודעת האישור ששלחנו.",
    phone: "טלפון:",
    progress_bar_on_card_img: "סרגל התקדמות עם סמלי מטוס ומזוודה בכרטיס כחול",
    success: "עדכון על מצב בקשתכם נשלח לכתובת הדוא\"ל שלכם.",
    title: "בדקו את מצב בקשת הוויזה האלקטרונית שלכם • ויזה נט",
    visa_status: "סטטוס ויזה אלקטרונית",
    why_title: "עקבו אחר מצב הוויזה האלקטרונית שלכם עם ויזה נט"
  },
  stay_days: "{limit} ימים לביקור",
  stay_limit: "מגבלת שהייה",
  street_number: "שורת כתובת",
  student: "סטודנט",
  success_page: {
    now_what: "מה הלאה?",
    pay_success: "התשלום התקבל בהצלחה!",
    step1_body_bahrain: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם תוך 3-5 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_cambodia: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם תוך 3-5 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_canada: "אתם צפויים לקבל eTA ישירות לכתובת הדוא\"ל שלכם תוך 1-2 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_india: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם תוך 1-3 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_indonesia: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם תוך 3-5 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_israel: "אתם צפויים לקבל eTA ישירות לכתובת הדוא\"ל שלכם תוך 1-2 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_korea: "אתם צפויים לקבל KETA ישירות לכתובת הדוא\"ל שלכם תוך 1-3 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_morocco: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם תוך 1-5 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_new_zealand: "אתם צפויים לקבל NZeTA ישירות לכתובת הדוא\"ל שלכם תוך 1-2 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_saudi_arabia: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם תוך 1-3 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_schengen: "אתם צפויים לקבל אשרת שנגן ישירות לכתובת הדוא\"ל שלכם תוך 15 יום לאחר הפגישה בשגרירות. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_sri_lanka: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם תוך 1-2 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_thailand: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם בקרוב. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_togo: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם תוך 3-5 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_uk: "אתם צפויים לקבל ETA לבריטניה ישירות לכתובת הדוא\"ל שלכם תוך 1-3 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_usa: "אתם צפויים לקבל ESTA ישירות לכתובת הדוא\"ל שלכם תוך 1-3 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_body_vietnam: "אתם צפויים לקבל ויזה אלקטרונית ישירות לכתובת הדוא\"ל שלכם תוך 4-5 ימים. בינתיים, שלחנו לכם אישור הזמנה וחשבונית עבור התשלום.",
    step1_header: "הויזה האלקטרונית תישלח לכתובת הדוא\"ל שלכם",
    step2_body: "לכל שאלה, הערה או בקשה, אתם מוזמנים תמיד <a href=\"/contact\">ליצור עמנו קשר</a>.",
    step2_header: "דרכים ליצירת קשר",
    step3_body: "תודה שבחרתם ויזה נט.",
    step3_header: "שתהיה לכם נסיעה טובה!",
    step_insurance_text_bahrain: "ביטוח אינו נדרש כדי להיכנס לבחריין, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_cambodia: "ביטוח אינו נדרש כדי להיכנס לקמבודיה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_canada: "ביטוח לא נדרש להיכנס לקנדה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'> קבל את הפוליסה שלך </a>",
    step_insurance_text_india: "ביטוח אינו נדרש כדי להיכנס להודו, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_indonesia: "ביטוח אינו נדרש כדי להיכנס לאינדונזיה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_israel: "ביטוח אינו נדרש כדי להיכנס לישראל, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_korea: "ביטוח אינו נדרש כדי להיכנס לדרום קוריאה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_morocco: "ביטוח אינו נדרש כדי להיכנס למרוקו, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_new_zealand: "ביטוח אינו נדרש כדי להיכנס לניו זילנד, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_saudi_arabia: "ביטוח אינו נדרש כדי להיכנס לערב הסעודית, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_schengen: "ביטוח אינו נדרש כדי להיכנס לאזור שנגן, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_sri_lanka: "ביטוח אינו נדרש כדי להיכנס לסרי לנקה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_thailand: "ביטוח אינו נדרש כדי להיכנס לתאילנד, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_togo: "ביטוח אינו נדרש כדי להיכנס לטוגו, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_uk: "ביטוח אינו נדרש כדי להיכנס לבריטניה, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_usa: "ביטוח אינו נדרש כדי להיכנס לארה\"ב, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_text_vietnam: "ביטוח אינו נדרש כדי להיכנס לווייטנאם, אך הוא יגן עליך מפני הוצאות רפואיות בלתי צפויות במהלך הטיול שלך. קבל את הפוליסה שלך באינטרנט תוך מספר דקות - <a href=\"{url}\" target='_blank'>קבל את הפוליסה שלך</a>",
    step_insurance_title_bahrain: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_cambodia: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_canada: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_india: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_indonesia: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_israel: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_korea: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_morocco: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_new_zealand: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_saudi_arabia: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_schengen: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_sri_lanka: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_thailand: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_togo: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_uk: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_usa: "🛡️ אנו ממליצים על ביטוח נסיעות",
    step_insurance_title_vietnam: "🛡️ אנו ממליצים על ביטוח נסיעות",
    under_way_bahrain: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה בבחריין.",
    under_way_cambodia: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה בקמבודיה.",
    under_way_canada: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת ה-eTA שלכם דרך רשויות ההגירה בקנדה.",
    under_way_india: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה בהודו.",
    under_way_indonesia: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה באינדונזיה.",
    under_way_israel: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת ה-eTA שלכם דרך רשויות ההגירה בישראל.",
    under_way_korea: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת ה-K-ETA שלכם דרך רשויות ההגירה בדרום קוריאה.",
    under_way_morocco: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה במרוקו.",
    under_way_new_zealand: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה בניו זילנד.",
    under_way_saudi_arabia: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה בערב הסעודית.",
    under_way_schengen: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת אשרת שנגן שלכם דרך שגרירות המדינה שבחרתם.",
    under_way_sri_lanka: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה בסרי לנקה.",
    under_way_thailand: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה בתאילנד.",
    under_way_togo: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה בטוגו.",
    under_way_uk: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת ה-UK-ETA שלכם דרך רשויות ההגירה בבריטניה.",
    under_way_usa: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת ה-ESTA שלכם דרך רשויות ההגירה בארצות הברית.",
    under_way_vietnam: "אנו נטפל מיד בבקשתכם, בהתבסס על הפרטים שמסרתם, ונתחיל בהנפקת הויזה האלקטרונית שלכם דרך רשויות ההגירה בווייטנאם."
  },
  suggest_later_pic: "תמונות נדרשות לעיבוד בקשתכם. אם אתם מעדיפים לשלוח אותם מאוחר יותר,",
  support: "תמיכה",
  surname: "שם משפחה",
  tax_id: "מספר זיהוי מס",
  terms_of_use: "תנאי שימוש",
  terms_page: {
    meta_desc: "תנאי השימוש באתר Visanet.co.il - בעמוד תמצאו מידע אודות החזרים כספיים, משך זמן הנפקת הויזות, חוזה השירות ומידע משפטי נוסף אודות אתר ויזה.נט וחברת eVisanet Ltd",
    title: "תנאי שימוש באתר ויזהנט ישראל • Visanet – ויזה.נט"
  },
  thailand: "תאילנד",
  thailand_page: {
    exempt_alert: "⚠ שימו לב: אזרחים אמריקאים וכן <a data-exempt-list-opener> אזרחים מלאומים אחרים הנכללים ברשימת הפטור </a> יכולים לבקר בתאילנד ללא ויזה למשך שהות של עד 60 יום. ויזה לטווח קצר מומלצת אם ברצונכם להבטיח הליך כניסה מהיר ונוח יותר בשדה התעופה. <br>📅 אם אתם מתכננים לשהות בתאילנד יותר מ-60 יום ברציפות, אנו ממליצים להגיש בקשה לוויזת DTV לטווח ארוך.",
    exempt_modal_title: "הודעת פטור מוויזה אלקטרונית",
    meta_desc: "ויזה לתאילנד זמינה כעת עבור ישראלים - טופס אישור ויזה לתאילנד בעברית. ויזה אלקטרונית רשמית של תאילנד מוכנה תוך 3-21 ימים. ויזת DTV ארוכת טווח לתאילנד ל-5 שנים 🇹🇭",
    title: "ויזה לתאילנד אונליין: הוצאת ויזה DTV לתאילנד לישראלים {currentYear} | ויזה.נט"
  },
  togo: "טוגו",
  togo_page: {
    meta_desc: "הגש בקשה לויזה אלקטרונית רשמית לטוגו בעברית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לטוגו - טופס אונליין קל {currentYear} {'|'} ויזה.נט"
  },
  total_price: "מחיר סופי",
  transfer_payment: "תשלום על ידי חשבון",
  uk: "בריטניה",
  uk_evisa: "ויזה לבריטניה UK-ETA",
  uk_page: {
    meta_desc: "ויזה לאנגליה זמינה כעת לישראלים, טופס אישור נסיעה וכניסה לבריטניה בעברית. ויזה אלקטרונית רשמית לממלכה המאוחדת: לונדון, אנגליה, סקוטלנד, ויילס ואירלנד. מוכן תוך 1-3 ימים",
    title: "ויזה לאנגליה אונליין: הוצאת ויזה לבריטניה לישראלים UK ETA {currentYear} {'|'} ויזה.נט"
  },
  underage: "קטין",
  unemployed: "אבטלה",
  unexpected_payment_error: "אירעה שגיאה בלתי צפויה. אנא נסו שוב או צרו איתנו קשר לקבלת עזרה",
  upload_images_now: "כאן בטופס",
  urgent_visa_fast_service: "ויזה דחופה - עיבוד מהיר",
  usa: "ארה\"ב",
  usa_evisa: "ויזה לארה\"ב ESTA",
  usa_page: {
    meta_desc: "ויזה לארה”ב זמינה כעת לישראלים, טופס אישור נסיעה לארצות הברית בעברית. הוצאת ויזה אלקטרונית רשמית לארה”ב תוך 1-3 ימים, פטור מויזה אמריקאית בלי לבקר בקונסוליה",
    title: "ויזה לארצות הברית אונליין: קבלו אישור ויזה לארה״ב ESTA 2025 {'|'} ויזה.נט"
  },
  use_coupon: "קופון",
  valid_for: "בתוקף למשך",
  validity_range_bahrain: "14+ יום",
  validity_range_cambodia: "30 יום",
  validity_range_canada: "5 שנים",
  validity_range_india: "30+ יום",
  validity_range_indonesia: "60+ יום",
  validity_range_israel: "שנתיים",
  validity_range_korea: "שנתיים",
  validity_range_morocco: "180 יום",
  validity_range_new_zealand: "שנתיים",
  validity_range_saudi_arabia: "365 יום",
  validity_range_schengen: "90 יום",
  validity_range_sri_lanka: "החל מ 30 יום",
  validity_range_thailand: "90+ יום",
  validity_range_togo: "15+ יום",
  validity_range_uk: "שנתיים",
  validity_range_usa: "שנתיים",
  validity_range_vietnam: "90 יום",
  vietnam: "וייטנאם",
  vietnam_evisa: "ויזה אלקטרונית לווייטנאם",
  vietnam_holiday_alert: {
    body: "מחלקת ההגירה בווייטנאם תהיה סגורה בין 30 באפריל ל -5 במאי 2025 לחג לאומי. לא יונפקו ויזות במהלך תקופה זו. אנא תכנן בהתאם. תודה לך!",
    title: "הודעה: סגירת חג"
  },
  vietnam_page: {
    meta_desc: "הנפקת ויזה לויאטנם, היכנסו כעת לויזה.נט והתחילו למלא את טופס ויזה וייטנאם בעברית. קבלת אישור כניסה לוייטנאם דיגיטלית לישראלים, בלי לבקר בשגרירות, במחיר זול ל-90 ימים",
    title: "ויזה לויאטנם אונליין: הוצאת ויזה לוייטנאם באינטרנט לישראלים {currentYear}"
  },
  visa_example_bahrain: "דוגמה לויזה אלקטרונית",
  visa_example_cambodia: "דוגמה לויזה אלקטרונית",
  visa_example_canada: "המחשה של ה-eTA לקנדה",
  visa_example_india: "המחשה של הוויזה להודו",
  visa_example_indonesia: "דוגמה לויזה אלקטרונית",
  visa_example_israel: "דוגמת ETA-IL",
  visa_example_korea: "דוגמת K-ETA",
  visa_example_morocco: "דוגמה לויזה אלקטרונית",
  visa_example_new_zealand: "דוגמת NZeTA",
  visa_example_saudi_arabia: "דוגמה לויזה אלקטרונית",
  visa_example_schengen: "דוגמה לויזת שנגן",
  visa_example_sri_lanka: "דוגמה לויזה אלקטרונית",
  visa_example_thailand: "דוגמה לויזה אלקטרונית",
  visa_example_togo: "דוגמה לויזה אלקטרונית",
  visa_example_uk: "דוגמת ETA לבריטניה",
  visa_example_usa: "דוגמת ESTA",
  visa_example_vietnam: "דוגמה לויזה אלקטרונית",
  visa_form_resume_link: "קישור להמשך מילוי טופס הויזה האלקטרונית",
  visa_ready_within: "ויזה מוכנה תוך:",
  visa_ready_within_priority: "ויזה מוכנה תוך:",
  visa_rejection_or_expel: "כולל דחיית ויזה או גירוש מהמדינה.",
  visa_select: "בחירת ויזה",
  visa_status: "סטטוס הזמנה",
  visa_type_info: "מידע על סוג הויזה",
  visit_details: "פרטי הביקור",
  visited_vietnam_past_10_years: "האם ביקרתם בווייטנאם בעשור האחרון?",
  waiting_business_days: "יום עסקים אחד | {days} ימי עסקים",
  waiting_business_days_nominative: "יום עסקים אחד | {days} ימי עסקים | {days} ימי עסקים",
  waiting_days: {
    bahrain: "3-5 ימים",
    cambodia: "3-5 ימים",
    canada: "1-2 ימים",
    india: "1-3 ימים",
    indonesia: "5 ימים",
    israel: "1-2 ימים",
    korea: "1-3 ימים",
    morocco: "1-5 ימים",
    new_zealand: "1-2 ימים",
    saudi_arabia: "1-3 ימים",
    schengen: "30-60 יום",
    sri_lanka: "1-2 ימים",
    thailand: "3-21 ימים",
    togo: "1-3 ימים",
    uk: "1-3 ימים",
    usa: "1-3 ימים",
    vietnam: "1-7 ימים"
  },
  waiting_days_nominative: "יום אחד | {days} ימים | {days} ימים",
  want_kids_visa: "אנו זקוקים גם לוויזות לילדים",
  we_are_pci_compliant: "התשלומים באתר שלנו מאובטחים באמצעות הצפנת SSL ועומדים באופן מלא בתקני PCI הבינלאומיים של שנת {year}.",
  website: "אתר אינטרנט",
  website_hint: "אתר העסק (לא חובה)",
  what_is_said_about_us: "מה אומרים עלינו?",
  whatsapp: "וואטסאפ",
  whatsapp_alerts_hint: "סמנו ✓ כדי לקבל עדכונים על הוויזה גם לווטסאפ",
  whatsapp_alerts_label: "התראות וואטסאפ",
  whatsapp_images_continue: "אנא שלחו את התמונות שלכם באמצעות WhatsApp למספר <a href=\"{url}\" target=\"_blank\">{phone}</a>.<br>לאחר מכן תוכלו להמשיך.",
  when_was_visit: "מתי היה ביקורכם האחרון?",
  where_passport_issue_place: "ציינו אם הדרכון הונפק בישראל או מחוצה לה. <br>פרטי ההנפקה מופיעים בסעיף 'סמכות קצין דרכונים'.",
  where_stayed_in_india: "היכן שהיתם בהודו?",
  which_countries_you_visited: "באילו מדינות ביקרתם?",
  which_country_date: "כללו פרטים כגון: המדינה, התאריך והנסיבות.",
  year: "שנה",
  yes: "כן"
};
